<template>
	<div class="animated fadeIn">
		<h1 class="title-text text-center">
      {{device_record.name || $t('device.title')}}
    </h1>
    <b-row>
      <b-col xl="12" lg="12" md="12" v-if="!isOpenTime">
        <b-card no-body class="transparent-bg main-body">
          <div class="status-li">
            <b-row class="align-items-start">
              <b-col class="li-icon">
                <b-img src="img/innoknight/calendar.icon.png" fluid alt="InnoKnight"/>
              </b-col>
              <b-col class="li-text">
                <div v-if="(available_open_times.length > 0)">
                  <div>{{$t('device.opening_hours')}}</div>
                  <div v-for="(open_time, index) in available_open_times" :key="open_time.id">
                    <div>{{getOpenTimeWeeklyInfo(open_time.weekly) + '：'}}</div>
                    <div>{{open_time.start_time.substring(0, 5) + '~' + open_time.end_time.substring(0, 5)}}</div>
                  </div>
                  <div v-if='holiday_close'>※{{$t('device.holiday_close')}}</div>
                </div>
              </b-col>
            </b-row> 
          </div>
          <div v-if="!show_mqtt">
            <b-card-body class="text-center action-btn-container">
              <b-button class="col-sm-12" size="lg" variant="info">
                <span class="lg-icon-btn"> <i class="fa fa-ban"></i> {{$t('device.not_open')}}</span>
              </b-button>
            </b-card-body>
            <div v-if="device_record" class="status-li-no-padding-left d-flex justify-content-center">
              <b-row>
                <b-col class="li-text">
                  <div v-if="charging_time_limit_minutes < DefaultChargingTimeLimitMinutes" class="charging-limit-warning">{{$t('device.overChargingTimeLimitMinuteMessage', { value: formatDuration(charging_time_limit_minutes) })}}</div>
                  <div v-if="car_member_device" class="support_text">({{$t('device.car_member_site', { support_car_brand })}})</div>
                  <div v-if="support_plug_and_charge && !support_rfid_charge" class="support_text">({{$t('device.support_plug_and_charge')}})</div>
                  <div v-if="!support_plug_and_charge && support_rfid_charge" class="support_text">({{$t('device.support_rfid_charge')}})</div>
                  <div v-if="support_plug_and_charge && support_rfid_charge" class="support_text">({{$t('device.support_plug_and_charge')}}/{{$t('device.rfid_charge')}})</div>
                </b-col>
              </b-row>
            </div>

            <div v-if="isOpenTime && isDemo =='NO' && buyerubn && buyerubn.length > 0 && buyername && buyername.length > 0" class="d-flex justify-content-center" style="font-size: 1rem; font-weight: bold; color: #ffffff;">
              <b-row style="margin-bottom: 5px;">
                <b-col class="li-text">
                  <p style="margin-bottom: 0px;">{{$t('device.InvoiceNoAutoSwitch')}}:</p>
                  <b-form-checkbox v-model="auto_invoiceno" @change="InvoiceNoAutoSwitch()" style="margin-top: 0px;" size="lg">{{buyerubn}}</b-form-checkbox>
                </b-col>
              </b-row>          
            </div>

            <div v-if="device_record && !device_record.charge_first" style="color:#FFFFFF" class="status-li">
              <b-row class="align-items-start">
                <b-col class="li-icon">
                  <b-img src="img/innoknight/money.icon.png" fluid alt="InnoKnight"/>
                </b-col>
                <b-col class="li-text">
                  <div v-if="(car_member && car_member_device)">{{$t('device.car_member_discount', { car_brand })}}</div>
                  <div v-if="(company_member && company_member_device)">{{$t('device.member_discount', { company_name })}}</div>
                  <label  for="toggle-button3">[{{device_record.billing_method === 'TIME' ? $t('time-base_billing') : $t('energy-base_billing')}}]&nbsp;
                    <i v-show="!isChecked_charge_fee" class="fa fa-caret-up" style="color: #FFFFFF;"></i>
                    <i v-show="isChecked_charge_fee" class="fa fa-caret-down" style="color: #FFFFFF;"></i>
                  </label>
                  <input v-model="isChecked_charge_fee" type="checkbox" id="toggle-button3" style="display: none;">
                  <div class="hidden-div3">
                    <div v-if="device_record.enable_peak_time">
                      <div :style="{color: is_peak_time === 0 ? '#FFFFFF' : '#808080'}">{{$t('device.off_peak_unit_price')}}：</div>
                      <div :style="{color: is_peak_time === 0 ? '#FFFFFF' : '#808080'}">{{$math.round(device_record.price, 2)}}{{device_record.billing_method === 'TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}({{$math.round(device_record.price * 115) / 100}}{{device_record.billing_method === 'TIME' ? $t('price_per_minute') : $t('price_per_kwh')}})</div>
                      <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}">{{$t('device.peak_unit_price')}}：</div>
                      <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}">{{$math.round(device_record.price_peak, 2)}}{{device_record.billing_method === 'TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}({{$math.round(device_record.price_peak * 115) / 100}}{{device_record.billing_method === 'TIME' ? $t('price_per_minute') : $t('price_per_kwh')}})</div>
                      <div v-if="(peak_time_periods.length > 0)">
                        <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}">{{$t('device.peak_time')}}</div>
                        <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}" v-for="(peak_time, index) in peak_time_periods" :key="peak_time.start_time">
                          {{peak_time.start_time + '~' + peak_time.end_time}}
                        </div>
                      </div>
                      <div v-else>
                        <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}">{{$t('device.peak_time_none')}}</div>
                      </div>
                    </div>
                    <div v-if="!device_record.enable_peak_time">
                      <div>{{$math.round(device_record.price, 2)}}{{device_record.billing_method === 'TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}({{$math.round(device_record.price * 115) / 100}}{{device_record.billing_method === 'TIME' ? $t('price_per_minute') : $t('price_per_kwh')}})</div>
                    </div>
                    <div v-if="device_record && !device_record.idle_fee"><p><small> (1 {{$t('point')}} = 1.15 {{$t('price_unit')}}) </small></p></div>
                    <div v-if="device_record && device_record.idle_fee && !(device_record.price_idle > 0)"><p><small> (1 {{$t('point')}} = 1.15 {{$t('price_unit')}}) </small></p></div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div v-if="device_record && !device_record.charge_first" style="color:#FFFFFF" class="status-li">
              <b-row v-if="device_record && device_record.idle_fee && device_record.price_idle > 0" class="align-items-start">
                <b-col class="li-icon">
                  <b-img src="img/innoknight/money.icon.png" fluid alt="InnoKnight"/>
                </b-col>
                <b-col class="li-text">
                  <label for="toggle-button4">[{{$t('device.idle_charge')}}]&nbsp;
                    <i v-show="!isChecked_idle_fee" class="fa fa-caret-up" style="color: #FFFFFF;"></i>
                    <i v-show="isChecked_idle_fee" class="fa fa-caret-down" style="color: #FFFFFF;"></i>
                  </label>
                  <input v-model="isChecked_idle_fee" type="checkbox" id="toggle-button4" style="display: none;">
                  <div class="hidden-div4">
                    <div>{{$math.round(device_record.price_idle, 2)}}{{$t('points')}}/{{idle_interval_rate}}{{$t('minute')}}({{$math.round(device_record.price_idle * 115) / 100}}{{$t('price_unit')}}/{{idle_interval_rate}}{{$t('minute')}})</div>
                    <div v-if="idle_max_price > 0">{{$t('device.idle_max_price', { idle_max_price })}}({{$math.round(idle_max_price * 115) / 100}}{{$t('price_unit')}})</div>
                    <div>({{$t('device.idle_free_info', { idle_free_period })}})</div>
                    <div><p><small> (1 {{$t('point')}} = 1.15 {{$t('price_unit')}}) </small></p></div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </b-col>

			<b-col xl="12" lg="12" md="12" v-if="show_device_occupied && isOpenTime">
          <b-card no-body>
            <div slot="header">
              <i class="fa fa-exclamation-triangle"></i> {{$t('device.device_using')}}
            </div>
            <b-card-body>
              <h1 class="text-warning w-100 text-center">
                {{$t('device.device_using_message')}} <i class="fa fa-qrcode"></i>
              </h1>
            </b-card-body>
          </b-card >
      </b-col>

			<b-col xl="12" lg="12" md="12" v-if="show_init_spinning && isOpenTime">
        <b-card no-body>
          <div slot="header">
            <i class="fa fa-anchor"></i> {{$t('device.system_init')}} <i class="fa fa-qrcode"></i>
          </div>
          <b-card-body class="text-center" v-if="show_scan_qrcode_msg">
            <div v-if="last_charging_stations.length" class="w-100"><b-button class="mx-auto attention-effect" variant="success" @click="openLastChargingStations()">{{$t('device.returnLastChargingStations')}}</b-button></div>
            <div v-if="last_charging_stations.length" class="w-100">{{$t('device.or')}}</div>
          	<div class="w-100"><b-button class="mx-auto attention-effect" variant="info" @click="openQrCodeScanner()">{{$t('device.openQrCodeScanner')}}</b-button></div>
            <i class="fa fa-qrcode" style="font-size:15rem; padding:0px;margin:0px;"></i>
            
          </b-card-body>
          <b-card-body v-else>
            <div class="sk-wave">
              <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
            </div>
            <p v-if="count_down" class="text-muted w-100 text-center">{{$t('device.system_countdown')}}：{{count_down}}</p>
          </b-card-body>
        </b-card >
		  </b-col>

      <b-col xl="12" lg="12" md="12" v-if="show_device_disconnected && isOpenTime">
        <b-card no-body>
          <div slot="header">
            <i class="fa fa-anchor"></i> {{$t('device.device_offline')}} <i class="fa fa-frown-o"></i>
          </div>
          <b-card-body class="text-center">
            <h3> {{$t('device.device_offline_message')}}</h3>
            <h6 class="text-center"><a href="https://lin.ee/B0X4IJ8"><img height="54" width="54" src="https://www.line.me/static/img/icon-line_1.png"></a></h6>
          </b-card-body>
        </b-card >
      </b-col>
            
      <b-col xl="12" lg="12" md="12" v-if="show_mqtt">
        <b-card no-body class="transparent-bg main-body">
          <!-- <b-img v-if="!mqtt_value.value3" src="img/innoknight/battery.empty.png" fluid alt="InnoKnight"/> -->
          <!-- <b-img v-if="mqtt_value.value3" src="img/innoknight/battery.charging.png" fluid alt="InnoKnight"/> -->
          <div class="battery-wrapper" v-if="isOpenTime && !mqtt_value.value3">
            <!--<i class="fa fa-battery-empty battery-icon"></i>-->
            <div class="battery-shape" aria-hidden="true"></div>
            <span v-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_PREPARING" class="battery-text">{{$t('device.charger_ready')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_SUSPENDED_EVSE" class="battery-text">{{$t('device.suspended_evse')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_SUSPENDED_EV" class="battery-text">{{$t('device.suspended_ev')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_FINISHING" class="battery-text">{{$t('device.idling')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_UNAVAILABLE" class="battery-text">{{$t('device.charger_unavailable')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_FAULTED" class="battery-text">{{$t('device.charger_faulted')}}</span>
            <span v-else-if="mqtt_value.value3&&mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_AVAILABLE" class="battery-text">{{$t('device.wait_preparing')}}</span>
            <span v-else-if="mqtt_value.value3&&mqtt_value.value1==0" class="battery-text">{{$t('device.load_detect')}}</span>
            <span v-else-if="mqtt_value.value3" class="battery-text">{{$t('device.charging')}}</span>
            <span v-else-if="!mqtt_value.value3" class="battery-text">{{$t('device.charger_ready')}}</span>
          </div>
          <div class="battery-wrapper" v-if="isOpenTime && mqtt_value.value3">
            <!--<i class="fa fa-battery-empty battery-icon-charging"></i>-->
            <div class="battery-shape-charging" aria-hidden="true"></div>
            <span v-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_PREPARING" class="battery-text">{{$t('device.charger_ready')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_SUSPENDED_EVSE" class="battery-text">{{$t('device.suspended_evse')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_SUSPENDED_EV" class="battery-text">{{$t('device.suspended_ev')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_FINISHING" class="battery-text">{{$t('device.idling')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_UNAVAILABLE" class="battery-text">{{$t('device.charger_unavailable')}}</span>
            <span v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_FAULTED" class="battery-text">{{$t('device.charger_faulted')}}</span>
            <span v-else-if="mqtt_value.value3&&mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_AVAILABLE" class="battery-text">{{$t('device.wait_preparing')}}</span>
            <span v-else-if="mqtt_value.value3&&mqtt_value.value1==0" class="battery-text">{{$t('device.load_detect')}}</span>
            <span v-else-if="mqtt_value.value3" class="battery-text">{{$t('device.charging')}}{{mqtt_value.soc > 0 ? `(${Number(mqtt_value.soc)}%)` : ''}}</span>
            <span v-else-if="!mqtt_value.value3" class="battery-text">{{$t('device.charger_ready')}}</span>
          </div>
          <!--<i class="fa fa-battery-empty battery-icon" v-if="isOpenTime && !mqtt_value.value3"></i>
          <i class="fa fa fa-battery-empty battery-icon-charging" v-if="isOpenTime && mqtt_value.value3"></i>-->

          <b-card-body class="text-center action-btn-container">
            <b-button v-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_FINISHING" class="col-sm-12" size="lg" variant="warning" :disabled="disable_btns">
              <span class="lg-icon-btn"> <i class="fa fa-plug"></i> {{$t('device.unplug_charging_connector')}}</span>
            </b-button>
            <b-button v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_FAULTED" class="col-sm-12" size="lg" variant="danger" :disabled="disable_btns">
              <span class="lg-icon-btn"> <i class="fa fa-exclamation-circle"></i> {{$t('device.charger_faulted')}}</span>
            </b-button>
            <b-button v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_SUSPENDED_EVSE" class="col-sm-12" size="lg" variant="danger" @click="toggleValue3(0)" :disabled="disable_btns">
              <span class="lg-icon-btn"> <i class="fa fa-stop-circle"></i> {{$t('device.stop_charging')}}</span>
            </b-button>
            <b-button v-else-if="mqtt_value.status&&mqtt_value.status==CHARGER_STATUS.CHARGER_STATUS_SUSPENDED_EV" class="col-sm-12" size="lg" variant="danger" @click="toggleValue3(0)" :disabled="disable_btns">
              <span class="lg-icon-btn"> <i class="fa fa-stop-circle"></i> {{$t('device.stop_charging')}}</span>
            </b-button>
            <b-button v-else-if="mqtt_value.value3" class="col-sm-12" size="lg" variant="danger" @click="toggleValue3(0)" :disabled="disable_btns">
              <span class="lg-icon-btn"> <i class="fa fa-stop-circle"></i> {{$t('device.stop_charging')}}</span>
            </b-button>
            <b-button v-else-if="!isOpenTime" class="col-sm-12" size="lg" variant="info">
              <span class="lg-icon-btn"> <i class="fa fa-ban"></i> {{$t('device.not_open')}}</span>
            </b-button>
            <b-button v-else class="col-sm-12 mx-auto attention-effect" size="lg" variant="success" @click="toggleValue3(1)" :disabled="disable_btns" :style="'background-color:none;'">
              <span class="lg-icon-btn"> <i class="fa fa-bolt"></i> {{$t('device.start_charging')}}</span>
            </b-button>
          </b-card-body>

          <div v-if="device_record" class="status-li-no-padding-left d-flex justify-content-center">
            <b-row>
              <b-col class="li-text">
                <div v-if="charging_time_limit_minutes < DefaultChargingTimeLimitMinutes" class="charging-limit-warning">{{$t('device.overChargingTimeLimitMinuteMessage', { value: formatDuration(charging_time_limit_minutes) })}}</div>
                <div v-if="car_member_device" class="support_text">({{$t('device.car_member_site', { support_car_brand })}})</div>
                <div v-if="support_plug_and_charge && !support_rfid_charge" class="support_text">({{$t('device.support_plug_and_charge')}})</div>
                <div v-if="!support_plug_and_charge && support_rfid_charge" class="support_text">({{$t('device.support_rfid_charge')}})</div>
                <div v-if="support_plug_and_charge && support_rfid_charge" class="support_text">({{$t('device.support_plug_and_charge')}}/{{$t('device.rfid_charge')}})</div>
              </b-col>
            </b-row>
          </div>

          <div v-if="isOpenTime && isDemo =='NO' && buyerubn && buyerubn.length > 0 && buyername && buyername.length > 0" class="d-flex justify-content-center" style="font-size: 1rem; font-weight: bold; color: #ffffff;">
            <b-row style="margin-bottom: 5px;">
              <b-col class="li-text">
                <p style="margin-bottom: 0px;">{{$t('device.InvoiceNoAutoSwitch')}}:</p>
                <b-form-checkbox v-model="auto_invoiceno" @change="InvoiceNoAutoSwitch()" style="margin-top: 0px;" size="lg">{{buyerubn}}</b-form-checkbox>
              </b-col>
            </b-row>          
          </div>

          <div v-if="device_record && !device_record.charge_first" style="color:#FFFFFF" class="status-li">
            <b-row class="align-items-start">
              <b-col class="li-icon">
                <b-img src="img/innoknight/money.icon.png" fluid alt="InnoKnight"/>
              </b-col>
              <b-col class="li-text">
                <div v-if="(car_member && car_member_device)">{{$t('device.car_member_discount', { car_brand })}}</div>
                <div v-if="(company_member && company_member_device)">{{$t('device.member_discount', { company_name })}}</div>
                <label  for="toggle-button3">[{{device_record.billing_method === 'TIME' ? $t('time-base_billing') : $t('energy-base_billing')}}]&nbsp;
                  <i v-show="!isChecked_charge_fee" class="fa fa-caret-up" style="color: #FFFFFF;"></i>
                  <i v-show="isChecked_charge_fee" class="fa fa-caret-down" style="color: #FFFFFF;"></i>
                </label>
                <input v-model="isChecked_charge_fee" type="checkbox" id="toggle-button3" style="display: none;">
                <div class="hidden-div3">
                  <div v-if="device_record.enable_peak_time">
                    <div :style="{color: is_peak_time === 0 ? '#FFFFFF' : '#808080'}">{{$t('device.off_peak_unit_price')}}：</div>
                    <div :style="{color: is_peak_time === 0 ? '#FFFFFF' : '#808080'}">{{$math.round(device_record.price, 2)}}{{device_record.billing_method === 'TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}({{$math.round(device_record.price * 115) / 100}}{{device_record.billing_method === 'TIME' ? $t('price_per_minute') : $t('price_per_kwh')}})</div>
                    <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}">{{$t('device.peak_unit_price')}}：</div>
                    <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}">{{$math.round(device_record.price_peak, 2)}}{{device_record.billing_method === 'TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}({{$math.round(device_record.price_peak * 115) / 100}}{{device_record.billing_method === 'TIME' ? $t('price_per_minute') : $t('price_per_kwh')}})</div>
                    <div v-if="(peak_time_periods.length > 0)">
                      <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}">{{$t('device.peak_time')}}</div>
                      <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}" v-for="(peak_time, index) in peak_time_periods" :key="peak_time.start_time">
                        {{peak_time.start_time + '~' + peak_time.end_time}}
                      </div>
                    </div>
                    <div v-else>
                      <div :style="{color: is_peak_time === 1 ? '#FFFFFF' : '#808080'}">{{$t('device.peak_time_none')}}</div>
                    </div>
                  </div>
                  <div v-if="!device_record.enable_peak_time">
                    <div>{{$math.round(device_record.price, 2)}}{{device_record.billing_method === 'TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}({{$math.round(device_record.price * 115) / 100}}{{device_record.billing_method === 'TIME' ? $t('price_per_minute') : $t('price_per_kwh')}})</div>
                  </div>
                  <div v-if="device_record && !device_record.idle_fee"><p><small> (1 {{$t('point')}} = 1.15 {{$t('price_unit')}}) </small></p></div>
                  <div v-if="device_record && device_record.idle_fee && !(device_record.price_idle > 0)"><p><small> (1 {{$t('point')}} = 1.15 {{$t('price_unit')}}) </small></p></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="device_record && !device_record.charge_first" style="color:#FFFFFF" class="status-li">
            <b-row v-if="device_record && device_record.idle_fee && device_record.price_idle > 0" class="align-items-start">
              <b-col class="li-icon">
                <b-img src="img/innoknight/money.icon.png" fluid alt="InnoKnight"/>
              </b-col>
              <b-col class="li-text">
                <label for="toggle-button4">[{{$t('device.idle_charge')}}]&nbsp;
                  <i v-show="!isChecked_idle_fee" class="fa fa-caret-up" style="color: #FFFFFF;"></i>
                  <i v-show="isChecked_idle_fee" class="fa fa-caret-down" style="color: #FFFFFF;"></i>
                </label>
                <input v-model="isChecked_idle_fee" type="checkbox" id="toggle-button4" style="display: none;">
                <div class="hidden-div4">
                  <div>{{$math.round(device_record.price_idle, 2)}}{{$t('points')}}/{{idle_interval_rate}}{{$t('minute')}}({{$math.round(device_record.price_idle * 115) / 100}}{{$t('price_unit')}}/{{idle_interval_rate}}{{$t('minute')}})</div>
                  <div v-if="idle_max_price > 0">{{$t('device.idle_max_price', { idle_max_price })}}({{$math.round(idle_max_price * 115) / 100}}{{$t('price_unit')}})</div>
                  <div>({{$t('device.idle_free_info', { idle_free_period })}})</div>
                  <div><p><small> (1 {{$t('point')}} = 1.15 {{$t('price_unit')}}) </small></p></div>
                </div>
              </b-col>
            </b-row>
          </div>

          <div v-if="device_record && device_record.charge_first" class="status-li">
            <b-row class="align-items-start">
              <b-col class="li-icon">
                <b-img src="img/innoknight/money.icon.png" fluid alt="InnoKnight"/>
              </b-col>
              <b-col class="li-text">
                {{$t('device.single_charge') + '：$' + device_record.charge_value + $t('per_use')}}
                ({{ $math.round(device_record.charge_value/1.15, 2) + $t('points_per_use')}})
              </b-col>
            </b-row>
          </div>

          <div v-if="mqtt_value.value3" class="status-li hidden">
            <b-row class="align-items-start">
              <b-col class="li-icon">
                <b-img src="img/innoknight/status.icon.png" fluid alt="InnoKnight"/>
              </b-col>
              <b-col class="li-text">
                <div class="hidden">{{$t('device.kwh_used')}}：{{mqtt_value.value1|kwh}}</div>
                <div class="hidden">{{$t('device.total_kwh_used')}}：{{mqtt_value.value2|kwh}}</div>
              </b-col>
            </b-row>
          </div>

          <div v-if="current_used_watts !== null" class="status-li">
            <b-row class="align-items-start">
              <b-col class="li-icon">
                <b-img src="img/innoknight/status.icon.png" fluid alt="InnoKnight"/>
              </b-col>
              <b-col class="li-text">
                <div>{{$t('device.current_watts')}}：{{(mqtt_value.value3 ? mqtt_value.value1 : 0)|__kW}}</div>
                <div>{{$t('device.charging_time')}}：{{current_charging_time|timeStr}}</div>
                <div v-if="device_record && device_record.idle_fee && current_used_time_idle > 0">{{$t('device.idle_used_time')}}：{{current_used_time_idle}}{{$t('minute')}}</div>
                <div v-if="device_record.billing_method === 'TIME'">
                  <label for="toggle-button">{{$t('used_time')}}：{{total_used_time}}{{$t('minute')}}&nbsp;
                    <i v-show="!isChecked_used" v-if="total_used_time > 0 && device_record && device_record.enable_peak_time" class="fa fa-caret-down" style="color: #C0C0C0;"></i>
                    <i v-show="isChecked_used" v-if="total_used_time > 0 && device_record && device_record.enable_peak_time" class="fa fa-caret-up" style="color: #C0C0C0;"></i>
                  </label>
                  <input v-model="isChecked_used" type="checkbox" id="toggle-button" style="display: none;">
                  <div v-if="device_record && device_record.enable_peak_time" class="hidden-div">
                    <div>{{$t('off_peak')}}：{{current_used_time}}{{$t('minute')}}</div>
                    <div>{{$t('peak')}}：{{current_used_time_peak}}{{$t('minute')}}</div>
                  </div>
                </div>
                <div v-else>
                  <label for="toggle-button">{{$t('device.used_kwh')}}：{{$math.round(total_used_watts,2)|kwh}}&nbsp;
                    <i v-show="!isChecked_used" v-if="total_used_watts > 0 && device_record && device_record.enable_peak_time" class="fa fa-caret-down" style="color: #C0C0C0;"></i>
                    <i v-show="isChecked_used" v-if="total_used_watts > 0 && device_record && device_record.enable_peak_time" class="fa fa-caret-up" style="color: #C0C0C0;"></i>
                  </label>
                  <input v-model="isChecked_used" type="checkbox" id="toggle-button" style="display: none;">
                  <div v-if="device_record && device_record.enable_peak_time" class="hidden-div">
                    <div v-if="current_used_watts > 0">{{$t('off_peak')}}：{{current_used_watts|kwh}}</div>
                    <div v-if="current_used_watts_peak > 0">{{$t('peak')}}：{{current_used_watts_peak|kwh}}</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <div v-if="total_price !== null" class="status-li">
            <b-row class="align-items-start">
              <b-col class="li-icon">
                <b-img src="img/innoknight/money.icon.png" fluid alt="InnoKnight"/>
              </b-col>
              <b-col class="li-text">
                <div>
                  <label for="toggle-button2">{{$t('device.points_used')}}：{{ $math.round(total_price, 2) }}{{$t('s_points')}}&nbsp;
                    <i v-show="!isChecked_pay" v-if="total_price > 0 && device_record && (device_record.enable_peak_time || (device_record.idle_fee && total_pay_idle > 0))" class="fa fa-caret-down" style="color: #C0C0C0;"></i>
                    <i v-show="isChecked_pay" v-if="total_price > 0 && device_record && (device_record.enable_peak_time || (device_record.idle_fee && total_pay_idle > 0))" class="fa fa-caret-up" style="color: #C0C0C0;"></i>
                  </label>
                  <input v-model="isChecked_pay" type="checkbox" id="toggle-button2" style="display: none;">
                  <div v-if="device_record && device_record.enable_peak_time" class="hidden-div2">
                    <div v-if="total_pay > 0">{{$t('off_peak')}}：{{ $math.round(total_pay, 2) }}{{$t('s_points')}}</div>
                    <div v-if="total_pay_peak > 0">{{$t('peak')}}：{{ $math.round(total_pay_peak, 2) }}{{$t('s_points')}}</div>
                    <div v-if="device_record.idle_fee && total_pay_idle > 0">{{$t('idle')}}：{{ $math.round(total_pay_idle, 2) }}{{$t('s_points')}}</div>
                  </div>
                  <div v-else-if="device_record && device_record.idle_fee" class="hidden-div2">
                    <div v-if="total_pay > 0">{{$t('used')}}：{{ $math.round(total_pay, 2) }}{{$t('s_points')}}</div>
                    <div v-if="total_pay_idle > 0">{{$t('idle')}}：{{ $math.round(total_pay_idle, 2) }}{{$t('s_points')}}</div>
                  </div>
                </div>
                <div v-if="reward > 0 && total_price > 0">{{$t('points_reward')}}：{{ $math.round(total_price * reward, 2) }}{{$t('s_points')}}</div>
              </b-col>
            </b-row>
          </div>

          <div v-if="record" class="status-li hidden">
            <b-row class="align-items-start">
              <b-col class="li-icon">
                <b-img src="img/innoknight/status.icon.png" fluid alt="InnoKnight"/>
              </b-col>
              <b-col class="li-text">
                <div>{{$t('device.last_kwh_used')}}：{{record.used_watts|kwh}}</div>
                <div>{{$t('device.last_time_used')}}：{{record.interval}}{{$t('hour')}}</div>
              </b-col>
            </b-row>
          </div>

          <div v-if="record" class="status-li hidden">
            <b-row class="align-items-start">
              <b-col class="li-icon">
                <b-img src="img/innoknight/money.icon.png" fluid alt="InnoKnight"/>
              </b-col>
              <b-col class="li-text">
                <div>{{$t('device.last_price')}}：{{ $math.round((record.used_watts)*(device_record.price ? device_record.price : price), 2) }}{{$t('s_points')}} ({{record.used_watts|kwh}})</div>
              </b-col>
            </b-row>
          </div>

          <div v-if="mqtt_value.value3" class="text-left text-light hidden">
            <div>{{$t('device.kwh_used')}}：{{mqtt_value.value1|kwh}}</div>
            <div class="hidden">{{$t('device.total_kwh_used')}}：{{mqtt_value.value2|kwh}}</div>
          </div>

          <div v-if="record" class="text-center hidden">
            <li>{{$t('device.last_kwh_used')}}：{{record.used_watts|kwh}}</li>
            <li>{{$t('device.last_time_used')}}：{{record.interval}}{{$t('hour')}}</li>
          </div>
        </b-card >
      </b-col>

      <b-col xl="12" lg="12" md="12" v-if="show_account_balace">
        <b-card no-body>
          <!--<div slot="header">
            
            <i class="fa fa-user-o"></i> {{$t('device.account')}}
            <b-button v-if="isDemo =='NO'&&0" style="margin: 0 5px;" class="pull-right" size="sm" variant="success" @click="popGrouponModal()"><i class="fa fa-ticket"></i> {{$t('device.coupon')}}</b-button>&nbsp;
            <b-button v-if="isDemo =='NO'" style="margin: 0 3px;" class="pull-right" size="sm" variant="primary" @click="popTopUpModal()"><i class="fa fa-plus"></i> {{$t('device.top_up')}}</b-button>&nbsp;
            <b-button v-if="isDemo =='NO'" style="margin: 0 3px; color: white;" class="pull-right" size="sm" variant="success" @click="popshowCreditCardORLINEPayModal()"><i class="fa fa-credit-card"></i> {{$t('device.creditcard_linepay_bind')}}</b-button>&nbsp;

          </div>-->
          <div slot="header" class="d-flex flex-wrap justify-content-between align-items-center">
            <span><i class="fa fa-user-o"></i> {{$t('device.account')}}</span>

            <div class="d-flex flex-wrap">
              <b-button
                v-if="isDemo =='NO&&0'"
                class="mx-1 my-1"
                size="sm"
                variant="primary"
                @click="popGrouponModal()"
              >
                <i class="fa fa-ticket"></i> {{$t('device.coupon')}}
              </b-button>

              <b-button
                v-if="isDemo =='NO'"
                class="mx-1 my-1 text-white"
                size="sm"
                variant="success"
                @click="popshowCreditCardORLINEPayModal()"
              >
                <i class="fa fa-credit-card"></i> {{$t('device.creditcard_linepay_bind')}}
              </b-button>

              <b-button
                v-if="isDemo =='NO'"
                class="mx-1 my-1"
                size="sm"
                variant="primary"
                @click="popTopUpModal()"
              >
                <i class="fa fa-plus"></i> {{$t('device.top_up')}}
              </b-button>
            </div>
          </div>
          
          <b-card-body>
            <div v-if="available_car_members && available_car_members.length > 0" style="color: #c07711">
              <table border="0" cellpadding="3">
                <tr>
                  <td style="vertical-align: top;"><span><i class="fa fa-star"></i></span></td>
                  <td>{{$t('device.car_members')}}：<br><span v-html="getCarMembers()"></span></td>
                </tr>
              </table>
            </div>
            <div v-if="available_members && available_members.length > 0" style="color: #c07711">
              <table border="0" cellpadding="3">
                <tr>
                  <td style="vertical-align: top;"><span><i class="fa fa-star"></i></span></td>
                  <td>{{$t('device.members')}}：<br><span v-html="getMembers()"></span></td>
                </tr>
              </table>
            </div>
            <span class="fixed-leading"><i class="fa fa-usd"></i></span>{{$t('device.account_balance')}}：{{balance|round}}{{$t('s_points')}}<br>
            <span class="fixed-leading"><i class="fa fa-diamond"></i></span>{{$t('device.reward_points')}}：{{bonus|roundAbs}}{{$t('s_points')}}<br>
            <div v-if="available_line && available_line.length">  
              <!--<span class="fixed-leading"><i class="fa fa-credit-card"></i></span> {{$t('device.linepay_binded')}}
              <b-button style="margin: 0 5px;"
                              class="pull-right"
                              size="sm"
                              variant="danger"
                              @click="setLinePay(available_line[0].id, 'delete')">
                                <i class="fa fa-times"></i> {{$t('delete')}}
              </b-button>-->
              
              <table border="0" cellpadding="3">
                <tr>
                  <th colspan="6" align="center">
                    <i class="fa fa-credit-card"></i> {{$t('device.linepay_binded')}}
                  </th>
                </tr>
                <tr>
                  <td>
                    <span class="text-primary"><i class="fa fa-check"></i></span>
                  </td>
                  <td style="width: 100%; text-align: left;">LINE Pay</td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <b-button
                        class="mx-1 my-1 text-white"
                        size="sm"
                        variant="danger"
                        @click="setLinePay(available_line[0].id, 'delete')"
                      >
                        <i class="fa fa-times"></i> {{$t('delete')}}
                      </b-button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>

            <div v-if="available_cards && available_cards.length && !available_line.length">
              <table border="0" cellpadding="3">
                <tr>
                  <th colspan="6" align="center">
                    <i class="fa fa-credit-card"></i> {{$t('device.creditcard_binded')}}
                  </th>
                </tr>
                <!--<tr>
                  <th>{{$t('device.creditcard_number')}}</th>
                  <th>{{$t('device.creditcard_dates')}}</th>
                  <th class="text-center">{{$t('device.creditcard_op')}}</th>
                </tr>-->
                <tr v-for="(card, index) in available_cards" :key="card.id">
                  <td colspan="2" style="width: 100%;">
                    <span v-if="card.is_main" class="text-primary"><i class="fa fa-check"></i></span>
                    <span v-else class="text-danger"><i class="fa fa-minus"></i></span>
                    {{`...-${card.last4}`}}&nbsp;&nbsp;
                    {{card.validate.toString().substr(2) + '/' + card.validate.toString().substr(0,2)}}
                  </td>
                  <td>
                    <!--<b-button style="margin: 0 5px;"
                              class="pull-right"
                              size="sm"
                              variant="primary"
                              v-if="!card.is_main"
                              @click="setCreditCard(card.id, card.last4, 'primary')">
                                <i class="fa fa-check"></i> {{$t('device.creditcard_payment_set')}}
                    </b-button>
                    <b-button style="margin: 0 5px;"
                              class="pull-right"
                              size="sm"
                              variant="danger"
                              @click="setCreditCard(card.id, card.last4, 'delete')">
                                <i class="fa fa-times"></i> {{$t('delete')}}
                    </b-button>-->
                    <div class="d-flex justify-content-end">
                      <b-button
                        v-if="!card.is_main"
                        class="mx-1 my-1 text-white"
                        size="sm"
                        variant="primary"
                        @click="setCreditCard(card.id, card.last4, 'primary')"
                      >
                        <i class="fa fa-check"></i> {{$t('device.creditcard_payment_set')}}
                      </b-button>

                      <b-button
                        class="mx-1 my-1"
                        size="sm"
                        variant="danger"
                        @click="setCreditCard(card.id, card.last4, 'delete')"
                      >
                        <i class="fa fa-times"></i> {{$t('delete')}}
                      </b-button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </b-card-body>
        </b-card >
      </b-col>

      <b-col v-if="isDemo =='NO'" xl="12" lg="12" md="12">
        <b-card no-body>
          <div slot="header" class="d-flex flex-wrap justify-content-between align-items-center">
            <span><i class="fa fa-barcode"></i> {{$t('device.invoice_carrier')}}</span>
            <div class="d-flex flex-wrap">
              <b-button
                class="mx-1 my-1"
                size="sm"
                variant="success"
                @click="popInvoiceCarrierModal()"
              >
                <i class="fa fa-barcode"></i> {{invoice_carrier ? $t('modify') : $t('add')}}
              </b-button>
            </div>
          </div>
          <b-card-body>
            <div>
              <table  border="0" cellpadding="3">
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.invoice_carrier_remark1')}}</td>
                </tr>
              </table>
              <table  border="0" cellpadding="3">
                <tr v-if="invoice_carrier && invoice_carrier.length > 0">
                  <td><span class="text-primary"><i class="fa fa-check"></i></span></td>
                  <td style="width: 100%; text-align: left;">{{$t('device.invoice_carrier_phone_barcode')}}：{{invoice_carrier}}</td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <b-button
                        class="mx-1 my-1 text-white"
                        size="sm"
                        variant="danger"
                        @click="InvoiceCarrierRemove()"
                      >
                        <i class="fa fa-times"></i> {{$t('delete')}}
                      </b-button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </b-card-body>
        </b-card >
      </b-col>

      <b-col v-if="isDemo =='NO'" xl="12" lg="12" md="12">
        <b-card no-body>
          <!--<div slot="header">
            <i class="fa fa-balance-scale"></i> {{$t('device.invoice_no')}}&nbsp;
            <b-button style="margin: 0 3px; color: white;" class="pull-right" size="sm" variant="success" @click="popInvoiceNoModal()"><i class="fa fa-balance-scale"></i> {{$t('device.popInvoiceNoModal')}}</b-button>&nbsp;
          </div>-->
          <div slot="header" class="d-flex flex-wrap justify-content-between align-items-center">
            <span><i class="fa fa-balance-scale"></i> {{$t('device.invoice_no')}}</span>
            <div class="d-flex flex-wrap">
              <b-button
                class="mx-1 my-1"
                size="sm"
                variant="success"
                @click="popInvoiceNoModal()"
              >
                <i class="fa fa-balance-scale"></i> {{buyerubn ? $t('modify') : $t('add')}}
              </b-button>
            </div>
          </div>
          <b-card-body>
            <div>
              <table  border="0" cellpadding="3">
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.invoice_no_remark1')}}</td>
                </tr>
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.invoice_no_remark2')}}</td>
                </tr>
              </table>
              <table  border="0" cellpadding="3">
                <tr v-if="buyerubn && buyerubn.length > 0 && buyername && buyername.length > 0">
                  <th colspan="6" align="center">
                    <b-form-checkbox v-model="auto_invoiceno" @change="InvoiceNoAutoSwitch()">{{$t('device.InvoiceNoAutoSwitch')}}:</b-form-checkbox>
                  </th>
                </tr>
                <tr v-if="buyerubn && buyerubn.length > 0 && buyername && buyername.length > 0">
                  <td><span class="text-primary"><i class="fa fa-check"></i></span></td>
                  <td style="width: 100%; text-align: left;">{{buyerubn}}{{buyername}}</td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <b-button
                        class="mx-1 my-1 text-white"
                        size="sm"
                        variant="danger"
                        @click="InvoiceNoRemove()"
                      >
                        <i class="fa fa-times"></i> {{$t('delete')}}
                      </b-button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </b-card-body>
        </b-card >
      </b-col>

      <b-col v-if="isDemo =='NO' && support_plug_and_charge" xl="12" lg="12" md="12">
        <b-card no-body>
          <!--<div slot="header">
            <i class="fa fa-plug"></i> {{$t('device.plug_and_charge')}}&nbsp;
            <b-button v-if="support_plug_and_charge" style="margin: 0 3px; color: white;" class="pull-right" size="sm" variant="success" @click="popPlugAndChargeModal()"><i class="fa fa-plug"></i> {{$t('device.popPlugAndChargeModal')}}</b-button>&nbsp;
            <p v-else style="margin: 0 3px; color: red;" class="pull-right">{{$t('device.site_not_support')}}</p>&nbsp;
          </div>-->
          <div slot="header" class="d-flex flex-wrap justify-content-between align-items-center">
            <span><i class="fa fa-plug"></i> {{$t('device.plug_and_charge')}}</span>
            <div class="d-flex flex-wrap">
              <b-button
                v-if="support_plug_and_charge"
                class="mx-1 my-1"
                size="sm"
                variant="success"
                @click="popPlugAndChargeModal()"
              >
                <i class="fa fa-plug"></i> {{$t('device.popPlugAndChargeModal')}}
              </b-button>
              <p v-else style="margin: 0 3px; color: red;" class="mx-1 my-1">{{$t('device.site_not_support')}}</p>
            </div>
          </div>
          <b-card-body>
            <div>
              <table border="0" cellpadding="3">
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.plug_and_charge_remark1')}}</td>
                </tr>
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.plug_and_charge_remark2')}}</td>
                </tr>
              </table>
              <table border="0" cellpadding="3">
                <tr v-if="available_plug_and_charge && available_plug_and_charge.length > 0">
                  <th colspan="6" align="center">
                    <i class="fa fa-car"></i> {{$t('device.car_binded')}}
                  </th>
                </tr>
                <tr v-for="(pac, index) in available_plug_and_charge" :key="pac.id">
                  <td>
                    <span class="text-primary"><i class="fa fa-check"></i></span>
                  </td>
                  <td style="width: 100%; text-align: left;">{{pac.idtag}}</td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <b-button
                        class="mx-1 my-1 text-white"
                        size="sm"
                        variant="danger"
                        @click="PlugAndChargeRemove(pac.idtag, pac.target_id)"
                      >
                        <i class="fa fa-times"></i> {{$t('delete')}}
                      </b-button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </b-card-body>
        </b-card >
      </b-col>

      <b-col v-if="isDemo =='NO' && support_rfid_charge" xl="12" lg="12" md="12">
        <b-card no-body>
          <!--<div slot="header">
            <i class="fa fa-feed"></i> {{$t('device.rfid')}}&nbsp;
            <b-button v-if="support_rfid_charge" style="margin: 0 3px; color: white;" class="pull-right" size="sm" variant="success" @click="popRfidChargeModal()"><i class="fa fa-feed"></i> {{$t('device.popRfidChargeModal')}}</b-button>&nbsp;
            <p v-else style="margin: 0 3px; color: red;" class="pull-right">{{$t('device.site_not_support')}}</p>&nbsp;
          </div>-->
          <div slot="header" class="d-flex flex-wrap justify-content-between align-items-center">
            <span><i class="fa fa-feed"></i> {{$t('device.rfid')}}</span>
            <div class="d-flex flex-wrap">
              <b-button
                v-if="support_rfid_charge"
                class="mx-1 my-1"
                size="sm"
                variant="success"
                @click="popRfidChargeModal()"
              >
                <i class="fa fa-feed"></i> {{$t('device.popRfidChargeModal')}}
              </b-button>
              <p v-else style="margin: 0 3px; color: red;" class="mx-1 my-1">{{$t('device.site_not_support')}}</p>
            </div>
          </div>
          <b-card-body>
            <div>
              <table border="0" cellpadding="3">
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.rfid_remark1')}}</td>
                </tr>
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.rfid_remark2')}}</td>
                </tr>
              </table>
              <table border="0" cellpadding="3">
                <tr v-if="available_rfid_charge && available_rfid_charge.length > 0">
                  <th colspan="6" align="center">
                    <i class="fa fa-key"></i> {{$t('device.rfid_binded')}}
                  </th>
                </tr>
                <tr v-for="(pac, index) in available_rfid_charge" :key="pac.id">
                  <td>
                    <span class="text-primary"><i class="fa fa-check"></i></span>
                  </td>
                  <td style="width: 100%; text-align: left;">{{pac.idtag}}</td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <b-button
                        class="mx-1 my-1 text-white"
                        size="sm"
                        variant="danger"
                        @click="RfidChargeRemove(pac.idtag, pac.target_id)"
                      >
                        <i class="fa fa-times"></i> {{$t('delete')}}
                      </b-button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </b-card-body>
        </b-card >
      </b-col>

      <b-col v-if="isDemo =='NO'" xl="12" lg="12" md="12">
        <b-card no-body>
          <!--<div slot="header">
            <i class="fa fa-clock-o"></i> {{$t('device.schedule_charging')}}&nbsp;
            <b-button v-if="support_schedulable" style="margin: 0 3px; color: white;" class="pull-right" size="sm" variant="success" @click="popScheduleEditModal(null)"><i class="fa fa-plus"></i> {{$t('device.popScheduleEditModal')}}</b-button>&nbsp;
            <p v-else style="margin: 0 3px; color: red;" class="pull-right">{{$t('device.site_not_support')}}</p>&nbsp;
          </div>-->
          <div slot="header" class="d-flex flex-wrap justify-content-between align-items-center">
            <span><i class="fa fa-clock-o"></i> {{$t('device.schedule_charging')}}</span>
            <div class="d-flex flex-wrap">
              <b-button
                v-if="support_schedulable"
                class="mx-1 my-1"
                size="sm"
                variant="success"
                @click="popScheduleEditModal(null)"
              >
                <i class="fa fa-plus"></i> {{$t('device.popScheduleEditModal')}}
              </b-button>
              <p v-else style="margin: 0 3px; color: red;" class="mx-1 my-1">{{$t('device.site_not_support')}}</p>
            </div>
          </div>
          <b-card-body>
            <div>
              <table border="0" cellpadding="3">
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.schedule_charging_remark1')}}</td>
                </tr>
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.schedule_charging_remark2')}}</td>
                </tr>
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.schedule_charging_remark3')}}</td>
                </tr>
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>※</span></td>
                  <td>{{$t('device.schedule_charging_remark4')}}</td>
                </tr>
              </table>
            </div>
            <div v-for="(schedule, index) in available_schedules" :key="schedule.id">
              <b-card no-body>
                <div slot="header">
                  <i class="fa fa-clock-o"></i> {{schedule.name}}&nbsp;
                  <b-form-checkbox v-model="schedule.enable" class="pull-right" @change="ScheduleEnableSwitch(schedule)" switch>{{schedule.enable ? $t('device.enable') : $t('device.disable')}}</b-form-checkbox>
                </div>
                <div slot="footer" class="text-center">
                  <b-button style="margin: 0 3px; color: white;" size="sm" variant="primary" @click="popScheduleEditModal(schedule)"><i class="fa fa-calendar"></i> {{$t('device.modify')}}</b-button>
                  <b-button style="margin: 0 3px; color: white;" size="sm" variant="danger" @click="ScheduleRemove(schedule)"><i class="fa fa-times"></i> {{$t('delete')}}</b-button>&nbsp;
                </div>
                <b-card-body>
                  <div class="schedule_time_text">
                    {{schedule.start_time + '~' + schedule.end_time}}
                  </div>
                  <div>
                    {{ getDateWeeklyInfo(schedule) }}
                  </div>
                </b-card-body>
              </b-card >
            </div>
          </b-card-body>
        </b-card >
      </b-col>

      <b-col xl="12" lg="12" md="12" v-if="isDemo =='NO'&&support_schedulable&&canInstall">
        <b-card no-body>
          <div slot="header">
            <i class="fa fa-star-o"></i> 充電捷徑&nbsp;
          </div>
          <b-card-body>
            <div v-if="isIphone">
              <table border="0" cellpadding="3">
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>1.</span></td>
                  <td>掃描QRCode進入充電裝置頁面</td>
                </tr>
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>2.</span></td>
                  <td style="display: flex; align-items: center;">
                    點一下選單列中的
                    <img src="img/innoknight/share.png" width="20" height="25" alt="「分享」按鈕" style="margin-left: 5px;">
                  </td>
                </tr>
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span>3.</span></td>
                  <td>向下捲動選項列表，然後點一下「加入主畫面」。</td>
                </tr>
                <tr style="color: #2373E6;">
                  <td style="vertical-align: top;"><span></span></td>
                  <td>
                    如果你沒有看見「加入主畫面」，可以將其加入。向下捲動至列表底部，點一下「編輯動作」，然後點一下「加入主畫面」。
                  </td>
                </tr>
              </table>
            </div>
            <div v-else class="text-center">
              <b-button class="top-up-btn-sm" variant="success" @click="promptInstall()"><i class="fa fa-plus"></i>新增到桌面</b-button>
            </div>
          </b-card-body>
        </b-card >
      </b-col>

      <b-col xl="12" lg="12" md="12">
        <b-card no-body>
          <div slot="header">
            <i class="fa fa-volume-control-phone"></i> {{$t('device.line_support')}}&nbsp;
          </div>
          <b-card-body>
            <h6 class="text-center"><a href="https://lin.ee/B0X4IJ8"><img height="54" width="54" src="https://www.line.me/static/img/icon-line_1.png"></a></h6>
          </b-card-body>
        </b-card >
      </b-col>

      <b-col xl="12" lg="12" md="12">
        <b-card no-body>
          <div slot="header">
            <i class="fas fa-ad"></i> {{$t('device.more_services')}}&nbsp;
          </div>
          <b-card-body>
            <h6 class="text-left">{{$t('device.more_services_item1')}}</h6>
            <h6 class="text-left">{{$t('device.more_services_item2')}}</h6><br><br>
            <h6 class="text-left">{{$t('device.more_services_item3')}}</h6>
            <h6 class="text-left">{{$t('device.more_services_item4')}}</h6>
          </b-card-body>
        </b-card >
      </b-col>

			<b-col cols="12" sm="6" lg="3" v-if="show_mqtt">
        <b-card :no-body="true">
          <b-card-body v-if="show_init_msg" class="p-0 clearfix">
              <i class="fa fa-cogs bg-info p-4 font-2xl mr-3 float-left"></i>
              <div class="h6 text-primary mb-0 pt-3">{{$t('device.server')}}</div>
              <div class="text-uppercase font-weight-bold font-xs text-success">{{$t('device.ready')}}</div>
              <div class="font-xs text-dark hidden">{{$t('device.server_last_connection')}}：{{mqtt_value.timestamp|htime}}</div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="12" sm="6" lg="3" v-if="show_mqtt">
        <b-card :no-body="true">
          <b-card-body v-if="show_mqtt" class="p-0 clearfix">
              <i class="fa fa-tachometer bg-info p-4 font-2xl mr-3 float-left"></i>
              <div class="h6 text-primary mb-0 pt-3">{{$t('device.smart_meter')}}</div>
              <div class="text-uppercase font-weight-bold font-xs text-success">{{$t('device.ready')}}({{mqtt_value.deviceid}})</div>
              <div class="font-xs text-dark hidden">{{$t('device.smart_meter_id')}}：{{mqtt_value.deviceid}}</div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="12" sm="6" lg="3" v-if="show_mqtt">
        <b-card :no-body="true">
          <b-card-body v-if="show_mqtt" class="p-0 clearfix">
              <i class="fa fa-pause-circle-o bg-info p-4 font-2xl mr-3 float-left"></i>
              <div class="h6 text-primary mb-0 pt-3">{{$t('device.meter_data')}}</div>
              <div class="font-xs text-dark hidden">{{$t('device.total_kwh_used')}}：{{mqtt_value.value2|kwh}}</div>
              <div class="font-xs text-dark">{{$t('status')}}：<span :class="mqtt_value.value3?'text-success':'text-warning'">{{mqtt_value.value3?$t('device.enable'):$t('device.disable')}}</span></div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="12" sm="6" lg="3" v-if="show_mqtt">
        <b-card :no-body="true">
          <b-card-body v-if="show_mqtt" class="p-0 clearfix">
              <i class="fa fa-clock-o bg-info p-4 font-2xl mr-3 float-left"></i>
              <div class="h6 text-primary mb-0 pt-3">{{$t('device.charging_data')}}</div>
              <div class="font-xs text-dark">{{$t('start_time')}}：{{start_time|htime}}</div>
              <div class="font-xs text-dark">{{$t('end_time')}}：{{end_time|htime}}</div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal :title="$t('qrcode_scanning')" v-model="showErrorModal" :ok-title="$t('ok')" :ok-only="true" :hide-footer="true" @hidden="hideScanner()">
      <b-alert :show="showErrorModal" variant="success"><i class="fa fa-exclamation-triangle"></i> {{$t('please_qrcode_scanning')}}</b-alert>
      <!--<b-alert :show="showErrorModal" variant="success"><i class="fa fa-exclamation-triangle"></i> {{errorMsg}}</b-alert>-->
      <!-- <canvas id="qrcode-window" v-if="show_qrcode_canvas"></canvas> -->
      <!-- <video id="qrcode-video" playsinline muted></video> -->
      <video
        v-show="showErrorModal"
        id="qrvideo"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        style="border: 1px solid gray; width: 100%; height: 100%"></video>
      <p class="text-primary">{{qrcode_string}}</p>
    </b-modal>

    <b-modal :title="$t('device.load_detect')" v-model="showLoadDetectorModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <h3>{{$t('device.load_detect')}}</h3>
        <b-alert :show="showLoadDetectorModal" variant="success"><i class="fa fa-exclamation-triangle"></i>{{detectorMsg}}</b-alert>
    </b-modal>
        
    <b-modal :title="$t('device.payment_processing')" v-model="showCashFlowLoadingModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <h5>{{$t('device.payment_connecting')}}</h5>
            <b-img src="img/innoknight/blueWeb.png" fluid alt="InnoKnight"></b-img>
    </b-modal>
        
    <b-modal :title="$t('device.connection_processing')" v-model="showDemoLoadingModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <h5>{{$t('device.device_init')}}</h5>
      <div class="sk-wave">
        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
      </div>
    </b-modal>
        
    <b-modal :title="$t('device.payment_processing')" v-model="showCashCheckOutModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <h5>{{$t('device.settlement_charges')}}</h5>
      <div v-if="available_car_members && available_car_members.length > 0" style="color: #c07711">
        <table border="0" cellpadding="3">
          <tr>
            <td style="vertical-align: top;"><span><i class="fa fa-star"></i></span></td>
            <td>{{$t('device.car_members')}}：<br><span v-html="getCarMembers()"></span></td>
          </tr>
        </table>
      </div>
      <div v-if="available_members && available_members.length > 0" style="color: #c07711">
        <table border="0" cellpadding="3">
          <tr>
            <td style="vertical-align: top;"><span><i class="fa fa-star"></i></span></td>
            <td>{{$t('device.members')}}：<br><span v-html="getMembers()"></span></td>
          </tr>
        </table>
      </div>
      <span class="fixed-leading"><i class="fa fa-usd"></i></span>{{$t('device.account_balance')}}：{{balance}}<br>
      <span class="fixed-leading"><i class="fa fa-diamond"></i></span>{{$t('device.reward_points')}}：{{bonus}}<br>
      <hr>
      <div v-if="device_record.billing_method === 'TIME' && current_used_time > 0">{{$t('device.off_peak_used_time')}}：{{current_used_time}}{{$t('minute')}}</div>
      <div v-if="device_record.billing_method === 'TIME' && current_used_time_peak > 0">{{$t('device.peak_used_time')}}：{{current_used_time_peak}}{{$t('minute')}}</div>
      <div v-if="device_record.billing_method !== 'TIME' && current_used_watts > 0">{{$t('device.off_peak_kwh')}}：{{current_used_watts|kwh}}</div>
      <div v-if="device_record.billing_method !== 'TIME' && current_used_watts_peak > 0">{{$t('device.peak_kwh')}}：{{current_used_watts_peak|kwh}}</div>
      <div v-if="total_pay > 0">{{$t('device.off_peak_price')}}：{{($math.round(total_pay, 2))}}{{$t('s_points')}}({{($math.round(total_pay * 115) / 100)}}{{$t('price_unit')}})</div>
      <div v-if="total_pay_peak > 0">{{$t('device.peak_price')}}：{{($math.round(total_pay_peak, 2))}}{{$t('s_points')}}({{($math.round(total_pay_peak * 115) / 100)}}{{$t('price_unit')}})</div>
      <div v-if="current_used_time_idle > 0">{{$t('device.idle_used_time')}}：{{current_used_time_idle}}{{$t('minute')}}</div>
      <div v-if="total_pay_idle > 0">{{$t('device.idle_price')}}：{{($math.round(total_pay_idle, 2))}}{{$t('s_points')}}({{($math.round(total_pay_idle * 115) / 100)}}{{$t('price_unit')}})</div>
      <div>{{$t('device.time_used')}}：{{current_charging_time|timeStr}}</div>
      <div>{{$t('device.current_total_price')}}：{{($math.round(total_price, 2))}}{{$t('s_points')}}({{($math.round(total_price * 115) / 100)}}{{$t('price_unit')}}) <!--&nbsp;&nbsp;<b-form-checkbox id="deductBonus" v-model="deduct_bonus" value="1" unchecked-value="0" @change="onDeductClick()">使用紅利折抵</b-form-checkbox>--></div>
      <div v-if="reward > 0 && total_price > 0">{{$t('points_reward')}}：{{ $math.round(total_price * reward, 2) }}{{$t('s_points')}}</div>
      <hr>
      <div>
        <span class="hidden">{{$t('device.amount_to_pay')}}：{{amount_to_pay()|round}}元</span>
          <i class="fa fa-check-square-o" aria-hidden="true"></i><span class="text-primary" > {{$t('device.final_points')}}：<i class="fa fa-usd"></i>{{after_credits|round}}</span><br>
          <i class="fa fa-check-square-o" aria-hidden="true"></i><span class="text-danger" > {{$t('device.final_bonus')}}：<i class="fa fa-diamond"></i>{{final_bonus|round}}</span>
      </div>
      <div class="row">
          <div v-if="showCashCheckOutProcessing" class="col-xs-12 col-md-12 text-center">
              <b-button variant="warning" class="top-up-btn"><i class="fa fa-spinner"></i>{{$t('device.checking_out')}}</b-button>
          </div>
          <div class="col-xs-6 col-md-6 text-center" v-if="!showCashCheckOutProcessing">
              <b-button variant="primary" class="top-up-btn" @click="doCheckOut(1)">{{$t('device.stop')}}</b-button>
          </div>
          <div class="col-xs-6 col-md-6 text-center" v-if="!showCashCheckOutProcessing">
              <b-button variant="" class="top-up-btn" @click="doCheckOut(0)">{{$t('device.continue')}}</b-button>
          </div>
      </div>
    </b-modal>

    <b-modal :title="$t('device.charger_error_processing')" v-model="showMqttErrorCheckOutModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true"> 
      <div class="row">
        <div class="col-xs-12 col-md-12 text-center">
            <b-alert variant="warning" class="col-xs-12 col-md-12 text-center" :show="true"><i class="fa fa-exclamation-triangle"></i>{{mqtt_error_code_detail}}</b-alert>
        </div>
        <div class="col-xs-12 col-md-12 text-center">
            <b-button variant="warning" class="col-xs-12 col-md-12 text-center"><i class="fa fa-spinner"></i>{{$t('device.system_processing')}}</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="系統通知"
      size="sm"
      v-model="showNoticeModal"
      :hide-footer="true"
      :hide-header="false"
      :no-close-on-backdrop="true"
      centered
      body-class="pt-4 pb-2 px-4 text-center"
      header-class="text-center"
    >
      <div style="text-align: center; font-size: 1.2rem;color: #156e06;">
        {{ notice_message }}
      </div>

      <div class="col-xs-12 col-md-12 text-center mt-3">
        <b-button variant="primary" class="top-up-btn-sm" @click="showNoticeModal = false">確定</b-button>
      </div>
    </b-modal>

    <b-modal
      title="解除綁定通知"
      size="sm"
      v-model="showCreditCardRemovedModal"
      :hide-footer="true"
      :hide-header="false"
      :no-close-on-backdrop="true"
      centered
      body-class="pt-4 pb-2 px-4 text-center"
      header-class="text-center"
    >
      <div style="text-align: center; font-size: 1.2rem;color: #156e06;">
        {{ credit_cards_removed_message }}
      </div>

      <div class="col-xs-12 col-md-12 text-center mt-3">
        <b-button variant="primary" class="top-up-btn-sm" @click="showCreditCardRemovedModal = false">確定</b-button>
      </div>
    </b-modal>

    <b-modal
      :title="$t('device.use_coupon')"
      v-model="showCouponModal"
      :hide-footer="true"
      :hide-header="false">
      <h5>{{$t('device.pls_enter_coupon')}}</h5>
            <div>
              <b-form-input
                ref="couponsn"
                class="text-center"
                autocomplete="off"
                autofocus
                v-model="couponsn"
                type="number"
                style="font-size: 3rem; height: 6.6rem;"/>
            </div>
            <div class="row">
              <div v-if="checkCouponProcessing" class="col-xs-12 col-md-12 text-center">
                  <b-button variant="warning" class="top-up-btn"><i class="fa fa-spinner"></i>{{$t('device.checking_coupon')}}</b-button>
              </div>
              <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCouponProcessing">
                <b-button variant="primary" class="top-up-btn" @click="checkCoupon(1)">{{$t('device.check_coupon')}}</b-button>
              </div>
            </div>
    </b-modal>

    <b-modal
      :title="$t('device.choose_your_plan')"
      v-model="showPaymentModal"
      :hide-footer="true"
      :hide-header="false">
      <b-alert variant="warning"
                class="text-center"
                :show="true">
        <i class="fa fa-exclamation-triangle"></i>
        {{showTopMsg}}
      </b-alert>
      <div class="row">
        <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
          <!---<b-button variant="info" class="top-up-btn" @click="popCreditCardModal()" style="color: white">綁定信用卡</b-button>-->
          <b-button variant="info" class="top-up-btn" @click="popshowCreditCardORLINEPayModal()" style="font-size: 1.8rem; color: white">{{$t('device.popshowCreditCardORLINEPayModal')}}</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
          <b-button variant="primary" class="top-up-btn" @click="popTopUpModal()">{{$t('device.popTopUpModal')}}</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
          <b-button variant="primary" class="top-up-btn" @click="popCarMemberRegisterModal()">{{$t('device.popCarMemberRegisterModal')}}</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
          <b-button variant="warning" class="top-up-btn" @click="showPaymentModal=false">{{$t('cancel')}}</b-button>
        </div>
      </div>

    </b-modal>

    <b-modal
      :title="$t('device.one_charge_title')"
      v-model="showChargeFirstModal"
      :hide-footer="true"
      :hide-header="false">
      <b-alert variant="warning"
                class="text-center"
                :show="true">
        <i class="fa fa-exclamation-triangle"></i>
        {{$t('device.one_charge_message', { value1: device_record.charge_value, value2: $math.round(device_record.charge_value/1.15,2)})}}
      </b-alert>
      <div class="row">
        <div class="col-xs-12 col-md-12 text-center mt-3">
          <b-button variant="info" class="top-up-btn" @click="chargeFirst()" style="color: white">{{$t('device.confirm_charging')}}</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mt-3">
          <b-button variant="warning" class="top-up-btn" @click="chargeFirst(1)">{{$t('cancel')}}</b-button>
        </div>
        <div v-if="prepayChargeMsg" class="col-xs-12 col-md-12 text-center text-danger">
          {{prepayChargeMsg}}
        </div>
      </div>

    </b-modal>

    <b-modal
      :title="$t('device.bind_creditcard_or_linepay')"
      v-model="showCreditCardORLINEPayModal"
      :hide-footer="true"
      :hide-header="false">
        <div class="mb-1">
          <b-form-checkbox v-model="auto_invoiceno_cl" size="lg" style="font-size: 1rem;">{{$t('device.InvoiceNoAutoSwitch')}}</b-form-checkbox>
        </div>
        <div v-if="auto_invoiceno_cl">
          <b-input-group class="mb-1">
            <b-input-group-prepend>
              <b-input-group-text style="font-size: 1rem; height: 3rem;">{{$t('device.invoice')}}</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
            ref="new_buyerubn_cl"
            class="text-center"
            autocomplete="off"
            v-model="new_buyerubn_cl"
            type="number"
            style="font-size: 1rem; height: 3rem;"
            :placeholder="$t('device.invoice_no_placeholder')"/>
          </b-input-group>
          <b-input-group class="mb-2">
            <b-input-group-prepend>
              <b-input-group-text style="font-size: 1rem; height: 3rem;">{{$t('device.invoice_no_company')}}</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
            ref="new_buyername_cl"
            class="text-center"
            autocomplete="off"
            v-model="new_buyername_cl"
            type="text"
            style="font-size: 1rem; height: 3rem;"
            :placeholder="$t('device.invoice_no_company_placeholder')"/>
          </b-input-group>
        </div>

        <div v-if="!auto_invoiceno_cl" class="row">
          <div v-if="!invoice_carrier" class="col-xs-12 col-md-12 text-center mb-2">
            <b-button variant="light" class="select-payment-btn" @click="popInvoiceCarrierModal()">{{$t('device.invoice_carrier')}}{{$t('device.invoice_carrier_optional')}}</b-button>
          </div>
          <div v-if="invoice_carrier" class="col-xs-12 col-md-12 text-center mb-2">
            <b-input-group class="mb-1">
              <b-input-group-prepend>
                <b-input-group-text style="font-size: 1rem; height: 3rem;">{{$t('device.invoice_carrier_phone_barcode')}}</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
              class="text-center"
              autocomplete="off"
              v-model="invoice_carrier"
              type="text"
              style="font-size: 1rem; height: 3rem;"
              readonly
              @click="popInvoiceCarrierModal()"/>
              <b-input-group-append>
                <b-button variant="danger" @click="InvoiceCarrierRemove()">{{$t('delete')}}</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>

        <div class="mb-1">
          <table border="0" cellpadding="3">
            <tr style="font-size: 1rem; color: #2373E6;">
              <td style="vertical-align: top;"><span>※</span></td>
              <td>{{$t('device.invoice_no_remark3')}}</td>
            </tr>
            <!--<tr style="font-size: 1rem; color: #2373E6;">
              <td style="vertical-align: top;"><span>※</span></td>
              <td>{{$t('device.invoice_no_remark4')}}</td>
            </tr>-->
            <tr style="font-size: 1rem; color: #2373E6;">
              <td style="vertical-align: top;"><span>※</span></td>
              <td>{{$t('device.invoice_no_remark1')}}</td>
            </tr>
          </table>
        </div>
        <div class="row">
          <div v-if="credit_card_linepay_invalid" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center text-danger">{{credit_card_linepay_invalid_msg}}</div>
          <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
            <b-button variant="primary" class="top-up-btn-sm" @click="popCreditCardModal()">{{$t('device.bind_creditcard')}}</b-button>
          </div>
          <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
            <b-button variant="success" class="top-up-btn-sm" @click="popLinePayModal()">{{$t('device.bind_linepay')}}</b-button>
          </div>
        </div>
    </b-modal>

    <b-modal
      :title="$t('device.bind_creditcard')"
      v-model="showCreditCardModal"
      :hide-footer="true"
      :hide-header="false">
        <div>
          <div v-if="showUpdateUserEmail" class="mb-1">
            <h5>{{$t('device.invoice_no_email')}}：</h5>
            <b-form-input
              ref="cardemail"
              class="text-center"
              autocomplete="off"
              v-model="cardemail"
              type="email"
              style="font-size: 1rem; height: 3rem;"
              :placeholder="$t('device.buyer_email_placeholder')"/>
            <p class="text-danger" v-if="cardemailinvalid">{{$t('device.confirm_invoice_no_email')}}</p>  
          </div>
        </div>
        <div class="mb-1">
          <table border="0" cellpadding="3">
            <tr style="font-size: 1.2rem; color: #2373E6;">
              <td style="vertical-align: top;"><span>※</span></td>
              <td>{{$t('device.creditcard_remark1')}}</td>
            </tr>
            <tr style="font-size: 1.2rem; color: #2373E6;">
              <td style="vertical-align: top;"><span>※</span></td>
              <td>{{$t('device.creditcard_remark2')}}</td>
            </tr>
          </table>
        </div>
        <div class="row">
          <div v-if="checkCreditCartProcessing" class="col-xs-12 col-md-12 text-center">
              <b-button variant="warning" class="top-up-btn"><i class="fa fa-spinner"></i>{{$t('device.checking')}}</b-button>
          </div>
          <div v-if="creditCartCheckingResult" class="col-xs-12 col-md-12 text-center" :class="creditCartCheckingSuccess ? 'text-primary' : 'text-danger'">
            {{creditCartCheckingResult}}
          </div>
          <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!checkCreditCartProcessing">
            <b-button variant="primary" class="top-up-btn-sm" @click="checkCreditCard()">{{$t('device.start_binding')}}</b-button>
          </div>
        </div>
    </b-modal>

    <b-modal
      :title="$t('device.bind_linepay')"
      v-model="showLinePayModal"
      :hide-footer="true"
      :hide-header="false">
        <div>
          <div v-if="showUpdateUserEmail" class="mb-1">
            <h5>{{$t('device.invoice_no_email')}}：</h5>
            <b-form-input
              ref="linepayemail"
              class="text-center"
              autocomplete="off"
              v-model="linepayemail"
              type="email"
              style="font-size: 1rem; height: 3.0rem;"
              :placeholder="$t('device.buyer_email_placeholder')"/>
            <p class="text-danger" v-if="linepayemailinvalid">{{$t('device.confirm_invoice_no_email')}}</p>  
          </div>
        </div>
        <div class="mb-1">
          <table border="0" cellpadding="3">
            <tr style="font-size: 1.2rem; color: #2373E6;">
              <td style="vertical-align: top;"><span>※</span></td>
              <td>{{$t('device.linepay_remark1')}}</td>
            </tr>
            <tr style="font-size: 1.2rem; color: #2373E6;">
              <td style="vertical-align: top;"><span>※</span></td>
              <td>{{$t('device.linepay_remark2')}}</td>
            </tr>
          </table>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-12 text-center mt-3">
            <b-button variant="primary" class="top-up-btn-sm" @click="checkLinePay()">{{$t('device.start_binding')}}</b-button>
          </div>
        </div>
    </b-modal>

    <b-modal :title="$t('device.payment_method')" v-model="showSelectPaymentModal" :hide-footer="true" :hide-header="false" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <!--<b-alert :show="showTopUpModal" variant="warning" class="text-center"><i class="fa fa-exclamation-triangle"></i>{{$t('device.choose_payment_method')}}</b-alert>-->
      <div class="row">
        <div class="col-xs-12 col-md-12 text-center mb-2">
          <b-button variant="light" class="select-payment-btn-left" @click="setPaymentMethod(1)"><b-img class="select-payment-img" src="img/innoknight/credit-card-svgrepo-com.svg" alt="credit card"></b-img>{{$t('device.use_creditcard')}}</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mb-2" v-if="false || isApplePayOkay">
          <b-button variant="light" class="select-payment-btn-left" @click="setPaymentMethod(2)"><b-img class="select-payment-img" src="img/innoknight/apple-pay-svgrepo-com.svg" alt="Apple Pay"></b-img>Apple Pay</b-button>
        </div>
        <!--<div class="col-xs-12 col-md-12 text-center mb-2">
          <b-button variant="light" class="select-payment-btn" @click="setPaymentMethod(3)"><b-img class="select-payment-img" src="img/innoknight/LINE-Pay_h_W238_n.png" alt="Line Pay"></b-img></b-button>
        </div>  -->
        <div class="col-xs-12 col-md-12 text-center mb-2">
          <b-button variant="light" class="select-payment-btn-left" @click="setPaymentMethod(4)"><b-img class="select-payment-img" src="img/innoknight/google-pay-svgrepo-com.svg" alt="Google Pay"></b-img>Google Pay</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center">
          <b-button variant="light" class="select-payment-btn-left" @click="setPaymentMethod(5)"><b-img class="select-payment-img" src="img/innoknight/Samsung_Pay_Logo.svg" alt="Samsung Pay"></b-img>Samsung Pay</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal :title="$t('device.topup_amount')" v-model="showSelectTopupAmountModal" :hide-footer="true" :hide-header="false" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <div class="row">
        <div class="col-xs-12 col-md-12 text-center mb-2">
          <b-button variant="light" class="select-payment-btn" @click="setTopupAmount(1)">{{$t('device.addValue2', { value: 100, price: Math.round(unit_price*100) })}}</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mb-2">
          <b-button variant="light" class="select-payment-btn" @click="setTopupAmount(2)">{{$t('device.addValue2', { value: 300, price: Math.round(unit_price*300) })}}</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mb-2">
          <b-button variant="light" class="select-payment-btn" @click="setTopupAmount(3)">{{$t('device.addValue2', { value: 500, price: Math.round(unit_price*500) })}}</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center mb-2">
          <b-button variant="light" class="select-payment-btn" @click="setTopupAmount(4)">{{$t('device.addValue2', { value: 1000, price: Math.round(unit_price*1000) })}}</b-button>
        </div>
        <div class="col-xs-12 col-md-12 text-center">
          <b-button variant="light" class="select-payment-btn" @click="setTopupAmount(5)" v-html="$t('device.addValue3', { value: 3000, price: Math.round(unit_price*3000), points: 60 })"></b-button>
        </div>
      </div>
    </b-modal>
        
    <b-modal :title="$t('device.popTopUpModal')" v-model="showTopUpModal" :hide-footer="true" :hide-header="false" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <!--<b-alert :show="showTopUpModal" variant="warning" class="text-center"><i class="fa fa-exclamation-triangle"></i>{{showTopMsg}}</b-alert>-->
      <div class="mb-1">
        <h5>{{$t('device.buyer_email')}}</h5>
        <b-form-input
          ref="buyeremail"
          class="text-center"
          autocomplete="off"
          v-model="buyeremail"
          type="email"
          style="font-size: 1rem; height: 3rem;"
          :placeholder="$t('device.buyer_email_placeholder')"/>
      </div>

      <div class="mb-1">
        <b-form-checkbox v-model="auto_invoiceno_cl" size="lg" style="font-size: 1rem">{{$t('device.InvoiceNoAutoSwitch')}}</b-form-checkbox>
      </div>
      <div v-if="auto_invoiceno_cl">
        <b-input-group class="mb-1">
          <b-input-group-prepend>
            <b-input-group-text style="font-size: 1rem; height: 3rem;">{{$t('device.invoice')}}</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
          ref="new_buyerubn_cl_top_up"
          class="text-center"
          autocomplete="off"
          v-model="new_buyerubn_cl"
          type="number"
          style="font-size: 1rem; height: 3rem;"
          :placeholder="$t('device.invoice_no_placeholder')"/>
        </b-input-group>
        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text style="font-size: 1rem; height: 3rem;">{{$t('device.invoice_no_company')}}</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
          ref="new_buyername_cl_top_up"
          class="text-center"
          autocomplete="off"
          v-model="new_buyername_cl"
          type="text"
          style="font-size: 1rem; height: 3rem;"
          :placeholder="$t('device.invoice_no_company_placeholder')"/>
        </b-input-group>
      </div>

      <div v-if="!auto_invoiceno_cl" class="row">
        <div v-if="!invoice_carrier" class="col-xs-12 col-md-12 text-center mb-3">
          <b-button variant="light" class="select-payment-btn" @click="popInvoiceCarrierModal()">{{$t('device.invoice_carrier')}}{{$t('device.invoice_carrier_optional')}}</b-button>
        </div>
        <div v-if="invoice_carrier" class="col-xs-12 col-md-12 text-center mb-3">
          <b-input-group class="mb-1">
            <b-input-group-prepend>
              <b-input-group-text style="font-size: 1rem; height: 3rem;">{{$t('device.invoice_carrier_phone_barcode')}}</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
            class="text-center"
            autocomplete="off"
            v-model="invoice_carrier"
            type="text"
            style="font-size: 1rem; height: 3rem;"
            readonly
            @click="popInvoiceCarrierModal()"/>
            <b-input-group-append>
              <b-button variant="danger" @click="InvoiceCarrierRemove()">{{$t('delete')}}</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <h5>{{$t('device.payment_method')}}</h5>
      <div class="row mb-3">
        <div class="col-xs-12 col-md-12 text-center">
          <b-button v-if="payment_method===0" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()">-- {{$t('device.choose_payment_method')}} --</b-button>
          <b-button v-if="payment_method===1" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()"><b-img class="select-payment-img" src="img/innoknight/credit-card-svgrepo-com.svg" alt="credit card"></b-img>{{$t('device.use_creditcard')}}</b-button>
          <b-button v-if="payment_method===2&&(false || isApplePayOkay)" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()"><b-img class="select-payment-img" src="img/innoknight/apple-pay-svgrepo-com.svg" alt="Apple Pay"></b-img>Apple Pay</b-button>
          <b-button v-if="payment_method===3" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()"><b-img class="select-payment-img" src="img/innoknight/LINE-Pay_h_W238_n.png" alt="Line Pay"></b-img>Line Pay</b-button>
          <b-button v-if="payment_method===4" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()"><b-img class="select-payment-img" src="img/innoknight/google-pay-svgrepo-com.svg" alt="Google Pay"></b-img>Google Pay</b-button>
          <b-button v-if="payment_method===5" variant="light" class="select-payment-btn" @click="popTopSelectPaymentModal()"><b-img class="select-payment-img" src="img/innoknight/Samsung_Pay_Logo.svg" alt="Samsung Pay"></b-img>Samsung Pay</b-button>
        </div>
      </div>

      <h5>{{$t('device.topup_amount')}}</h5>
      <div class="row">
        <div class="col-xs-12 col-md-12 text-center">
          <b-button v-if="topup_amount_select===0" variant="light" class="select-payment-btn" @click="popTopSelectTopupAmountModal()">-- {{$t('device.choose_topup_amount')}} --</b-button>
          <b-button v-if="topup_amount_select===1" variant="light" class="select-payment-btn" @click="popTopSelectTopupAmountModal()">{{$t('device.addValue2', { value: 100, price: Math.round(unit_price*100) })}}</b-button>
          <b-button v-if="topup_amount_select===2" variant="light" class="select-payment-btn" @click="popTopSelectTopupAmountModal()">{{$t('device.addValue2', { value: 300, price: Math.round(unit_price*300) })}}</b-button>
          <b-button v-if="topup_amount_select===3" variant="light" class="select-payment-btn" @click="popTopSelectTopupAmountModal()">{{$t('device.addValue2', { value: 500, price: Math.round(unit_price*500) })}}</b-button>
          <b-button v-if="topup_amount_select===4" variant="light" class="select-payment-btn" @click="popTopSelectTopupAmountModal()">{{$t('device.addValue2', { value: 1000, price: Math.round(unit_price*1000) })}}</b-button>
          <b-button v-if="topup_amount_select===5" variant="light" class="select-payment-btn" @click="popTopSelectTopupAmountModal()" v-html="$t('device.addValue3', { value: 3000, price: Math.round(unit_price*3000), points: 60 })"></b-button>
        </div>
      </div>

      <div class="mb-1">
        <table border="0" cellpadding="3">
          <tr style="font-size: 1rem; color: #2373E6;">
            <td style="vertical-align: top;"><span>※</span></td>
            <td>{{$t('device.payment_method_remark1', { unit_price })}}</td>
          </tr>
          <tr style="font-size: 1rem; color: #2373E6;">
            <td style="vertical-align: top;"><span>※</span></td>
            <td>{{$t('device.payment_method_remark2')}}</td>
          </tr>
          <tr style="font-size: 1rem; color: #2373E6;">
            <td style="vertical-align: top;"><span>※</span></td>
            <td>{{$t('device.payment_method_remark3')}}"<a href="https://lin.ee/1XYXjce" target="_blank" style="color:#2373E6; text-decoration: underline;">創玖科技官方LINE群</a>"。</td>
          </tr>
        </table>
      </div>

      <div class="row">
        <div v-if="top_up_invalid" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center text-danger">{{top_up_invalid_msg}}</div>
        <div class="col-xs-12 col-md-12 text-center mt-1">
          <b-button variant="primary" class="top-up-btn-sm" @click="doPaymentProcess(topup_amount_select)">{{$t('device.topup_start')}}</b-button>
        </div>
      </div>

      <!--<h4>{{$t('device.payment_method_remark1', { unit_price })}}</h4>
      <blockquote>
        <i class="fa fa-plus"></i><span v-html="$t('device.addValue', { value: Math.round(unit_price * 2400), points: 30 })"></span><br>
        <i class="fa fa-plus"></i><span v-html="$t('device.addValue', { value: Math.round(unit_price * 3000), points: 60 })"></span>
      </blockquote>

      <div class="row">
        <div class="col-md-12 col-xs-12 text-center">
            <b-button
              v-if="device_record.charge_value && ($math.round(unit_price*100) >= device_record.charge_value * 1.5)"
              variant="" class="top-up-btn" @click="doPaymentProcess(100)">{{$t('device.addValue2', { value: 100, price: Math.round(unit_price*100) })}}</b-button>
            <b-button
              v-if="!device_record.charge_value"
              variant="" class="top-up-btn" @click="doPaymentProcess(100)">{{$t('device.addValue2', { value: 100, price: Math.round(unit_price*100) })}}</b-button>
        </div>
        <div class="col-md-12 col-xs-12 text-center">
            <b-button
              v-if="device_record.charge_value && ($math.round(unit_price*300) >= device_record.charge_value * 1.5)"
              variant="" class="top-up-btn" @click="doPaymentProcess(300)">{{$t('device.addValue2', { value: 300, price: Math.round(unit_price*300) })}}</b-button>
            <b-button
              v-if="!device_record.charge_value"
              variant="" class="top-up-btn" @click="doPaymentProcess(300)">{{$t('device.addValue2', { value: 300, price: Math.round(unit_price*300) })}}</b-button>
        </div>
        <div class="col-md-12 col-xs-12 text-center">
            <b-button
              v-if="device_record.charge_value && ($math.round(unit_price*600) >= device_record.charge_value * 1.5)"
              variant="" class="top-up-btn" @click="doPaymentProcess(600)">{{$t('device.addValue2', { value: 600, price: Math.round(unit_price*600) })}}</b-button>
            <b-button
              v-if="!device_record.charge_value"
              variant="" class="top-up-btn" @click="doPaymentProcess(600)">{{$t('device.addValue2', { value: 600, price: Math.round(unit_price*600) })}}</b-button>
        </div>
        <div class="col-md-12 col-xs-12 text-center">
            <b-button
              v-if="device_record.charge_value && ($math.round(unit_price*1200) >= device_record.charge_value * 1.5)"
              variant="" class="top-up-btn" @click="doPaymentProcess(1200)">{{$t('device.addValue2', { value: 1200, price: Math.round(unit_price*1200) })}}</b-button>
            <b-button
              v-if="!device_record.charge_value"
              variant="" class="top-up-btn" @click="doPaymentProcess(1200)">{{$t('device.addValue2', { value: 1200, price: Math.round(unit_price*1200) })}}</b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 text-center">
            <b-button
              v-if="device_record.charge_value && ($math.round(unit_price*2400) >= device_record.charge_value * 1.5)"
              variant="primary" class="top-up-btn" @click="doPaymentProcess(2400)">{{$t('device.addValue2', { value: 2400, price: Math.round(unit_price*2400) })}}</b-button>
            <b-button
              v-if="!device_record.charge_value"
              variant="primary" class="top-up-btn" @click="doPaymentProcess(2400)">{{$t('device.addValue2', { value: 2400, price: Math.round(unit_price*2400) })}}</b-button>
        </div>
        <div class="col-md-12 col-xs-12 text-center">
            <b-button
              v-if="device_record.charge_value && ($math.round(unit_price*3000) >= device_record.charge_value * 1.5)"
              variant="primary" class="top-up-btn " @click="doPaymentProcess(3000)">{{$t('device.addValue2', { value: 3000, price: Math.round(unit_price*3000) })}}</b-button>
            <b-button
              v-if="!device_record.charge_value"
              variant="primary" class="top-up-btn " @click="doPaymentProcess(3000)">{{$t('device.addValue2', { value: 3000, price: Math.round(unit_price*3000) })}}</b-button>
        </div>
      </div>-->
		</b-modal>

    <b-modal
      :title="$t('device.car_members_bind')"
      v-model="showCarMemberRegisterModal"
      :hide-footer="true"
      :hide-header="false">
      <div>
        <b-input-group class="mb-1">
          <b-input-group-prepend>
            <b-input-group-text style="custom_input_prepend">{{$t('device.card_number')}}</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="text" 
            ref="car_member_cardno"
            v-model="car_member_cardno"
            class="text-center" 
            :placeholder="$t('device.card_number_placeholder')"
            autocomplete="off"
            autofocus
            maxlength="20"
            style="font-size: 1.0rem;"/>
        </b-input-group>
      </div>
      <div class="mb-1">
        <table border="0" cellpadding="3">
          <tr style="font-size: 1.0rem; color: #2373E6;">
            <td style="vertical-align: top;"><span>※</span></td>
            <td>{{$t('device.car_members_bind_remark1')}}</td>
          </tr>
          <tr style="font-size: 1.0rem; color: #2373E6;">
            <td style="vertical-align: top;"><span>※</span></td>
            <td>{{$t('device.car_members_bind_remark2')}}<br>({{$t('device.car_members_bind_remark3')}})</td>
          </tr>
        </table>
      </div>
      <div class="row">
        <div v-if="car_member_cardnoinvalid" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center text-danger">{{$t('device.bind_fail_message')}}</div>
        <div v-if="CarMemberRegisterProcessing" class="col-xs-12 col-md-12 text-center">
            <b-button variant="warning" class="top-up-btn-sm"><i class="fa fa-spinner"></i>{{$t('device.checking')}}</b-button>
        </div>
        <div v-if="CarMemberRegisterResult" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center" :class="CarMemberRegisterSuccess ? 'text-primary' : 'text-danger'">
          {{$t('device.bind_error')}}: {{CarMemberRegisterResult}}
        </div>
        <div class="col-xs-12 col-md-12 text-center mt-3" v-if="!CarMemberRegisterProcessing">
          <b-button variant="primary" class="top-up-btn-sm" @click="CarMemberRegister()">{{$t('ok')}}</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal :title="$t('device.popPlugAndChargeModal')" v-model="showPlugAndChargeModal" :hide-footer="true" :hide-header="false">
      <table border="0" cellpadding="3">
        <tr v-if="PlugAndChargeErrorMsg.length <= 0 && PlugAndChargeIdTag.length <= 0 && PlugAndChargeIdTagBinded == true" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{$t('device.car_already_binded')}}</th>
        </tr>
        <tr v-if="PlugAndChargeErrorMsg.length <= 0 && PlugAndChargeIdTag.length <= 0 && PlugAndChargeIdTagBinded == false" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{$t('device.car_detection')}}</th>
        </tr>
        <tr v-if="PlugAndChargeErrorMsg.length <= 0 && PlugAndChargeIdTag.length <= 0 && PlugAndChargeIdTagBinded == false" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{$t('device.pls_remove_and_plug')}}</th>
        </tr>
        <tr v-if="PlugAndChargeErrorMsg.length <= 0 && PlugAndChargeIdTag.length > 0 && PlugAndChargeIdTagBinded == false" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{$t('device.car_detected')}}:</th>
        </tr>
        <tr v-if="PlugAndChargeErrorMsg.length <= 0 && PlugAndChargeIdTag.length > 0 && PlugAndChargeIdTagBinded == false" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{PlugAndChargeIdTag}}</th>
        </tr>

        <tr v-if="PlugAndChargeErrorMsg.length > 0" style="text-align: center; font-size: 2rem;color: #ad0b1b;">
          <th colspan="6" align="center">{{$t('device.bind_fail')}}</th>
        </tr>
        <tr v-if="PlugAndChargeErrorMsg.length > 0" style="text-align: center; font-size: 2rem;color: #ad0b1b;">
          <th colspan="6" align="center">{{$t('err')}}:{{PlugAndChargeErrorMsg}}</th>
        </tr>

        <tr>
          <th></th>
        </tr>
        <tr style="font-size: 1rem;color: #2373E6;">
          <td style="vertical-align: top;"><span>※</span></td>
          <td>{{$t('device.plug_and_charge_remark3')}}</td>
        </tr>
        <tr style="font-size: 1rem;color: #2373E6;">
          <td style="vertical-align: top;"><span>※</span></td>
          <td>{{$t('device.plug_and_charge_remark1')}}</td>
        </tr>
      </table>
      <div v-if="PlugAndChargeIdTag.length > 0" class="col-xs-12 col-md-12 text-center mt-3">
        <b-button variant="primary" class="top-up-btn-sm" @click="PlugAndChargeRegister(PlugAndChargeIdTag)">{{$t('binding')}}</b-button>
      </div>
      <div v-if="PlugAndChargeIdTagBinded == true" class="col-xs-12 col-md-12 text-center mt-3">
        <b-button variant="primary" class="top-up-btn-sm" @click="showPlugAndChargeModal=false">{{$t('ok')}}</b-button>
      </div>
      <div class="col-xs-12 col-md-12 text-center mt-3">
        <b-button variant="secondary" class="top-up-btn-sm" @click="showPlugAndChargeModal=false">{{$t('cancel')}}</b-button>
      </div>
    </b-modal>

    <b-modal :title="$t('device.popRfidChargeModal')" v-model="showRfidChargeModal" :hide-footer="true" :hide-header="false">
      <table border="0" cellpadding="3">
        <tr v-if="RfidChargeErrorMsg.length <= 0 && RfidChargeIdTag.length <= 0 && RfidChargeIdTagBinded == true" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{$t('device.rfid_already_binded')}}</th>
        </tr>
        <tr v-if="RfidChargeErrorMsg.length <= 0 && RfidChargeIdTag.length <= 0 && RfidChargeIdTagBinded == false" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{$t('device.rfid_detection')}}</th>
        </tr>
        <tr v-if="RfidChargeErrorMsg.length <= 0 && RfidChargeIdTag.length <= 0 && RfidChargeIdTagBinded == false" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{$t('device.pls_hold_near_area')}}</th>
        </tr>
        <tr v-if="RfidChargeErrorMsg.length <= 0 && RfidChargeIdTag.length > 0 && RfidChargeIdTagBinded == false" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{$t('device.rfid_detected')}}:</th>
        </tr>
        <tr v-if="RfidChargeErrorMsg.length <= 0 && RfidChargeIdTag.length > 0 && RfidChargeIdTagBinded == false" style="text-align: center; font-size: 2rem;color: #156e06;">
          <th colspan="6" align="center">{{RfidChargeIdTag}}</th>
        </tr>
        <tr v-if="RfidChargeErrorMsg.length > 0" style="text-align: center; font-size: 2rem;color: #ad0b1b;">
          <th colspan="6" align="center">{{$t('device.bind_fail')}}</th>
        </tr>
        <tr v-if="RfidChargeErrorMsg.length > 0" style="text-align: center; font-size: 2rem;color: #ad0b1b;">
          <th colspan="6" align="center">{{$t('err')}}:{{RfidChargeErrorMsg}}</th>
        </tr>

        <tr>
          <th></th>
        </tr>
        <tr style="font-size: 1rem;color: #2373E6;">
          <td style="vertical-align: top;"><span>※</span></td>
          <td>{{$t('device.rfid_remark3')}}</td>
        </tr>
        <tr style="font-size: 1rem;color: #2373E6;">
          <td style="vertical-align: top;"><span>※</span></td>
          <td>{{$t('device.rfid_remark1')}}</td>
        </tr>
      </table>
      <div v-if="RfidChargeIdTag.length > 0" class="col-xs-12 col-md-12 text-center mt-3">
        <b-button variant="primary" class="top-up-btn-sm" @click="RfidChargeRegister(RfidChargeIdTag)">{{$t('binding')}}</b-button>
      </div>
      <div v-if="RfidChargeIdTagBinded == true" class="col-xs-12 col-md-12 text-center mt-3">
        <b-button variant="primary" class="top-up-btn-sm" @click="showRfidChargeModal=false">{{$t('ok')}}</b-button>
      </div>
      <div class="col-xs-12 col-md-12 text-center mt-3">
        <b-button variant="secondary" class="top-up-btn-sm" @click="showRfidChargeModal=false">{{$t('cancel')}}</b-button>
      </div>
    </b-modal>
    
    <b-modal :title="buyerubn ? $t('device.modify_invoice_no') : $t('device.add_invoice_no')" v-model="showInvoiceNoModal" :hide-footer="true" :hide-header="false">
        <div>
          <b-input-group class="mb-1">
            <b-input-group-prepend>
              <b-input-group-text style="font-size: 1.2rem; height: 3rem;">{{$t('device.invoice')}}</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
            ref="new_buyerubn_am"
            class="text-center"
            autocomplete="off"
            v-model="new_buyerubn_am"
            type="number"
            style="font-size: 1.2rem; height: 3rem;"
            :placeholder="$t('device.invoice_no_placeholder')"/>
          </b-input-group>
          <b-input-group class="mb-2">
            <b-input-group-prepend>
              <b-input-group-text style="font-size: 1.2rem; height: 3rem;">{{$t('device.invoice_no_company')}}</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
            ref="new_buyername_am"
            class="text-center"
            autocomplete="off"
            v-model="new_buyername_am"
            type="text"
            style="font-size: 1.2rem; height: 3rem;"
            :placeholder="$t('device.invoice_no_company_placeholder')"/>
          </b-input-group>
        </div>
        <div class="row">
          <div v-if="invoice_no_invalid" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center text-danger">{{invoice_no_invalid_msg}}</div>
          <div v-if="!buyerubn" class="col-xs-12 col-md-12 text-center mt-3">
            <b-button variant="primary" class="top-up-btn-sm" @click="InvoiceNoAdd()">{{$t('add')}}</b-button>
          </div>
          <div v-if="buyerubn" class="col-xs-12 col-md-12 text-center mt-3">
            <b-button variant="primary" class="top-up-btn-sm" @click="InvoiceNoModify()">{{$t('modify')}}</b-button>
          </div>
        </div>
    </b-modal>

    <b-modal :title="invoice_carrier ? $t('device.modify_invoice_carrier') : $t('device.add_invoice_carrier')" v-model="showInvoiceCarrierModal" :hide-footer="true" :hide-header="false">
      <div>
        <b-input-group class="mb-1">
          <b-input-group-prepend>
            <b-input-group-text style="font-size: 1.2rem; height: 3rem;">{{$t('device.invoice_carrier_phone_barcode')}}</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
          ref="new_invoice_carrier"
          class="text-center"
          autocomplete="off"
          v-model="new_invoice_carrier"
          type="text"
          style="font-size: 1.2rem; height: 3rem;"
          :placeholder="$t('device.invoice_carrier_placeholder')"
          @input="onInvoiceCarrierInput"/>
        </b-input-group>
      </div>
      <div class="mb-1">
        <table border="0" cellpadding="3">
          <tr style="font-size: 1.0rem; color: #2373E6;">
            <td style="vertical-align: top;"><span>※</span></td>
            <td>{{$t('device.invoice_carrier_remark2')}}</td>
          </tr>
          <tr style="font-size: 1.0rem; color: #2373E6;">
            <td style="vertical-align: top;"><span>※</span></td>
            <td>{{$t('device.invoice_carrier_remark3')}}</td>
          </tr>
        </table>
      </div>
      <div class="row">
        <div v-if="invoice_carrier_invalid" style="font-size: 1.2rem" class="col-xs-12 col-md-12 text-center text-danger">{{invoice_carrier_invalid_msg}}</div>
        <div v-if="!invoice_carrier" class="col-xs-12 col-md-12 text-center mt-3">
          <b-button variant="primary" class="top-up-btn-sm" @click="InvoiceCarrierAdd()">{{$t('add')}}</b-button>
        </div>
        <div v-if="invoice_carrier" class="col-xs-12 col-md-12 text-center mt-3">
          <b-button variant="primary" class="top-up-btn-sm" @click="InvoiceCarrierModify()">{{$t('modify')}}</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="showScheduleEditModal" :title="scheduleEditTitle" :hide-footer="true" :hide-header="false">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-clock-o"></i>{{scheduleSelected ? scheduleSelected.name : (device_record ? device_record.name : $t('unknow_device'))}}&nbsp;
        </div>
        <div slot="footer" class="col-xs-12 col-md-12 text-center">
          <b-button v-if="!scheduleEditProcessing" variant="primary" class="top-up-btn-sm" @click="ScheduleEditConfirm()">{{$t('confirm')}}</b-button>
          <b-button v-else variant="primary" class="top-up-btn-sm">{{$t('processing')}}...</b-button>
        </div>
        <b-card-body class="container-fluid custom-padding">
          <div class="container-fluid custom-padding">
            <div class="row">
              <div class="col">
                <table class="table custom-table" style="font-size: 1rem; font-weight: bold;">
                  <thead>
                    <tr>
                      <th>{{$t('start_time')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <VueCtkDateTimePicker
                          v-if="showScheduleEditModal"
                          ref="TimePickerStartTime"
                          v-model="scheduleEditStartTime"
                          style="font-size: 1.5rem; font-weight: bold;"
                          :no-header="true" 
                          :only-time="true" 
                          :inline="true" 
                          :format="'HH:mm'"
                          :formatted="'HH:mm'"
                          :no-label="true"
                          :input-size="lg"
                          :no-button-now="true"
                          :noClearButton="true">
                        </VueCtkDateTimePicker>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col">
                <table class="table custom-table" style="font-size: 1rem; font-weight: bold;">
                  <thead>
                    <tr>
                      <th>{{$t('end_time')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <VueCtkDateTimePicker
                          v-if="showScheduleEditModal"
                          ref="TimePickerEndTime"
                          v-model="scheduleEditEndTime"
                          style="font-size: 1.5rem; font-weight: bold;"
                          :no-header="true" 
                          :only-time="true" 
                          :inline="true" 
                          :format="'HH:mm'"
                          :formatted="'HH:mm'"
                          :no-label="true"
                          :input-size="lg"
                          :no-button-now="true"
                          :noClearButton="true">
                        </VueCtkDateTimePicker>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div>
            <b-input-group class="d-flex p-2 bd-highlight custom-padding">
              <b-button class="custom-b-button" variant="primary" @click="popDatePickerModal()"><i class="fa fa-calendar"></i></b-button>
              <b-form-input v-model="DatePickerInputValue" @click="popDatePickerModal()" readonly></b-form-input> 
            </b-input-group>
          </div>
          <div class="container-fluid custom-padding">
            <div class="row">
              <div class="col custom-padding">
                <table class="table custom-table-for-week">
                  <thead>
                    <tr>
                      <th>
                        <div class="device-clickable-text" :class="{'clicked': scheduleEditSelectedWeeks[1]}" @click="handleWeekClick(1)">{{$t('device.sun')}}</div>
                      </th>
                      <th> 
                        <div class="device-clickable-text" :class="{'clicked': scheduleEditSelectedWeeks[2]}" @click="handleWeekClick(2)">{{$t('device.mon')}}</div>
                      </th>
                      <th>
                        <div class="device-clickable-text" :class="{'clicked': scheduleEditSelectedWeeks[3]}" @click="handleWeekClick(3)">{{$t('device.tue')}}</div>
                      </th>
                      <th>
                        <div class="device-clickable-text" :class="{'clicked': scheduleEditSelectedWeeks[4]}" @click="handleWeekClick(4)">{{$t('device.wed')}}</div>
                      </th>
                      <th>
                        <div class="device-clickable-text" :class="{'clicked': scheduleEditSelectedWeeks[5]}" @click="handleWeekClick(5)">{{$t('device.thu')}}</div>
                      </th>
                      <th>
                        <div class="device-clickable-text" :class="{'clicked': scheduleEditSelectedWeeks[6]}" @click="handleWeekClick(6)">{{$t('device.fri')}}</div>
                      </th>
                      <th>
                        <div class="device-clickable-text" :class="{'clicked': scheduleEditSelectedWeeks[7]}" @click="handleWeekClick(7)">{{$t('device.sat')}}</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-modal>

    <b-modal :title="$t('device.select_date')" v-model="showDatePickerModal" :hide-footer="true" :hide-header="false">
      <div>
        <VueCtkDateTimePicker
          v-if="showDatePickerModal"
          v-model="datePickerSelectedDate"
          :locale="zh-TW"
          :no-header="true"
          :only-date="true" 
          :inline="true" 
          :format="'YYYY-MM-DD'"
          :formatted="'YYYY-MM-DD'"
          :min-date="scheduleMinDate"
          :no-button-now="true"
          :button-now-translation="$t('device.today')"
          :noClearButton="true">
        </VueCtkDateTimePicker>
      </div>
      <div class="col-xs-12 col-md-12 text-center mt-3">
        <b-button variant="primary" class="top-up-btn-sm" @click="DatePickerConfirm()">{{$t('confirm')}}</b-button>
      </div>
    </b-modal>

    <b-modal :title="$t('device.chargingStationsList')" v-model="showLastChargingStationsModal" :hide-footer="true" :hide-header="false" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <!--<b-alert :show="showTopUpModal" variant="warning" class="text-center"><i class="fa fa-exclamation-triangle"></i>{{$t('device.choose_payment_method')}}</b-alert>-->
      <div class="row">
        <div v-for="(last_charging_station, index) in last_charging_stations" class="col-xs-12 col-md-12 text-center mb-2">
          <b-button variant="light" class="select-payment-btn-left" @click="gotoLastChargingStation(last_charging_station.sn)">{{last_charging_station.name}}</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      :title="$t('device.loginExpiredTitle')"
      size="sm"
      v-model="showLoginExpiredModal"
      :ok-title="$t('ok')"
      ok-only="true"
      :hide-footer="false"
      :hide-header="false"
      :hide-header-close="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      centered
      body-class="p-4 text-center"
      header-class="bg-primary text-white text-center"
      footer-class="d-flex justify-content-center border-0"
      @ok="loginExpired"
    >
      <div style="text-align: center; font-size: 1.2rem;color: #156e06;">
        {{$t('device.loginExpiredMessage')}}
      </div>
    </b-modal>

    <b-modal
      :title="$t('device.overChargingTimeLimitMinuteTitle')"
      size="sm"
      v-model="showOverChargingTimeLimitMinuteModal"
      :ok-title="$t('ok')"
      ok-only="true"
      :hide-footer="false"
      :hide-header="false"
      :hide-header-close="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      centered
      body-class="p-4 text-center"
      header-class="bg-primary text-white text-center"
      footer-class="d-flex justify-content-center border-0"
    >
      <div style="text-align: center; font-size: 1.2rem;color: #156e06;">
        {{$t('device.overChargingTimeLimitMinuteMessage', { value: formatDuration(charging_time_limit_minutes)})}}
      </div>
    </b-modal>

		<div class="hidden" id="tmp-form"></div>
	</div>
</template>
<script>
import VueNotifications from 'vue-notifications'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import io from 'socket.io-client'
import moment from 'moment-timezone'
import _ from 'lodash'
import { BrowserQRCodeReader } from '@zxing/library';
import { isNull } from '../../public/js/browserMqtt'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

const codeReader = new BrowserQRCodeReader();

let $socket  = null;
let scanner  = null;
let eventbus = config.eventbus;

const mail_format_check = (value) => {
  //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(value || '');
};

const invoice_carrier_check = (value) => {
  const invoiceCarrierRegex = /^\/[0-9A-Z+.-]{7}$/;
  return invoiceCarrierRegex.test(value || '');
};

let getUrlParameter = function getUrlParameter(url) {
  let sPageURL = url.substring(url.indexOf('?')+1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i,
      rlt={};

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      rlt[sParameterName[0]] = sParameterName[1];
  }

  return rlt;
};//eo getUrlParameter

const generateRandomToken = () => {
  // 使用 36 進位，並串接兩個隨機數來增加長度
  const part1 = Math.random().toString(36).slice(2).toUpperCase();
  const part2 = Math.random().toString(36).slice(2).toUpperCase();
  const part3 = Math.random().toString(36).slice(2).toUpperCase();
  return `${part1}${part2}${part3}`; 
};

let get_latest_charging_record = function(app){
  let action = `${config.mqtt_root}/get_latest_charging_record`;
  fetch(action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + app.$state.$get('user').token
    },
    body: JSON.stringify({
      user_id:   encodeURIComponent(app.$state.$get('user').uuid),
      device_id: encodeURIComponent(app.uuid),
      keyset: 'mqtt',
    })
  }).then(res => res.json()).then(charging_record => {
    // console.info('get_latest_charging_record:', charging_record);
    app.charging_record = charging_record.record;

    app.show_device_occupied = false;
    if(charging_record.flag){
      app.show_device_occupied = true;
      app.show_mqtt            = false;
      app.show_init_spinning   = false;
      return;
    }

    if(charging_record.success && charging_record.record){
      app.start_time      = charging_record.record.start_time;
      app.end_time        = charging_record.record.end_time;

      if(charging_record.record.status === 'end'){
        app.record            = {};
        app.record.used_watts = charging_record.record.used_watts;
        app.record.interval   = Math.round(charging_record.record.interval/3600);
      } else {
        //console.info('[get_latest_charging_record] charging_record.charging_info: ', charging_record.charging_info);
        let new_reward = 0.0;
        if(charging_record.charging_info) {
          app.current_used_time = Math.ceil(charging_record.charging_info.used_time/60);
          app.current_used_time_peak = Math.ceil(charging_record.charging_info.used_time_peak/60);
          app.total_used_time = app.current_used_time + app.current_used_time_peak;
          app.current_used_time_idle = Math.floor(charging_record.charging_info.used_time_idle/60);
          app.current_used_watts = charging_record.charging_info.used_watts;
          app.current_used_watts_peak = charging_record.charging_info.used_watts_peak;
          app.total_used_watts = (charging_record.charging_info.used_watts * 1) + (charging_record.charging_info.used_watts_peak * 1);
          app.total_pay = charging_record.charging_info.total_pay;
          app.total_pay_peak = charging_record.charging_info.total_pay_peak;
          app.total_pay_idle = charging_record.charging_info.total_pay_idle;
          app.total_price = charging_record.charging_info.total_pay + charging_record.charging_info.total_pay_peak + charging_record.charging_info.total_pay_idle;

          //get valid reward percentage
          if(app.available_reward_members) {
            let start_time_unix = result.charging_info.start_time ? moment.unix(result.charging_info.start_time).tz(config.timezone) : moment().tz(config.timezone);
            for(let idx = 0; idx < app.available_reward_members.length; idx++) {
              let member = app.available_reward_members[idx];
              let validity_period_date = member.validity_period_date ? moment.tz(member.validity_period_date, config.timezone) : null;
              let validity_period_date_start = member.validity_period_date_start ? moment.tz(member.validity_period_date_start, config.timezone) : null;
              if(validity_period_date_start && validity_period_date_start.isAfter(start_time_unix)) {
                continue;
              }
              if(validity_period_date && validity_period_date.isSameOrAfter(start_time_unix)) {
                if(member.reward > new_reward) {
                  new_reward = member.reward;
                }
              }
            }
          }
        }
        app.reward = new_reward;
      }
    }
  }).catch(error => {
  });
};//eo get_latest_charging_record

let get_user_latest_charging_record = function(app){
  if (!app.$state.$get('user')) {
    window.location.href = '/';
    return;
  }

  let action = `${config.mqtt_root}/get_user_latest_charging_record`;
  fetch(action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + app.$state.$get('user').token
    },
    body: JSON.stringify({
      user_id: encodeURIComponent(app.$state.$get('user').uuid),
      keyset: 'mqtt',
    })
  }).then(res => res.json()).then(charging_record => {
    app.last_charging_stations = [];
    //console.info('get_user_latest_charging_record:', charging_record);
    if(charging_record.success) {
      if(charging_record.last_charging_stations){
        app.last_charging_stations = charging_record.last_charging_stations;
      }

      if(charging_record.record && (charging_record.record.status === 'start' || charging_record.record.status === 'stop')){
        // app.charging_record = charging_record.record;
            
        let uuid = config.encrypt(''+charging_record.record.deviceid, config.ffkey, config.ffiv);
        
        app.$state.$set('uuid', uuid);
        app.uuid = uuid;
        
        //Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
        let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
            uuid: uuid
        });

        window.location = href;
        location.reload();
      }
    }
  }).catch(error => {

  });
};//eo get_user_latest_charging_record

let get_balance = function(app){
    let user = app.$state.$get('user');
    let action = `${config.mqtt_root}/read_balance`;
    fetch(action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.token
      },
      body: JSON.stringify({
        device_id: app.uuid ? app.uuid : 0,
        user_id: user.uuid,
      })
    }).then(res => res.json()).then(result => {
      // console.info('read_balance:', result);
      if(result.success){
          app.balance = parseInt(result.user.credits);
          app.bonus = parseInt(result.user.bonus);
          
          user.credits = result.user.credits;
          user.bonus = result.user.bonus;
          app.isDemo = result.user.demo;

          //Save newest app.isDemo info.
          app.$state.$set('isDemo', app.isDemo);

          if (!user.email && result.user.email) {
            user.email = result.user.email;
          }

          if ((!app.buyeremail || app.buyeremail.indexOf('@') === -1) && result.user.email && !app.showTopUpModal) {
            app.buyeremail = result.user.email;
          }

          if (!app.invoice_carrier && result.user.invoice_carrier && !app.showInvoiceCarrierModal) {
            app.invoice_carrier = result.user.invoice_carrier;
            // console.info(`app.invoice_carrier: ${app.invoice_carrier}`);
          }

          if (result.user.invoiceno_enable) {
            app.auto_invoiceno = true;
            // console.info(`app.auto_invoiceno: ${app.auto_invoiceno}, result.user.invoiceno_enable: ${result.user.invoiceno_enable}`);
          } else {
            app.auto_invoiceno = false;
          }

          if (!app.buyername && result.user.invoiceno_name && !app.showTopUpModal && !app.showInvoiceNoModal) {
            app.buyername = result.user.invoiceno_name;
            // console.info(`app.buyername: ${app.buyername}, result.user.name: ${result.user.name}`);
          }

          if (!app.buyerubn && result.user.invoiceno && !app.showTopUpModal && !app.showInvoiceNoModal) {
            app.buyerubn = result.user.invoiceno;
          }

          if (result.user.name && result.user.name !== '匿名使用者') {
            user.name = result.user.name;
            user.username = result.user.name;
            jQuery('#username-placeholder').html(user.username);
          }

          // console.info('available_cards - 0: ', app.available_cards, result.user.cards);
          if (result.user.cards && (app.available_cards.length != result.user.cards.length)) {
            // console.info('available_cards: ', app.available_cards);
            app.available_cards = result.user.cards;
          } else if (!result.user.cards) {
            app.available_cards = [];
          }

            //console.info('available_line - 0: ', app.available_line ,app.available_line.length,  result.user.line);
          if (result.user.line && (app.available_line.length != result.user.line.length)) {
            //console.info('available_line: ', app.available_line);
            app.available_line = result.user.line;
          } else if (!result.user.line) {
            app.available_line = [];
          }

          let need_update_device_info = false;
          if (result.user.car_members && (app.available_car_members.length != result.user.car_members.length)) {
            app.available_car_members = result.user.car_members;
            need_update_device_info = true;
          } else if (!result.user.car_members) {
            if(app.available_car_members.length > 0) {
              need_update_device_info = true;
            }
            app.available_car_members = [];
          }

          if (result.user.members && (app.available_members.length != result.user.members.length)) {
            app.available_members = result.user.members;
            need_update_device_info = true;
          } else if (!result.user.members) {
            if(app.available_members.length > 0) {
              need_update_device_info = true;
            }
            app.available_members = [];
          }

          if(need_update_device_info) {
            app.$nextTick(() => {
              get_device_info(app, app.uuid);
            });
          }

          if (result.user.plug_and_charge && (app.available_plug_and_charge.length != result.user.plug_and_charge.length)) {
            // console.info('available_plug_and_charge: ', app.available_plug_and_charge);
            app.available_plug_and_charge = result.user.plug_and_charge;
          } else if (!result.user.plug_and_charge) {
            app.available_plug_and_charge = [];
          }

          if (result.user.rfid_charge && (app.available_rfid_charge.length != result.user.rfid_charge.length)) {
            // console.info('available_rfid_charge: ', app.available_rfid_charge);
            app.available_rfid_charge = result.user.rfid_charge;
          } else if (!result.user.rfid_charge) {
            app.available_rfid_charge = [];
          }

          if (result.user.schedules) {
            //console.info('schedules: ', result.user.schedules);
            app.available_schedules = result.user.schedules;
            app.available_schedules.forEach((schedule, index) => {
              schedule.name = schedule.Device ? schedule.Device.name : app.$t('unknow_device');
              schedule.start_time = schedule.start_time.substring(0, 5);
              schedule.end_time = schedule.end_time.substring(0, 5);    
            });
          } else if (!result.user.schedules) {
            app.available_schedules = [];
          }
          //console.info('available_schedules: ', app.available_schedules);

          //console.info('[get_balance] result.charging_info: ', result.charging_info);
          let new_reward = 0.0;
          if(result.charging_info) {
            app.current_used_time = Math.ceil(result.charging_info.used_time/60);
            app.current_used_time_peak = Math.ceil(result.charging_info.used_time_peak/60);
            app.total_used_time = app.current_used_time + app.current_used_time_peak;
            app.current_used_time_idle = Math.floor(result.charging_info.used_time_idle/60);
            app.current_used_watts = result.charging_info.used_watts;
            app.current_used_watts_peak = result.charging_info.used_watts_peak;
            app.total_used_watts = (result.charging_info.used_watts * 1) + (result.charging_info.used_watts_peak * 1);
            app.total_pay = result.charging_info.total_pay;
            app.total_pay_peak = result.charging_info.total_pay_peak;
            app.total_pay_idle = result.charging_info.total_pay_idle;
            app.total_price = result.charging_info.total_pay + result.charging_info.total_pay_peak + result.charging_info.total_pay_idle;

            //get valid reward percentage
            if(app.available_reward_members) {
              let start_time_unix = result.charging_info.start_time ? moment.unix(result.charging_info.start_time).tz(config.timezone) : moment().tz(config.timezone);
              for(let idx = 0; idx < app.available_reward_members.length; idx++) {
                let member = app.available_reward_members[idx];
                let validity_period_date = member.validity_period_date ? moment.tz(member.validity_period_date, config.timezone) : null;
                let validity_period_date_start = member.validity_period_date_start ? moment.tz(member.validity_period_date_start, config.timezone) : null;
                if(validity_period_date_start && validity_period_date_start.isAfter(start_time_unix)) {
                  continue;
                }
                if(validity_period_date && validity_period_date.isSameOrAfter(start_time_unix)) {
                  if(member.reward > new_reward) {
                    new_reward = member.reward;
                  }
                }
              }
            }
          }
          app.reward = new_reward;

          //console.log('open_time: ', JSON.stringify(result.open_time));
          if(result.open_time) {
            if(result.open_time.open_times) {
              app.available_open_times = result.open_time.open_times;
            } else {
              app.available_open_times = [];
            }
            app.available_open_times.forEach(open_time => {
              app.holiday_close |= open_time.holiday_close;
            });
            app.isOpenTime = result.open_time.is_open_time;

          } else {
            app.available_open_times = [];
            app.holiday_close = false;
            app.isOpenTime = true;
          }

          if(result.user && result.user.credit_card_removed_notify) {
            console.info(`credit_card_removed_notify: ${result.user.credit_card_removed_notify}`);
            app.showCreditCardRemovedModal = true;
            app.credit_cards_removed_message = `信用卡檢查錯誤，請重新綁定信用卡。`;
          }

          app.is_peak_time = result.is_peak_time ? result.is_peak_time : 0;
          app.charging_time_limit_minutes = result.charging_time_limit_minutes ? result.charging_time_limit_minutes : app.DefaultChargingTimeLimitMinutes;

          // console.info(`user: `, user);
          if(app.isDemo === 'YES' || (app.balance + app.bonus) > 0 || app.available_cards.length > 0 || app.available_line.length > 0 || app.available_car_members.length > 0 || app.available_members.length > 0 ){
              user.card_id = 'YES';
              app.showTopUpModal = false;
              app.showPaymentModal = false;
              app.showCreditCardORLINEPayModal = false;
              app.showCarMemberRegisterModal = false;
          } else if (app.device_record.charge_value
                      && (app.balance + app.bonus) < app.device_record.charge_value
                      && app.available_cards.length === 0
                      && app.available_line.length === 0) {
              app.showPaymentModal = true;
              // console.info('#1...');
              app.showTopMsg = app.$t('device.not_enough_points', { points: (app.balance+app.bonus) });
          } else {
              app.showPaymentModal = true;
              // console.info('#2...');
              app.showTopMsg = app.$t('device.not_enough_points', { points: (app.balance+app.bonus) });
          }
          
          //console.info(`Device get_balance set user.uuid: ${user.uuid}`);
          app.$state.$set('user', user);//update user
      }
    }).catch(error => {
    });
};

let get_device_info = function(app, device_id){
    
  let user = app.$state.$get('user');
  
  if(!user || !device_id){
      return;
  }

  let action = `${config.mqtt_root}/get_device_info`;
  fetch(action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + app.$state.$get('user').token
    },
    body: JSON.stringify({
      user_id: user.uuid,
      device_id,
      keyset: 'mqtt',
    })
  }).then(res => res.json()).then(device_record => {
    if(device_record.success){
      //console.log('device_record.record: ', device_record.record);
      app.device_record = device_record.record; 
      app.uuid = device_id;
      if(device_record.record && device_record.record.peak_time_periods) {
        app.peak_time_periods = device_record.record.peak_time_periods;
      } else {
        app.peak_time_periods = [];
      }
      app.car_member_device = device_record.car_member.car_member_device;
      app.car_member = device_record.car_member.car_member;
      app.car_brand = device_record.car_member.car_brand;
      app.support_car_brand = device_record.car_member.support_car_brand;
      if(device_record.car_member.car_members) {
        app.available_car_members = device_record.car_member.car_members;
      } else {
        app.available_car_members = [];
      }

      app.company_member_device = device_record.member.company_member_device;
      app.company_member = device_record.member.company_member;
      app.company_name = device_record.member.company_name;
      if(device_record.member.members) {
        app.available_members = device_record.member.members;
      } else {
        app.available_members = [];
      }

      if(device_record.member.reward_members) {
        app.available_reward_members = device_record.member.reward_members;
      } else {
        app.available_reward_members = [];
      }

      app.support_plug_and_charge = (device_record.record && device_record.record.plug_and_charge) ? device_record.record.plug_and_charge : false;
      app.support_rfid_charge = (device_record.record && device_record.record.rfid_charge) ? device_record.record.rfid_charge : false;
      app.support_schedulable = (device_record.record && device_record.record.schedulable) ? device_record.record.schedulable : false;

      let price = app.device_record.price_peak + app.device_record.price_idle;
      if(price <= 0.00){
        app.showPaymentModal = false;
      }

      // console.log('device_record.record: ', device_record.record);
      //console.log('open_time: ', JSON.stringify(device_record.open_time));
      if(device_record.open_time) {
        if(device_record.open_time.open_times) {
          app.available_open_times = device_record.open_time.open_times;
        } else {
          app.available_open_times = [];
        }
        app.available_open_times.forEach(open_time => {
          app.holiday_close |= open_time.holiday_close;
        });
        app.isOpenTime = device_record.open_time.is_open_time;
      } else {
        app.available_open_times = [];
        app.holiday_close = false;
        app.isOpenTime = true;
      }

      if(device_record.record && device_record.record.idle_info) {
        //console.log('device_record.idle_info: ', device_record.record.idle_info);
        let [idle_free_period, idle_interval_rate, idle_max_price] = device_record.record.idle_info.split('/');
        app.idle_free_period = idle_free_period;
        app.idle_interval_rate = idle_interval_rate;
        app.idle_max_price = idle_max_price;
      }

      if(device_record.record && device_record.record.charging_time_limit_minutes) {
        app.charging_time_limit_minutes = device_record.record.charging_time_limit_minutes;
      }
      if(device_record.record && device_record.record.low_power_cutoff_threshold != undefined) {
        app.low_power_cutoff_threshold = device_record.record.low_power_cutoff_threshold;
      }
    }
  }).catch(error => {

  });
};

//this function for auto loading demo user account when device demo='YES'
let get_device_info_n_login = function(app, device_id){
    
    app.showDemoLoadingModal = true;
    
    let action = `${config.mqtt_root}/get_device_info_plain`;
    fetch(action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + generateRandomToken()
      },
      body: JSON.stringify({
        device_id,
        keyset: 'mqtt'
      })
    }).then(res => res.json()).then(device_record => {
      if(device_record.success){//found demo user account(free charge)
        app.device_record = device_record.record;  
        if(device_record.record.user){
          //console.info(`Device get_device_info_n_login set user.uuid: ${user.uuid}`);
          app.$state.$set('user', device_record.record.user);
          //console.info('reload - 7');
          window.location.reload();
        }
      } else {
        app.showError({message:app.$t('device.error.pls_login_and_qrcode_scan')});

        if(device_id !== null) {
          app.$state.$set('uuid', device_id);
        }
        
        let _vcc = setTimeout(() => {
          app.$router.push('/');
          clearTimeout(_vcc);
        }, 1500);
      }
      // console.info('app.device_record:', app.device_record);
    }).catch(error => {
      app.showError({message:app.$t('device.error.qrcode_read_device_error')});
      console.error('cannot read device:', error);
      
      let _vcc = setTimeout(() => {
        app.$router.push('/');
        clearTimeout(_vcc);
      }, 1500);
    });
};

let user_id_token_check = function(app){   
  let user = app.$state.$get('user');

  if(!user) {
    //console.info(`user_id_token_check no user`);
    return;
  }
  //console.info(`user_id_token_check user.uuid: ${user.uuid}`);

  let action = `${config.mqtt_root}/user_id_token_check`;
  fetch(action, {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + app.$state.$get('user').token
    },
    body: JSON.stringify({
    user_id: user.uuid
    })
  }).then(res => res.json()).then(result => {
    if(result.success === false){  
      //console.info(`user_id_token_check fail`); 
      app.showError({
        title: app.$t('user_check_error_title'),
        message: app.$t('user_check_error_message')
      });
      app.$state.$del('user');
      app.$router.push('/');
    }
  }).catch(error => {
    app.showError({
      title: app.$t('user_check_error_title'),
      message: app.$t('user_check_error_message')
    });
    app.$state.$del('user');
    app.$router.push('/');
  });
};

let get_member_info = function(app){   
  let user = app.$state.$get('user');

  if(!user) {
    return;
  }

  return app.$jsonp(`${config.mqtt_root}/get_member_info`, {
    user_id: user.uuid
  }).then((result) => {
    if(result.success) {
      if(result.car_member.car_members) {
        app.available_car_members = result.car_member.car_members;
        //console.log('app.available_car_members: ', app.available_car_members);
      } else {
        app.available_car_members = [];
      }
      if(result.member.members) {
        app.available_members = result.member.members;
        //console.log('app.available_members: ', app.available_members);
      } else {
        app.available_members = [];
      }
    }
  });
};

let cards_validate_check = function(app){   
  let user = app.$state.$get('user');

  if(!user) {
    //console.info(`cards_validate_check no user`);
    return;
  }
  //console.info(`cards_validate_check user.uuid: ${user.uuid}`);

  return app.$jsonp(`${config.mqtt_root}/cards_validate_check`, {
  user_id: user.uuid
  }).then((validate_check) => {
    if(validate_check.success === true && validate_check.cards_found_invalid === true){  
      app.showPaymentModal = true;
      // console.info('#2...');
      app.showTopMsg = app.$t('device.creditcard_invalid_and_rebind');
    }
  });
};

let line_validate_check = function(app){   
  let user = app.$state.$get('user');

  if(!user) {
    //console.info(`line_validate_check no user`);
    return;
  }
  //console.info(`line_validate_check user.uuid: ${user.uuid}`);
  let action = `${config.mqtt_root}/line_validate_check`;
  fetch(action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + generateRandomToken()
    },
    body: JSON.stringify({
      user_id: user.uuid
    })
  }).then(res => res.json()).then(validate_check => {
    if(validate_check.success === true && validate_check.cards_found_invalid === true){  
      app.showPaymentModal = true;
      // console.info('#2...');
      app.showTopMsg = app.$t('device.linwpay_invalid_and_rebind');
    }
  }).catch(error => {
  });
};

function demo_device_check(app, device_id) {
  return new Promise((resolve, reject) => {
    let user = app.$state.$get('user');

    if(!user || !device_id) {//ignore check
      resolve();
    } else {
      app.$jsonp(`${config.mqtt_root}/demo_device_check`, {
        user_id: user.uuid,
        device_id
      }).then((result) => {
        if(result.success === false){  
          app.showSuccess({
            title: app.$t('device.system_check_title'),
            message: app.$t('device.system_check_message')
          });

          app.$state.$del('user'); 
        }
        resolve();
      }).catch((error) => {
        resolve();
      });//return the Promise
    }
  });
};

let get_notice = function(app, device_id){
  let user = app.$state.$get('user');

  if(!user) {
    return;
  }

  return app.$jsonp(`${config.mqtt_root}/get_notice`, {
    user_id: user.uuid,
  }).then((result) => {
    if(result.success) {
      app.showNoticeModal = true;
      app.notice_message = result.message;
    }
  });
}

export default {
	name: 'Device',
	notifications,
  components: {
    VueCtkDateTimePicker,
  },
  filters: {
    __kW(value) {
      value = Number(value) || 0;

      return (value / 1000).toFixed(2) + ' kW';
    }
  },
	data(){
    const DEFAULT_CHARGING_TIME_LIMIT_MINUTES = 2880;
    const minApplePayAmount = 100;
    const user = this.$state.$get('user');
    // console.info('user: ', user);

    const buyeremail = user && user.email ? user.email : '';

		return {
      isIphone: /iPhone|iPad|iPod/i.test(navigator.userAgent),
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      canInstall: false,   // 是否顯示安裝按鈕
      deferredPrompt: null, // 用來儲存 `beforeinstallprompt` 事件
      read_balance_timer: null,
      retry_timer: null,
      _cc2_timer: null,
      showNoticeModal: false,
      notice_message: '',
      showCreditCardRemovedModal: false,
      showLoginExpiredModal:false,
      showOverChargingTimeLimitMinuteModal:false,
      DefaultChargingTimeLimitMinutes: DEFAULT_CHARGING_TIME_LIMIT_MINUTES,
      charging_time_limit_minutes: DEFAULT_CHARGING_TIME_LIMIT_MINUTES,
      low_power_cutoff_threshold: config.cutoff_threshold,
      credit_cards_removed_message:'',
      unit_price: 1.15,
      showInvoiceCarrierModal: false,
      invoice_carrier_invalid: false,
      invoice_carrier_invalid_msg: '',
      new_invoice_carrier: '',
      invoice_carrier: '',
      top_up_invalid: false,
      top_up_invalid_msg: '',
      credit_card_linepay_invalid: false,
      credit_card_linepay_invalid_msg: '',
      isDemo: 'YES',
      isOpenTime: true,
      isChecked_used: false,
      isChecked_pay: false,
      isChecked_charge_fee: false,
      isChecked_idle_fee: false,
      available_open_times: [],
      holiday_close: false,
			show_qrcode_canvas: false,
			show_device_occupied: false,
			show_scan_qrcode_msg: false,
      show_account_balace: true,
			record: null,
			start_time:'',
			end_time:'',
			count_down:0,
			disable_btns: false,
			show_init_spinning: true,
			show_init_msg: false,
			show_mqtt: false,
			uuid: null,
			device_id: null,
			device_record: {},
      last_charging_stations: [],
			showErrorModal: false,
			showLoadDetectorModal: false,
      force_shutdown_detector: false,
      showTopUpModal: false,
      showSelectPaymentModal: false,
      showSelectTopupAmountModal: false,
      showCashFlowLoadingModal: false,
      showCashCheckOutModal: false,
      showMqttErrorCheckOutModal: false,
      showCashCheckOutProcessing: false,
      showDemoLoadingModal: false,
      showCouponModal: false,
      showCreditCardModal: false,
      showCreditCardORLINEPayModal: false,
      showPaymentModal: false,
      showChargeFirstModal: false,
      showLastChargingStationsModal: false,
      checkCouponProcessing: false,
      checkCreditCartProcessing: false,
      showTopMsg: '',
			errorMsg: '',
			detectorMsg: '',
			mqtt_value: {},
      mqtt_error_code: 0,
      mqtt_error_code_detail: '',
      current_used_time: 0,
      current_used_time_peak: 0,
      total_used_time: 0,
      current_used_time_idle: 0,
			current_used_watts: 0,
      current_used_watts_peak: 0,
      total_used_watts: 0,
      total_price: 0,
      total_pay: 0,
      total_pay_peak: 0,
      total_pay_idle: 0,
      idle_free_period: 0,
      idle_interval_rate: 0,
      idle_max_price: 0,
			current_charging_time: null,
			charging_record: null,
      balance: 0,
      bonus: 0,
      deduct_bonus: 1,
      after_credits: 0,
      final_bonus: 0,
      current_bonus: 0,
      qrcode_string: '',
      price: 7,
			_cc: null,
			_lecc: null,
      cameraDevices: [],
      couponsn: '',
      buyerubn: '',
      buyername: '',
      buyeremail,
      use_invoiceno: false,
      new_buyerubn_topup: '',
      new_buyername_topup: '',
      new_buyerubn_cl: '',
      new_buyername_cl: '',
      new_buyerubn_am: '',
      new_buyername_am: '',
      invoice_no_invalid: false,
      invoice_no_invalid_msg: '',
      isApplePayOkay: false,
      applePayAmount: minApplePayAmount,
      minApplePayAmount,
      cardno: '',
      carddate: '',
      cardcvs: '',
      cardemail: '',
      cardnoinvalid: false,
      carddateinvalid: false,
      cardcvsinvalid: false,
      cardemailinvalid: false,
      creditCartCheckingResult: null,
      creditCartCheckingSuccess: false,
      showUpdateUserEmail: false,
      available_cards: [],
      available_line: [],
      prepayChargeMsg: null,
      chargeBtnClicked: false,
      show_device_disconnected: false,
      stopRetry: false,
      payment_method: 0,
      topup_amount_select: 0,
      is_peak_time: 0,
      peak_time_periods:[],
      car_member_device: false,
      car_member: false,
      car_brand: '',
      support_car_brand: '',
      available_car_members: [],
      car_member_cardno: '',
      car_member_cardnoinvalid: false,
      showCarMemberRegisterModal: false,
      CarMemberRegisterProcessing: false,
      CarMemberRegisterResult: null,
      CarMemberRegisterSuccess: false,
      CarMemberRegisterErrorCount: 0,
      linePayCheckBox: 'accepted',
      linepayemail: '',
      linepayemailinvalid: false,
      showLinePayModal: false,
      company_member_device: false,
      company_member: false,
      company_name: '',
      available_members: [],
      available_reward_members: [],
      reward: 0.0,
      support_plug_and_charge: false,
      available_plug_and_charge:[],
      showPlugAndChargeModal: false,
      PlugAndChargeIdTagBinded: false,
      PlugAndChargeIdTag: '',
      PlugAndChargeErrorMsg: '',
      support_rfid_charge: false,
      available_rfid_charge:[],
      showRfidChargeModal: false,
      RfidChargeIdTagBinded: false,
      RfidChargeIdTag: '',
      RfidChargeErrorMsg: '',
      auto_invoiceno: false,
      auto_invoiceno_cl: false,
      showInvoiceNoModal: false,
      support_schedulable: false,
      scheduleMinDate: '2023-01-01',
      showDatePickerModal: false,
      datePickerSelectedDate: null,
      showScheduleEditModal: false,
      scheduleSelected: null,
      scheduleEditTitle: '',
      scheduleEditProcessing: false,
      scheduleEditDate: null,
      scheduleEditWeekly: 0,
      scheduleEditStartTime: '12:30',
      scheduleEditEndTime: '12:30',
      DatePickerInputValue: '',
      scheduleEditSelectedWeeks: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false, 
      },
      CHARGER_STATUS: {
        CHARGER_STATUS_UNKNOW: 0,
        CHARGER_STATUS_AVAILABLE: 1,
        CHARGER_STATUS_PREPARING: 2,
        CHARGER_STATUS_CHARGING: 3,
        CHARGER_STATUS_SUSPENDED_EVSE: 4,
        CHARGER_STATUS_SUSPENDED_EV: 5,
        CHARGER_STATUS_FINISHING: 6,
        CHARGER_STATUS_RESERVED: 7,
        CHARGER_STATUS_UNAVAILABLE: 8,
        CHARGER_STATUS_FAULTED: 9,
      },
      available_schedules:[],
      ignore_schedules_refresh: false,
      _available_schedules: [
        {id: 1, device_id: 151, name: '世界島MP3-8_T_B3-229', date: null, weekly: 127, enable: false, start_time: '10:30', end_time: '13:40'},
        {id: 2, device_id: 151, name: '麗寶國際停車場100號', date: '2023-11-07', weekly: 0, enable: false, start_time: '14:00', end_time: '20:00'},
        {id: 3, device_id: 151, name: 'EtreegoTest10', date: null, weekly: 36, enable: false, start_time: '23:30', end_time: '01:00'},
        {id: 4, device_id: 151, name: 'EtreegoTest11', date: '2023-11-08', weekly: 0, enable: true, start_time: '00:00', end_time: '12:00'},
        {id: 5, device_id: 151, name: 'EtreegoTest12', date: '2023-11-09', weekly: 0, enable: true, start_time: '17:30', end_time: '03:00'},
      ]
		}
	},//eo data
  created(){
		let app = this;

		app.$on('qrcodeDetected', function(result){
			// console.info('qr result:', result);
			
      app.$emit('reveived-qrcode', result);
			app.show_qrcode_canvas = false; 
			app.showErrorModal     = false;

			let params = getUrlParameter(result);
   
      // console.info('params:', params);

			if(params && params.uuid){
        app.uuid = decodeURIComponent(params.uuid);
				app.$state.$set('uuid', app.uuid);

        //Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
				let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
					uuid: app.uuid
				});
				// console.info('href:', href);

				window.location = href;

				location.reload();
			}
		});

		/*if(location.hash){
			//fetch Device record
			let url_params = getUrlParameter(location.hash); 

			if(url_params.uuid){
				get_device_info(app, url_params.uuid);
			}
		}*/

		// console.info('location:', );
	},
	updated(){
		// console.info('updated...');
	},
	mounted() {
		let app = this;

    jQuery('.app').css({background:'black'});

    eventbus.$on('start-qrcode-scanning', app.openQrCodeScanner);
    
    app.uuid = this.$route.query.uuid || null;

    //Loading newest app.isDemo info(default set YES).
    app.isDemo = this.$state.$get('isDemo') ? this.$state.$get('isDemo') : 'YES';

    // 監聽 `beforeinstallprompt` 事件
    if (window._beforeInstallPrompt) {
      // 如果事件已經發生，直接處理
      this.handleBeforeInstallPrompt(window._beforeInstallPrompt);
    }
    // 監聽 beforeinstallprompt 事件
    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);

    // console.info('Okay...');

    // let __reload = setInterval(() => {
    //   if (this.mqtt_value.value3) {
    //     window.location.reload(true);
    //   }
    // }, 180000); // every 3 mins

    //Added force logout to avoid user.user_id encrypt with wrong iv/key when backend server restarting.
    user_id_token_check(app);
    get_member_info(app);
    
    let url_params = getUrlParameter(location.hash);
    //console.info('url_params.uuid:', url_params.uuid); 

    // location.hash is a property that contains the part of the URL that comes after the # symbol. 
    // When the URL includes the # symbol, location.hash will return the content after the # symbol.
    // ex: URL is https://iot.innoknight.com/#/dashboard/showdevice?uuid=GubHR0uaVxch85LSTecd1g%3D%3D
    //     location.hash is /dashboard/showdevice?uuid=GubHR0uaVxch85LSTecd1g%3D%3D
    if(location.hash){
      if(url_params.uuid){ //QRcode scan done and user already login before will come here.
        app.uuid = decodeURIComponent(url_params.uuid);
      } else if(this.$state.$get('uuid')){//QRcode scan done and user not login before will come here.
        app.uuid = this.$state.$get('uuid');
      } else { //Only user login done but not scan any QRcode. Reload last charging record if record exist.
        get_user_latest_charging_record(app);
      }
    }

    if(app.uuid === null){
      let predefinded_uuid = this.$state.$get('uuid');
      if(predefinded_uuid){
        app.uuid = predefinded_uuid;
        
        //write the UUID back to URL
        //Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
        if(this.$route.query.uuid === undefined){
          location.href += '?' + jQuery.param({
            uuid: app.uuid
          });
        }
                
        this.$route.query.uuid = predefinded_uuid;
      }
    }
    
    get_device_info(app, app.uuid);
    demo_device_check(app, app.uuid).then(()=>{
      let user  = this.$state.$get('user');
      let token = user ? this.$state.$get('user').token : null;
      
      if(!token){   
        // Auto loading demo account
        get_device_info_n_login(app, app.uuid);
      } else {
        // console.info(`user.name: ${user.name}`);
        /*if (user && user.name && user.name !== '匿名使用者') {
          this.buyername = user.name;
        }*/
        //console.info(`Device user.uuid: ${user.uuid}`);

        //========== PWA 機制 ======================
        // 確保 manifest.json 的 URL 總是最新的
        const timestamp = Date.now();
        const manifestUrl = `/backend/api/manifest.json?uuid=${encodeURIComponent(app.uuid)}&t=${timestamp}`;
        // 動態加載 manifest.json
        const link = document.createElement("link");
        link.rel = "manifest";
        link.href = manifestUrl;
        document.head.appendChild(link);

        // 記錄 uuid 到 localStorage
        localStorage.setItem("uuid", this.uuid);

        // 針對 iPhone 解決 start_url 失效問題
        if(this.isIphone) {
          /*this.showSuccess({
            title: "我是IPHONE",
            message: "我是IPHONE",
            duration: 10000
          });*/

          if (window.navigator.standalone) {
            // PWA 已經安裝，避免再次顯示安裝提示
          } else {
            // 提示用戶如何安裝 PWA
            if(this.isSafari) {
              this.canInstall = true;
            }
          }
          
          window.onload = () => {
            const savedUuid = localStorage.getItem("uuid");
            if (savedUuid) {
              localStorage.removeItem("uuid");
              window.location.href = `/#/dashboard/showdevice?uuid=${savedUuid}`;
            }
          };
        }
        //========== PWA 機制 ======================

        if (user && user.email) {
          this.buyeremail = user.email;
        }

        cards_validate_check(app);
        line_validate_check(app);
        get_balance(app);
        app.readBalance();
        get_notice(app);
        
        if(!user.card_id){
            
            let credits = parseFloat(user.credits);
            
            if(credits.toFixed(2) === '0.00' && app.available_cards.length === 0){
                // app.showPaymentModal = true;
                // app.showTopMsg = '您目前尚未綁定信用卡，請透過下列儲值後綁定';
            }
        } else {
            app.show_account_balace = true;
            app.balance = parseInt(user.credits);
            app.bonus = parseInt(user.bonus);
        }

        if(app.uuid === null){ 
          app.errorMsg = app.$t('please_qrcode_scanning');
          app.show_scan_qrcode_msg = true;
          
          return;
        } else {
          app.show_scan_qrcode_msg = false;
        }
            
        let device_id = '';

        try{
          device_id = config.decrypt(app.uuid, config.ffkey, config.ffiv);
        } catch (exp) {
          this.showError({
            title: this.$t('device.error.system_error'),
            message: this.$t('device.error.device_can_not_check')
          });

          this.$state.$del('user');
          this.$state.$del('uuid');
          this.$router.push('/');
          return;
        }

        get_latest_charging_record(app);
        
        app.device_id = device_id;

        /*var _check_mqtt_err_code = setInterval(() => {
          if (app.mqtt_error_code) {
            clearInterval(_check_mqtt_err_code);

            if(app.mqtt_error_code === 1000) {
              app.showLoadDetectorModal = false;
              app.force_shutdown_detector = true;

              //stop charging
              app.showMqttErrorCheckOutModal = true;
              let __stop_charging = setTimeout(() => {
                app.doCheckOut(1);
                clearTimeout(__stop_charging);
              }, 1000);
            }
            
            //reset error code to 0
            app.mqtt_error_code = 0;
          }
        }, 10000);*/

        $socket = io(config.socket_entry, {
          // 'force new connection': true,
          // transports: ['websocket'],
          upgrade: true,
          rememberUpgrade: true,
          forceNode: true,
        });

        // console.info('config.socket_entry:', config.socket_entry);
        
        $socket.on('connect', () => {
          app.show_init_msg = true;
        });

        $socket.on('mqtt_socket_connected', (data) => {
          // console.info('mqtt_socket_connected:', data);
          // $socket.emit('mqtt_socket', {message:'from client'});
          if(this.retry_timer) {
            clearTimeout(this.retry_timer);
            this.retry_timer = null;
          }

          this.retry_timer = setTimeout(() => {
            if (window.location.search
                && window.location.search.indexOf('retry') !== -1) {
              url_params = getUrlParameter(window.location.search); 
            }

            let retryCount = url_params.retry ? parseInt(url_params.retry) : 0;
            const togo = retryCount < 2 && !this.stopRetry;
            // console.info(`retryCount: ${retryCount}, this.stopRetry: ${this.stopRetry}, togo: ${togo}`);
            if (togo) {
              // console.info(window.location);
              retryCount++;
              window.location.href = `${window.location.origin}#/dashboard/showdevice?retry=${retryCount}`;
              setTimeout(() => {
                //console.info('reload - 8');
                window.location.reload(true);
              }, 1200);
              // console.info(`${window.location.origin}?retry=${retryCount}&cache=${cache}`);
            }
          }, 120000);

          let __vcc = setTimeout(() => {
            $socket.emit('mqtt_socket', {
              type: 'mqtt-response',
              token: app.$state.$get('user').token,
              device_id: app.device_id,
              uuid: app.$state.$get('user').uuid,
            });

            let __vcc2 = setTimeout(() => {
              if (app.show_scan_qrcode_msg === false && app.show_mqtt === false && app.show_device_occupied === false) { // device disconnected
                app.show_init_spinning = false;
                app.show_device_disconnected = true;
              }
              clearTimeout(__vcc2);
            }, 60000);

            clearTimeout(__vcc);
          }, 1000);

          // let __vcc2 = setTimeout(() => {
          //   $socket.emit('mqtt_socket', {
          //     type: 'mqtt-response',
          //     token: app.$state.$get('user').token,
          //     device_id: app.device_id,
          //     uuid: app.$state.$get('user').uuid,
          //   });
          //   clearTimeout(__vcc2);
          // }, 15000);
        });

        let count_second = 60;
        //let had_sent_query = false;

        // setInterval(() => {
        //   $socket.emit('hi');
        // }, 5000);
            
        $socket.on('mqtt_connected', (data) => {
                
          /*if(!had_sent_query){
            // console.info('send query...');
            $socket.emit('mqtt_socket', {
              type: 'mqtt-query',
              token: app.$state.$get('user').token,
              device_id: app.uuid,
              uuid: app.$state.$get('user').uuid,
            });
            had_sent_query = true;
          }*/
          
          // console.info('data received...');

          if(data.message.indexOf('&') !== -1){
            let parsed = config.mqtt_msg_parser(data.message);

            // console.info(`parsed.deviceid: ${parsed.deviceid}, device_id: ${device_id}`);
                    
            if(parsed.deviceid === device_id){

              // console.info('device_id:', device_id, 'parsed: ', parsed);
              // console.info('device_id:', device_id);

              if(app._cc !== null){
                clearInterval(app._cc);
              }

              if (app.mqtt_value.value3 !== parsed.value3) {
                get_latest_charging_record(app);
              }
              app.mqtt_value = parsed;
              app.show_device_disconnected = false;

              if(app.show_device_occupied){
                return;
              }

              // if (app.mqtt_value.value3 === 1 && parsed.value3 === 0) {
              //   console.info('reload - 1');
              //   window.location.reload(true);
              //   return;
              // }

              //Received charging finish whem load detector is working. close load detector modal.
              if(app.showLoadDetectorModal && parsed && parsed.status) {
                if(parsed.status == app.CHARGER_STATUS.CHARGER_STATUS_FINISHING) {
                  app.showLoadDetectorModal = false;
                  app.force_shutdown_detector = true;
                }
              }

              if(parsed.err_code) {
                app.mqtt_error_code = parseInt(parsed.err_code);
                if(app.mqtt_error_code === 1000) { //ErrorCode 1000 is OCPP server remote start transaction fail.
                  app.mqtt_error_code_detail = app.$t('device.can_not_start_charger', {mqtt_error_code:app.mqtt_error_code}); 
                } else if(app.mqtt_error_code === 1002) { //ErrorCode 1002 is EMS power not enough.
                  app.mqtt_error_code_detail = app.$t('device.power_not_enough', {mqtt_error_code:app.mqtt_error_code}); 
                } else if(app.mqtt_error_code === 1010) { //ErrorCode 1010 is OCPP_ERROR_CODE_EMERGENCY_BUTTON_ERROR.
                  app.mqtt_error_code_detail = app.$t('device.emergency_button_error', {mqtt_error_code:app.mqtt_error_code}); 
                } else {
                  app.mqtt_error_code_detail = app.$t('device.charging_station_error_code', {mqtt_error_code:app.mqtt_error_code});
                }

                if(app.mqtt_error_code === 1000 || app.mqtt_error_code === 1002 || app.mqtt_error_code === 1010) {
                  app.showLoadDetectorModal = false;
                  app.force_shutdown_detector = true;

                  //stop charging when device is charging(mqtt_value.value3 is 1) 
                  if(app.mqtt_value && app.mqtt_value.value3) {              
                    let __stop_charging = setTimeout(() => {
                      app.doCheckOut(1);
                      clearTimeout(__stop_charging);
                    }, 10000);
                  }
                }
                app.showMqttErrorCheckOutModal = true;
                
                //reset error code to 0
                app.mqtt_error_code = 0;
              }

              if(app.support_plug_and_charge && app.showPlugAndChargeModal) {
                if(parsed.idtag && parsed.idtag.length > 0) {
                  //console.info('parsed.idtag:', parsed.idtag);
                  app.PlugAndChargeErrorMsg = '';
                  app.PlugAndChargeIdTag = parsed.idtag;
                  app.PlugAndChargeIdTagBinded = false;
                } else if(parsed.valid_car_id){
                  //console.info('parsed.valid_car_id:', parsed.valid_car_id);
                  app.PlugAndChargeErrorMsg = '';
                  app.PlugAndChargeIdTag = '';
                  app.PlugAndChargeIdTagBinded = true;
                } else if(parsed.valid_card_no){
                  //console.info('parsed.valid_card_no:', parsed.valid_card_no);
                  app.PlugAndChargeErrorMsg = '';
                  app.PlugAndChargeIdTag = '';
                  app.PlugAndChargeIdTagBinded = true;
                }
              }

              if(app.support_rfid_charge && app.showRfidChargeModal) {
                if(parsed.idtag && parsed.idtag.length > 0) {
                  //console.info('parsed.idtag:', parsed.idtag);
                  app.RfidChargeErrorMsg = '';
                  app.RfidChargeIdTag = parsed.idtag;
                  app.RfidChargeIdTagBinded = false;
                } else if(parsed.valid_card_no){
                  //console.info('parsed.valid_card_no:', parsed.valid_card_no);
                  app.RfidChargeErrorMsg = '';
                  app.RfidChargeIdTag = '';
                  app.RfidChargeIdTagBinded = true;
                }
              }

              app.show_init_spinning = false;
              app.show_mqtt          = true;
              app.disable_btns       = false;
              app.stopRetry          = true;

              if(app.retry_timer) {
                clearTimeout(app.retry_timer);
                app.retry_timer = null;
              }
              
              if(app.charging_record && parsed.value3){
                //app.current_used_watts = parsed.value2 - app.charging_record.start_watts;
                app.current_charging_time  = moment().tz(config.timezone).unix() - app.charging_record.start_time;
              } else {
                app.current_charging_time  = 0;
              }
            } else {
              
            }
          } else {

            let counter = 0;
            app.count_down = count_second;

            app._cc = setInterval(() => {

              if(app.show_mqtt){
                count_second = 999;
                clearInterval(app._cc);
                return;
              }

              // console.info('start counter:', counter);

              if(counter++ < count_second){
                app.count_down = count_second - counter;
              } else {

                clearInterval(app._cc);

                app.showError({
                  message: app.$t('device.error.device_cant_not_connect')
                });
              }

            }, 1000);
          }
        });
        
        $socket.on('update-log', (data) => {

          app.disable_btns = false;

          // app.mqtt_value.value3 = app.mqtt_value.value3 ? 0 : 1;

          if(!data.success){

            //console.info('update-log:', data);

            let msg = '';
            switch(data.message) {
              case 'unable-to-start':
                msg = app.$t('device.update-log.unable-to-start');
                break;
              case 'unable-to-finish':
                msg = app.$t('device.update-log.unable-to-finish');
                break;
              case 'no-previous-record':
                msg = app.$t('device.update-log.no-previous-record');
                break;
              case 'invalid-ownership':
                msg = app.$t('device.update-log.invalid-ownership');
                break;
              case 'demo-check-error': //fixed user/device demo check not match issue.
                msg = app.$t('device.update-log.demo-check-error');
                break;
              case 'overlap-in-3-mins':
                msg = app.$t('device.update-log.overlap-in-3-mins');
                setTimeout(() => {
                  //console.info('reload - 2');
                  window.location.reload(true);
                }, 6000);

                break;
              case 'login-expired':
                //login_expired
                clearInterval(app._cc2_timer);
                app.showLoadDetectorModal = false;
                app.showLoginExpiredModal = true;
                break;
              case 'over-charging-time-limit-minutes':
                //over-charging-time-limit-minutes
                clearInterval(app._cc2_timer);
                app.showLoadDetectorModal = false;
                app.showOverChargingTimeLimitMinuteModal = true;
                break;
              case 'invalid-uuid':
                msg = app.$t('device.update-log.invalid-uuid');
                break;
              default:
                break;
            }

            if(msg !== '') {
              app.showError({
                title: app.$t('device.error.system_response'),
                message: msg
              });
            }
          } else {
            //console.info('update-log:', data);
            let action = `${config.mqtt_root}/get_latest_charging_record`;
            fetch(action, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.$state.$get('user').token
              },
              body: JSON.stringify({
                user_id:   encodeURIComponent(this.$state.$get('user').uuid),
                device_id: encodeURIComponent(app.uuid),
                keyset: 'mqtt',
              })
            }).then(res => res.json()).then(charging_record => {
              // console.info('charging_record:', charging_record);

              if(charging_record.success){
                app.start_time = charging_record.record.start_time;
                app.end_time   = charging_record.record.end_time;

                if(charging_record.record.status === 'end'){
                  app.record            = {};
                  app.record.used_time = charging_record.record.used_time;
                  app.record.used_time_peak = charging_record.record.used_time_peak;
                  app.record.used_watts = charging_record.record.used_watts;
                  app.record.used_watts_peak = charging_record.record.used_watts_peak;
                  app.record.interval   = Math.round(charging_record.record.interval/3600);
                }
              }
            }).catch(error => {
            });
          }
        });

        /*let _rvcc = setInterval(() => {
          get_latest_charging_record(app);
        }, 180000);*/
      } 
    })
    .catch((error) => {
      console.log('error: ', error);
      app.showError({
        message: app.$t('device.error.account_check_error'),
        timeout: 15000
      });
      app.$state.$del('user'); 
      window.location.reload(true);
    });
	},//eo mounted

  beforeDestroy(){
    //console.info('beforeDestroy');
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);

    if(this._cc2_timer) {
      //console.info('LoadDetector clearTimeout');
      clearInterval(this._cc2_timer);
      this._cc2_timer = null;
    }

    if(this.read_balance_timer) {
      //console.info('read_balance_timer clearTimeout');
      clearInterval(this.read_balance_timer);
      this.read_balance_timer = null;
    }

    if(this.retry_timer) {
      clearTimeout(this.retry_timer);
      this.retry_timer = null;
    }
  },//eo beforeDestroy

	methods: {
    formatDuration(value) {
      const hours = Math.floor(value / 60);
      const minutes = Math.floor(value % 60);

      if (hours > 0) {
        if (minutes > 0) {
          return `${hours}${this.$t('hour')}${minutes}${this.$t('minute')}`;
        }
        return `${hours}${this.$t('hour')}`;
      }

      return `${minutes}${this.$t('minute')}`;
    },
    loginExpired(){
      let app = this;
      //login_expired
      app.$state.$del('user');
      app.$router.push('/');
    },
    handleBeforeInstallPrompt(e) {
      e.preventDefault(); // 阻止自動顯示提示
      this.deferredPrompt = e; // 儲存事件
      this.canInstall = true; // 顯示安裝按鈕
      window._beforeInstallPrompt = e; // 記錄事件，確保即使 Vue 載入後也能使用
    },
    // 顯示安裝提示
    promptInstall() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();  // 顯示安裝提示
        this.deferredPrompt.userChoice.then((choiceResult) => {
          console.log(choiceResult.outcome);  // 顯示用戶選擇結果 ("accepted" 或 "dismissed")
          if (choice.outcome === 'accepted') {
            this.canInstall = false;     // 隱藏安裝按鈕
            this.deferredPrompt = null;  // 重設事件
          }
        });
      }
    },
    gotoLastChargingStation(deviceid){
      let app = this;
      //console.log('deviceid:' , deviceid);
      if(deviceid) {
        let uuid = config.encrypt(''+deviceid, config.ffkey, config.ffiv);
        app.$state.$set('uuid', uuid);
        app.uuid = uuid;
        
        //Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
        let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
            uuid: uuid
        });
        window.location = href;
        location.reload();
      }
    },
    openLastChargingStations() {
      let app = this;
      app.showLastChargingStationsModal = true;
    },//eo openLastChargingStations
    getCarMembers(){
			let car_members = '';
			if(this.available_car_members) {
				//console.log('this.available_car_members:' , this.available_car_members);
				this.available_car_members.forEach((car_member, index) => {
					let validity_period_date = car_member['validity_period_date'];
					let discount = parseFloat(car_member['discount']);
					//console.log('discount:' , discount);
					if(discount != 1.00) {
						car_members += car_member['car_brand'];
						/*if(discount == 0.00) {
							car_members += `(免費)`;
						} else {
							car_members += `(${(discount * 10).toString().replace(/\.0$/, '')}折)`;
						}*/
						if(validity_period_date) {
							car_members += `(有效期限:${validity_period_date})`;
						}
						car_members += '<br>';
					}
				});
			}
			return car_members;
		},
		getMembers(){
			let members = '';
			if(this.available_members) {
				//console.log('this.available_members:' , this.available_members);
				this.available_members.forEach((member, index) => {
					let validity_period_date = member['validity_period_date'];
          let validity_period_date_start = member['validity_period_date_start'];
					if(member['type'] == 'REWARD') {
						let reward = parseFloat(member['reward']);
						if(reward != 0.00) {
							members += `${this.$t('all_stations_charging_reward')} ${reward * 100}%`;
							if(validity_period_date) {
								members += `<br>(${this.$t('expiration_date')}:${validity_period_date_start} ~ ${validity_period_date})`;
							}
							members += '<br>'
						}
					} else {
						let discount = parseFloat(member['discount']);
						//console.log('discount:' , discount);
						if(discount != 1.00) {
							members += member['Company.name'];
							if(discount == 0.00) {
								members += `(${this.$t('free')})`;
							} else {
								members += `(${(discount * 10).toString().replace(/\.0$/, '')}${this.$t('discount')})`;
							} //this.$t('device.today')
							if(validity_period_date) {
								members += `(${this.$t('expiration_date')}:${validity_period_date})`;
							}
							members += '<br>';
						}
					}
				});
			}
			return members;
		},
    handleWeekClick(id) {
      this.$set(this.scheduleEditSelectedWeeks, id, !this.scheduleEditSelectedWeeks[id]);

      this.scheduleEditWeekly = 0;
      this.scheduleEditWeekly += this.scheduleEditSelectedWeeks[1] === true ? 64 : 0;
      this.scheduleEditWeekly += this.scheduleEditSelectedWeeks[2] === true ? 32 : 0;
      this.scheduleEditWeekly += this.scheduleEditSelectedWeeks[3] === true ? 16 : 0;
      this.scheduleEditWeekly += this.scheduleEditSelectedWeeks[4] === true ? 8 : 0;
      this.scheduleEditWeekly += this.scheduleEditSelectedWeeks[5] === true ? 4 : 0;
      this.scheduleEditWeekly += this.scheduleEditSelectedWeeks[6] === true ? 2 : 0;
      this.scheduleEditWeekly += this.scheduleEditSelectedWeeks[7] === true ? 1 : 0;
      if(this.scheduleEditWeekly) {
        this.scheduleEditDate = null;
      } else {
        let date = moment().tz(config.timezone);
        date = date.add(1, 'day').format("YYYY-MM-DD");
        this.scheduleEditDate = date;
      }

      this.DatePickerInputValue = this.scheduleEditDate ? this.getDateAndWeekInfo(this.scheduleEditDate) : this.getWeeklyInfo(this.scheduleEditWeekly);
    },
    getDateWeeklyInfo(schedule){
      let info = '';
      if(schedule) {
        if(schedule.date != null) { //show date and week info
          info = this.getDateAndWeekInfo(schedule.date);
        } else { //show weekly info
          info = this.getWeeklyInfo(schedule.weekly);
        }
      }
      return info;
    },
    getDateAndWeekInfo(date){
      let info = '';
      if(date) {
        let dateObject = moment(date).tz(config.timezone);
        let dateObjectYear = dateObject.format("YYYY");
        let dateObjectMonth = dateObject.format("MM");
        let dateObjectDay = dateObject.format("DD");
        let today = moment().tz(config.timezone);
        let todayYear = today.format("YYYY");
        let todayMonth = today.format("MM");
        let todayDay = today.format("DD");
        let tomorrowDay = today.add(1, 'day').format("DD");

        //console.log('dateObjectYear:' , dateObjectYear, ', dateObjectMonth:' , dateObjectMonth, ', dateObjectDay:' , dateObjectDay);
        //console.log('todayYear:' , todayYear, ', todayMonth:' , todayMonth, ', todayDay:' , todayDay);

        if(dateObjectYear === todayYear && dateObjectMonth === todayMonth) {
          if(dateObjectDay === todayDay) {
            info += this.$t('device.today') + '-';
          } else if(dateObjectDay === tomorrowDay) {
            info += this.$t('device.tomorrow') + '-';
          }
        }

        if(this.$i18n && this.$i18n.locale == 'zh_TW') {
          info += dateObject.format("MM").toString() + this.$t('unit_month') + dateObject.format("DD").toString() + this.$t('unit_date');
        } else {
          info += dateObject.format("MMMM Do").toString();
        }

        let dayOfWeekString = dateObject.format("d");
        let dayOfWeek = parseInt(dayOfWeekString);
        //console.log('dayOfWeek:' , dayOfWeek);
        let day;
        switch(dayOfWeek) {
          case 0:
            day = this.$t('device.week_sun');
            break;
          case 1:
            day = this.$t('device.week_mon');
            break;
          case 2:
            day = this.$t('device.week_tue');
            break;
          case 3:
            day = this.$t('device.week_wed');
            break;
          case 4:
            day = this.$t('device.week_thu');
            break;
          case 5:
            day = this.$t('device.week_fri');
            break;
          case 6:
            day = this.$t('device.week_sat');
            break;
          default:
            day = this.$t('device.invalid_date');
            break;
        }
        info += ', ' + day;
      }
      return info;
    },
    getWeeklyInfo(weekly){
      let info = '';
      if(weekly) {
        if(weekly == 127) {
          info = this.$t('device.everyday');
        } else {
          //show weekly info
          let sun = weekly & 64;
          let mon = weekly & 32;
          let tue = weekly & 16;
          let wed = weekly & 8;
          let thu = weekly & 4;
          let fri = weekly & 2;
          let sat = weekly & 1;

          info = this.$t('device.every') + ' ';
          if(sun) {
            info += this.$t('device.week_sun') + ' ';
          }
          if(mon) {
            info += this.$t('device.week_mon') + ' ';
          }
          if(tue) {
            info += this.$t('device.week_tue') + ' ';
          }
          if(wed) {
            info += this.$t('device.week_wed') + ' ';
          }
          if(thu) {
            info += this.$t('device.week_thu') + ' ';
          }
          if(fri) {
            info += this.$t('device.week_fri') + ' ';
          }
          if(sat) {
            info += this.$t('device.week_sat') + ' ';
          }
        }
      }
      return info;
    },
    getOpenTimeWeeklyInfo(weekly){
      let info = this.getWeeklyInfo(weekly);
      if(info == '') {
        info = this.$t('device.maintenance');
      }
      return info;
    },
    chargeFirst(cancel) {
      if (cancel === 1) {
        this.showChargeFirstModal = false;
        return;
      }

      this.showChargeFirstModal = false;
      this.toggleValue3(1, true);
      this.prepayChargeMsg = null;
    },
		toggleValue3(value, verified) {
			let app  = this;
      let user = this.$state.$get('user');

      let after = (google_captcha) => {
        google_captcha = google_captcha || null;

        if (app.disable_btns) {
          return false;
        }

        if (value === 1 && this.device_record.charge_first && !verified) {
          // this.showChargeFirstModal = true;
          this.chargeFirst();
          this.prepayChargeMsg = null;
          return;
        }

        if(parseInt(value) === 0){
            // console.info('turn if off');
            app.showCashCheckOutModal = true;
            return;
        } else { //turn on
            //auto close charge/idle fee info
            app.isChecked_charge_fee = true;
            app.isChecked_idle_fee = true;

            let credits = parseInt(user.credits) + parseInt(user.bonus);
            let price = app.device_record.price_peak + app.device_record.price_idle;
            if((isNaN(credits) || credits <= 0)
              && this.available_cards.length === 0
              && this.available_line.length === 0
              && !(price <= 0.00)){
                // console.info('#3...');
                app.showPaymentModal = true;
                app.showTopMsg = app.$t('device.points_not_enough');
                return;
            } else if (this.device_record.charge_value
                      && credits < this.device_record.charge_value
                      && this.available_cards.length === 0 
                      && this.available_line.length === 0
                      && !(price <= 0.00)) {
              // console.info('#4...', this.device_record.charge_value);
              app.showPaymentModal = true;
              app.showTopMsg = app.$t('device.points_not_enough2');
              return;
            }
        }

        let shutdown_detector = false;
        app.force_shutdown_detector = false;
        
        if (value === 1) {
          //app.chargeBtnClicked = true;
          app.disable_btns = true;

          //reset error code to 0
          this.mqtt_error_code = 0; 
          this.mqtt_error_code_detail = '';

          /*var _checkvcc1 = setInterval(() => {
            if (!this.mqtt_value.value3) {
              this.showLoadDetectorModal = false;
              shutdown_detector = true;
              clearInterval(_checkvcc1);
            }
          }, 10000);

          let __rstcc1 = setTimeout(() => {
            app.chargeBtnClicked = false;
            clearTimeout(__rstcc1);
          }, 3000);*/
        }

        $socket.emit('mqtt_socket', {
          type: 'mqtt-push',
          token: app.$state.$get('user').token,
          ggtoken: google_captcha,
          device_id: app.device_id,
          value: value,
          watts: app.mqtt_value.value1,
          all_watts: app.mqtt_value.value2,
          uuid: app.$state.$get('user').uuid,
        });

        if(parseInt(value) === 0){//off
          app.end_time           = moment().tz(config.timezone).unix();
          app.current_used_time = 0;
          app.current_used_time_peak = 0;
          app.current_used_time_idle = 0;
          app.total_used_time = 0;
          app.current_used_watts = 0;
          app.current_used_watts_peak = 0;
          app.total_used_watts = 0;
          app.total_price = 0;
          app.total_pay = 0;
          app.total_pay_peak = 0;
          app.total_pay_idle = 0;
          app.current_charging_time  = 0;
        } else {  //on
          app.start_time         = moment().tz(config.timezone).unix();
          app.current_used_time = 0;
          app.current_used_time_peak = 0;
          app.current_used_time_idle = 0;
          app.total_used_time = 0;
          app.current_used_watts = 0;
          app.current_used_watts_peak = 0;
          app.total_used_watts = 0;
          app.total_price = 0;
          app.total_pay = 0;
          app.total_pay_peak = 0;
          app.total_pay_idle = 0;
          app.current_charging_time  = 0;
          app.charging_record    = null;
          app.record             = null;

          let _cc = setTimeout(() => {
            get_latest_charging_record(app);
            clearTimeout(_cc);
          }, 1400);

          let _occ = setTimeout(() => {
            if(!app.showLoginExpiredModal && !app.showOverChargingTimeLimitMinuteModal) {
              app.showLoadDetectorModal = true;
            }
            clearTimeout(_occ);
          }, 800);
     
          //start the load detector
          let timeout = 60*3;//seconds
          if(app.device_record.charging_timeout) {
            timeout = app.device_record.charging_timeout;
          }
          let has_sent = false;
          
          if(app._cc2_timer) {
            clearInterval(app._cc2_timer);
            app._cc2_timer = null;
          }
          
          app._cc2_timer = setInterval(() => {
            if(app.mqtt_value.value1 >= app.low_power_cutoff_threshold){
              clearInterval(app._cc2_timer);
              app.showLoadDetectorModal = false;
            }
                      
            if(!has_sent){
              let _ctc = setTimeout(function(){
                $socket.emit('mqtt_socket', {
                  type: 'mqtt-query',
                  token: app.$state.$get('user').token,
                  device_id: app.uuid,
                  uuid: app.$state.$get('user').uuid,
                });
                clearTimeout(_ctc);
              }, 15000);
              has_sent = true;
            }

            if (shutdown_detector || app.force_shutdown_detector || app.showLoginExpiredModal || app.showOverChargingTimeLimitMinuteModal) {
              shutdown_detector = false;
              app.force_shutdown_detector = false;
              app.showLoadDetectorModal = false;
              clearInterval(app._cc2_timer);
              return;
            }
          
            if(timeout <= 0){
              app.showLoadDetectorModal = false;
              // app.toggleValue3(0); //backend will take care of this
              clearInterval(app._cc2_timer);
              app.doCheckOut(1); //add this to improve backend detector not stop immediately.
              //setTimeout(() => {
              //  console.info('reload - 3');
              //  window.location.reload(true);
              //}, 1000);
            }

            app.detectorMsg = app.$t('device.detectorMsg', {timeout1:timeout, timeout2:timeout, value1: app.mqtt_value.value1, cutoff_threshold:app.low_power_cutoff_threshold});
            timeout--;
          }, 1000);
        }
      }

      grecaptcha.execute(config.captcha_key, {action: 'webchargecmd'})
      .then(function(ggtoken) {
        // console.info('grecaptcha.token:', ggtoken);
        after(ggtoken);
      });
			// app.disable_btns = true;
		},//eo toggleValue3
		openQrCodeScanner() {
			let app = this;

			app.showErrorModal       = true
			app.show_scan_qrcode_msg = true;
			app.show_qrcode_canvas   = true;

			// let _ccc = setTimeout(() => {
			// 	clearTimeout(_ccc);
			// 	init_qrcode_reader(app);
			// }, 1000);

      codeReader
        .listVideoInputDevices()
        .then((videoInputDevices) => {
          let targetCamera;
          videoInputDevices.forEach((device) => {
            this.cameraDevices.push(`${device.label}, ${device.deviceId}`);
            if (this.camera === 'front' && device.label.toLowerCase().indexOf('front') !== -1) {
              targetCamera = device.deviceId;
              return false;
            }
            return true;
          });
          codeReader
            .decodeFromInputVideoDevice(undefined, 'qrvideo')
            .then(result => this.onDecode(result.text))
            .catch(err => {
              // this.showError({message:this.$t('qr_code_detect_error')});
              console.error(err)
            });
        })
        .catch(err => { 
          this.showError({message:this.$t('qr_code_detect_error')});
          console.error(err)
        });

		},//eo openQrCodeScanner
    onDecode(data) {
      this.$emit('qrcodeDetected', data);
      this.showSuccess({message:this.$t('qr_code_detected')});
    },
		hideScanner(){
			// let app = this;
			// app.getVideo().stop();
      if(scanner !== null && scanner.destroy){
          scanner.destroy();
          scanner = null;
      }
		},//eo hideScanner
    readBalance() {
      let app = this;
      let user = app.$state.$get('user');

      //console.info('read balance...');
      if(app.read_balance_timer) {
        clearInterval(app.read_balance_timer);
        app.read_balance_timer = null;
      }

      app.read_balance_timer = setInterval(() => {
        //console.info('app.read_balance_timer started');
        let action = `${config.mqtt_root}/read_balance`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + app.$state.$get('user').token
          },
          body: JSON.stringify({
            device_id: app.uuid ? app.uuid : 0,
            user_id: app.$state.$get('user').uuid,
          })
        }).then(res => res.json()).then(result => {
          if(result.success){
            app.balance = parseInt(result.user.credits);
            app.bonus = parseInt(result.user.bonus);
            
            user.credits = result.user.credits;
            user.bonus = result.user.bonus;
            app.isDemo = result.user.demo;

            //Save newest app.isDemo info.
            app.$state.$set('isDemo', app.isDemo);

            if (!user.email && result.user.email) {
              user.email = result.user.email;
            }

            if (!app.invoice_carrier && result.user.invoice_carrier && !app.showInvoiceCarrierModal) {
              app.invoice_carrier = result.user.invoice_carrier;
              // console.info(`app.invoice_carrier: ${app.invoice_carrier}`);
            }

            if (!app.buyeremail && result.user.email && !app.showTopUpModal) {
              app.buyeremail = result.user.email;
            }

            if (!app.buyername && result.user.invoiceno_name && !app.showTopUpModal) {
              app.buyername = result.user.invoiceno_name;
            }

            if (!user.name && result.user.name) {
              user.name = result.user.name;
            }

            if (!user.username && result.user.name) {
              user.username = result.user.name;
            }

            if (result.user.cards && (app.available_cards.length != result.user.cards.length)) {
              app.available_cards = result.user.cards;
            } else if (!result.user.cards) {
              app.available_cards = [];
            }

            if (result.user.line && (app.available_line.length != result.user.line.length)) {
              app.available_line = result.user.line;
            } else if (!result.user.line) {
              app.available_line = [];
            }

            let need_update_device_info = false;
            if (result.user.car_members && (app.available_car_members.length != result.user.car_members.length)) {
              app.available_car_members = result.user.car_members;
              need_update_device_info = true;
            } else if (!result.user.car_members) {
              if(app.available_car_members.length > 0) {
                need_update_device_info = true;
              }
              app.available_car_members = [];
            }

            if (result.user.members && (app.available_members.length != result.user.members.length)) {
              app.available_members = result.user.members;
              need_update_device_info = true;
            } else if (!result.user.members) {
              if(app.available_members.length > 0) {
                need_update_device_info = true;
              }
              app.available_members = [];
            }

            if(need_update_device_info) {
              app.$nextTick(() => {
                get_device_info(app, app.uuid);
              });
            }

            if (result.user.plug_and_charge && (app.available_plug_and_charge.length != result.user.plug_and_charge.length)) {
              app.available_plug_and_charge = result.user.plug_and_charge;
            } else if (!result.user.plug_and_charge) {
              app.available_plug_and_charge = [];
            }

            if (result.user.rfid_charge && (app.available_rfid_charge.length != result.user.rfid_charge.length)) {
              app.available_rfid_charge = result.user.rfid_charge;
            } else if (!result.user.rfid_charge) {
              app.available_rfid_charge = [];
            }

            if (result.user.schedules) {
              if(app.available_schedules.length != result.user.schedules.length) {
                app.available_schedules = result.user.schedules;
                app.available_schedules.forEach((schedule, index) => {
                  schedule.name = schedule.Device ? schedule.Device.name : app.$t('unknow_device');
                  schedule.start_time = schedule.start_time.substring(0, 5);
                  schedule.end_time = schedule.end_time.substring(0, 5);    
                });
              } else if(app.ignore_schedules_refresh === false) {
                //console.info('schedules: ', result.user.schedules);
                app.available_schedules.forEach(available_schedules_item => {
                  let matchingItem = result.user.schedules.find(result_item => result_item.id === available_schedules_item.id);
                  if (matchingItem) {
                    if(available_schedules_item.enable != matchingItem.enable && app.ignore_schedules_refresh === false) {
                      available_schedules_item.enable = matchingItem.enable;
                      //console.info('available_schedules_item update: ', available_schedules_item);
                    }
                  }
                });
              }
            } else if (!result.user.schedules) {
              app.available_schedules = [];
            }
            //console.info('available_schedules: ', app.available_schedules);

            //console.info('[readBalance] result.user.cards: ',JSON.stringify(result.user.cards));
            //console.info('[readBalance] result.user.line: ',JSON.stringify(result.user.line));
            //console.info('[readBalance] app.available_line.length=' + app.available_line.length);
            //console.info('[readBalance] result.charging_info: ', result.charging_info);
            let new_reward = 0.0;
            if(result.charging_info) {
              app.current_used_time = Math.ceil(result.charging_info.used_time/60);
              app.current_used_time_peak = Math.ceil(result.charging_info.used_time_peak/60);
              app.total_used_time = app.current_used_time + app.current_used_time_peak;
              app.current_used_time_idle = Math.floor(result.charging_info.used_time_idle/60);
              app.current_used_watts = result.charging_info.used_watts;
              app.current_used_watts_peak = result.charging_info.used_watts_peak;
              app.total_used_watts = (result.charging_info.used_watts * 1) + (result.charging_info.used_watts_peak * 1);
              //console.info('[readBalance] total_used_watts: ', app.total_used_watts);
              app.total_pay = result.charging_info.total_pay;
              app.total_pay_peak = result.charging_info.total_pay_peak;
              app.total_pay_idle = result.charging_info.total_pay_idle;
              app.total_price = result.charging_info.total_pay + result.charging_info.total_pay_peak + result.charging_info.total_pay_idle;

              //get valid reward percentage
              if(app.available_reward_members) {
                let start_time_unix = result.charging_info.start_time ? moment.unix(result.charging_info.start_time).tz(config.timezone) : moment().tz(config.timezone);
                for(let idx = 0; idx < app.available_reward_members.length; idx++) {
                  let member = app.available_reward_members[idx];
                  let validity_period_date = member.validity_period_date ? moment.tz(member.validity_period_date, config.timezone) : null;
                  let validity_period_date_start = member.validity_period_date_start ? moment.tz(member.validity_period_date_start, config.timezone) : null;
                  if(validity_period_date_start && validity_period_date_start.isAfter(start_time_unix)) {
                    continue;
                  }
                  if(validity_period_date && validity_period_date.isSameOrAfter(start_time_unix)) {
                    if(member.reward > new_reward) {
                      new_reward = member.reward;
                    }
                  }
                }
              }
            }
            app.reward = new_reward;

            //console.log('open_time: ', JSON.stringify(result.open_time));
            if(result.open_time) {
              if(result.open_time.open_times) {
                app.available_open_times = result.open_time.open_times;
              } else {
                app.available_open_times = [];
              }
              app.available_open_times.forEach(open_time => {
                app.holiday_close |= open_time.holiday_close;
              });
              app.isOpenTime = result.open_time.is_open_time;

            } else {
              app.available_open_times = [];
              app.holiday_close = false;
              app.isOpenTime = true;
            }

            app.is_peak_time = result.is_peak_time ? result.is_peak_time : 0;
            app.charging_time_limit_minutes = result.charging_time_limit_minutes ? result.charging_time_limit_minutes : app.DefaultChargingTimeLimitMinutes;
            app.low_power_cutoff_threshold = result.low_power_cutoff_threshold != undefined ? result.low_power_cutoff_threshold : config.cutoff_threshold;
            
            if(result.user && result.user.credit_card_removed_notify) {
              console.info(`credit_card_removed_notify: ${result.user.credit_card_removed_notify}`);
              app.showCreditCardRemovedModal = true;
              app.credit_cards_removed_message = `扣款信用卡已解除綁定，請重新綁定信用卡或LINE Pay。`;
            }
            
            //console.info(`Device readBalance set user.uuid: ${user.uuid}`);
            app.$state.$set('user', user);//update user
          } else {
            //Added force reload to check user_id to fixed readBalance fail when user.user_id encrypt with wrong iv/key when backend server restarting.
            let reload_timer = setTimeout(() => {
              //console.info('reload - readBalance fail');
              window.location.reload(true);
              clearTimeout(reload_timer);
            }, 1000); 
          }
        }).catch(error => {
        });
      }, 15000);
    }, // eo read balance
    

    getTransactionForm(amount){
      let app = this;
      let user = app.$state.$get('user');

      app.showCashFlowLoadingModal = true;
      app.showTopUpModal = false;

      let payment_method = "CREDIT";
      switch(this.payment_method) { 
        case 2: //ApplePay
          payment_method = "APPLEPAY";
          break;
        case 4: //Google Pay
          payment_method = "ANDROIDPAY";
          break;
        case 5: //Samsung Pay
          payment_method = "SAMSUNGPAY";
          break;
        default:
          payment_method = "CREDIT";
          break;
      }

      amount *= app.unit_price;
      amount = Math.round(amount);
      let invoiceno_enable = this.auto_invoiceno ? '1' : '0';

      let action = `${config.mqtt_root}/render_transaction_form`;
      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + app.$state.$get('user').token
        },
        body: JSON.stringify({
          user_id: encodeURIComponent(app.$state.$get('user').uuid),
          backurl: location.href,
          amount,
          payment_method,
          callbackName: 'transactionJP',
          invoiceno_enable,
          buyerubn: this.buyerubn,
          buyername: this.buyername,
          buyeremail: this.buyeremail,
        })
      }).then(res => res.json()).then(result => {
        //console.info('render_transaction_form result:', result);
          
        if(result.auth && result.success){
            app.showSuccess({message:app.$t('device.topup_success')});
            let action = `${config.mqtt_root}/read_balance`;
            fetch(action, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + app.$state.$get('user').token
              },
              body: JSON.stringify({
                device_id: app.uuid ? app.uuid : 0,
                user_id: app.$state.$get('user').uuid,
              })
            }).then(res => res.json()).then(result => {
              // console.info('read_balance:', result);
              if(result.success){
                  app.balance = parseInt(result.user.credits);
                  app.bonus = parseInt(result.user.bonus);
                  
                  user.credits = result.user.credits;
                  user.bonus = result.user.bonus;
                  
                  app.$state.$set('user', user);//update user
              }
            }).catch(error => {
            });
            app.showCashFlowLoadingModal = false;
            return;
        } else if(result.auth) {
            app.showCashFlowLoadingModal = false;
            app.showError({message:app.$t('device.error.topup_fail_error')});
            return;
        }

        if(result.success){
          let form = jQuery(result.form);
          jQuery('#tmp-form').find('#transaction-form').remove();
          jQuery('#tmp-form').append(form).find('#transaction-form').submit();
          // jQuery('#tmp-form').append(form).find('#transaction-form');
        } else {
          app.showCashFlowLoadingModal = false;
          app.showError({message:app.$t('device.error.topup_fail2_error')});
        }
      }).catch(error => {
        app.showCashFlowLoadingModal = false;
        app.showError({message:app.$t('device.error.topup_fail2_error')});
      });
    },//eo getTransactionForm

    popTopSelectPaymentModal(){
      this.showSelectPaymentModal = true;
      
    },//eo popTopSelectPaymentModal

    setPaymentMethod(method){
      this.payment_method = method;
      this.showSelectPaymentModal = false;
    },//eo setPaymentMethod

    popTopSelectTopupAmountModal(){
      this.showSelectTopupAmountModal = true;
      
    },//eo popTopSelectPaymentModal

    setTopupAmount(value){
      this.topup_amount_select = value;
      this.showSelectTopupAmountModal = false;
    },//eo setPaymentMethod
    
    popTopUpModal(){
      if(this.$state.$get('isDemo') === 'YES'){
        this.showError({message: this.$t('device.error.demo_account_topup_error')});
        return;
      }

      const user = this.$state.$get('user');
      this.showPaymentModal = false;

      if (!this.buyeremail && user.email && user.email.indexOf('@') !== -1) {
        this.buyeremail = user.email;
      }

      if (this.buyeremail.indexOf('@') === -1) {
        this.buyeremail = '';
      }

      //this.new_buyerubn_topup = this.buyerubn;
      //this.new_buyername_topup = this.buyername;
      this.auto_invoiceno_cl = this.auto_invoiceno;
      this.new_buyerubn_cl = this.buyerubn;
      this.new_buyername_cl = this.buyername;
      this.topup_amount_select = 0;

      // console.info('popTopUpModal.user: ', user, ' ,this.buyeremail:', this.buyeremail);
      // console.info(this.$state.$get('user'));
      this.showTopMsg = this.$t('device.click_your_topup_plan');
      this.showTopUpModal = true;
      this.top_up_invalid = false;
      this.top_up_invalid_msg = '';

      // console.info(window.ApplePaySession);
      
      if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
        //console.log("支援 Apple Pay");
        this.isApplePayOkay = true;
      } else {
        //console.log("不支援 Apple Pay");
        this.isApplePayOkay = false;
      }
      /*if (window.ApplePaySession) {
        //console.info('ApplePaySession is okay...');
        const merchantIdentifier = 'merchant.com.innoknight.iot';
        const promise = ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
        promise.then((canMakePayments) => {
          if (canMakePayments) {
            //console.info('ApplePay is good to go');
            this.isApplePayOkay = true;
          } else {
            this.isApplePayOkay = false;
          }
        });
      } else {
        this.isApplePayOkay = false;
      }*/
    },//eo showTopUpModal

    popGrouponModal() {
      this.showCouponModal = true;
      let __vcc = setTimeout(() =>{
        this.$refs.couponsn.focus();
        clearTimeout(__vcc);
      } , 800);
    }, // eo popGrouponModal

    popshowCreditCardORLINEPayModal() {
      if(this.$state.$get('isDemo') === 'YES'){
        this.showError({message: this.$t('demo_account_error')});
        return;
      }
      this.auto_invoiceno_cl = this.auto_invoiceno;
      this.new_buyerubn_cl = this.buyerubn;
      this.new_buyername_cl = this.buyername;
      this.showCreditCardModal = false;
      this.showLinePayModal = false;
      this.showPaymentModal = false;
      this.credit_card_linepay_invalid = false;
      this.credit_card_linepay_invalid_msg = '';
      this.showCreditCardORLINEPayModal = true;
      let __vcc = setTimeout(() => {
        this.$refs.couponsn.focus();
        clearTimeout(__vcc);
      }, 800);
    }, //eo popshowCreditCardORLINEPayModal

    popCreditCardModal() {
      this.credit_card_linepay_invalid = false;
      this.credit_card_linepay_invalid_msg = '';

      if(this.$state.$get('isDemo') === 'YES'){
        this.credit_card_linepay_invalid = true;
        this.credit_card_linepay_invalid_msg = this.$t('demo_account_error');
        //this.showError({message: this.$t('demo_account_error')});
        return;
      }

      if(this.auto_invoiceno != this.auto_invoiceno_cl ||
        this.buyerubn != this.new_buyerubn_cl || 
        this.buyername != this.new_buyername_cl) {
        if (this.auto_invoiceno_cl) {
          if(this.new_buyerubn_cl.length !== 8) {
            this.$refs.new_buyerubn_cl.focus();
            this.credit_card_linepay_invalid = true;
            this.credit_card_linepay_invalid_msg = this.$t('device.error.invoice_no_error');
            //this.showError({message: this.$t('device.error.invoice_no_error')});
            return;
          }

          if (!this.new_buyername_cl) {
            this.$refs.new_buyername_cl.focus();
            this.credit_card_linepay_invalid = true;
            this.credit_card_linepay_invalid_msg = this.$t('device.error.company_error');
            //this.showError({message: this.$t('device.error.company_error')});
            return;
          }
        }

        let invoiceno_enable = this.auto_invoiceno_cl ? '1' : '0';
        let action = `${config.mqtt_root}/set_invoiceno`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('user').token
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            keyset: 'mqtt',
            invoiceno_enable: encodeURIComponent(config.encrypt(`${invoiceno_enable}`, config.ffkey, config.ffiv)),
            invoiceno: encodeURIComponent(config.encrypt(`${this.new_buyerubn_cl}`, config.ffkey, config.ffiv)),
            invoiceno_name: encodeURIComponent(config.encrypt(`${this.new_buyername_cl}`, config.ffkey, config.ffiv)),
            op: 'modify',
          })
        }).then(res => res.json()).then(result => {
          if(result.success) {
            this.auto_invoiceno = this.auto_invoiceno_cl;
            this.buyerubn = this.new_buyerubn_cl;
            this.buyername = this.new_buyername_cl;

            this.showCreditCardORLINEPayModal = false;
            this.showUpdateUserEmail = false;
            this.showCreditCardModal = true;
            this.cardnoinvalid = false;
            this.carddateinvalid = false;
            this.cardcvsinvalid = false;
            this.creditCartCheckingResult = null;
            this.cardno = '';
            this.carddate = '';
            this.cardcvs = '';
            this.showPaymentModal = false;

            const user = this.$state.$get('user');
            // console.log('user: ', user);
            const useremail = user.email && user.email.indexOf('@') !== -1 ? user.email : user.email2;

            if (!useremail) {
              this.showUpdateUserEmail = true;
            }
          } else {
            this.credit_card_linepay_invalid = true;
            this.credit_card_linepay_invalid_msg = result.message ? result.message : this.$t('device.error.set_invoice_no_error');

            //this.showError({
            //  message: result.message ? result.message : this.$t('device.error.set_invoice_no_error'), //TODO: i18n
            //});
          }
        }).catch(error => {
          //console.info('set invoiceno error', error);
          this.credit_card_linepay_invalid = true;
          this.credit_card_linepay_invalid_msg = error;
          this.showError(error); //TODO: i18n
        });
      } else {
        this.showCreditCardORLINEPayModal = false;
        this.showUpdateUserEmail = false;
        this.showCreditCardModal = true;
        this.cardnoinvalid = false;
        this.carddateinvalid = false;
        this.cardcvsinvalid = false;
        this.creditCartCheckingResult = null;
        this.cardno = '';
        this.carddate = '';
        this.cardcvs = '';
        this.showPaymentModal = false;

        const user = this.$state.$get('user');
        // console.log('user: ', user);
        const useremail = user.email && user.email.indexOf('@') !== -1 ? user.email : user.email2;

        if (!useremail) {
          this.showUpdateUserEmail = true;
        }
      }
    }, // eo popCreditCardModal

    popLinePayModal() {
      this.credit_card_linepay_invalid = false;
      this.credit_card_linepay_invalid_msg = '';

      if(this.$state.$get('isDemo') === 'YES'){
        this.credit_card_linepay_invalid = true;
        this.credit_card_linepay_invalid_msg = this.$t('demo_account_error');
        //this.showError({message: this.$t('demo_account_error')});
        return;
      }

      if(this.auto_invoiceno != this.auto_invoiceno_cl ||
        this.buyerubn != this.new_buyerubn_cl || 
        this.buyername != this.new_buyername_cl) {
        if (this.auto_invoiceno_cl) {
          if(this.new_buyerubn_cl.length !== 8) {
            this.$refs.new_buyerubn_cl.focus();
            this.credit_card_linepay_invalid = true;
            this.credit_card_linepay_invalid_msg = this.$t('device.error.invoice_no_error');
            //this.showError({message: this.$t('device.error.invoice_no_error')});
            return;
          }

          if (!this.new_buyername_cl) {
            this.$refs.new_buyername_cl.focus();
            this.credit_card_linepay_invalid = true;
            this.credit_card_linepay_invalid_msg = this.$t('device.error.company_error');
            //this.showError({message: this.$t('device.error.company_error')});
            return;
          }
        }

        let invoiceno_enable = this.auto_invoiceno_cl ? '1' : '0';
        let action = `${config.mqtt_root}/set_invoiceno`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('user').token
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            keyset: 'mqtt',
            invoiceno_enable: encodeURIComponent(config.encrypt(`${invoiceno_enable}`, config.ffkey, config.ffiv)),
            invoiceno: encodeURIComponent(config.encrypt(`${this.new_buyerubn_cl}`, config.ffkey, config.ffiv)),
            invoiceno_name: encodeURIComponent(config.encrypt(`${this.new_buyername_cl}`, config.ffkey, config.ffiv)),
            op: 'modify',
          })
        }).then(res => res.json()).then(result => {
          if(result.success) {
            this.auto_invoiceno = this.auto_invoiceno_cl;
            this.buyerubn = this.new_buyerubn_cl;
            this.buyername = this.new_buyername_cl;

            this.showCreditCardORLINEPayModal = false;
            this.showUpdateUserEmail = false;
            this.showLinePayModal = true;
            this.showPaymentModal = false;

            const user = this.$state.$get('user');
            // console.log('user: ', user);
            const useremail = user.email && user.email.indexOf('@') !== -1 ? user.email : user.email2;

            if (!useremail) {
              this.showUpdateUserEmail = true;
            }
          } else {
            this.credit_card_linepay_invalid = true;
            this.credit_card_linepay_invalid_msg = result.message ? result.message : this.$t('device.error.set_invoice_no_error');
            //this.showError({
            //  message: result.message ? result.message : this.$t('device.error.set_invoice_no_error'), //TODO: i18n
            //});
          }
        }).catch(error => {
          //console.info('set invoiceno error', error);
          this.credit_card_linepay_invalid = true;
          this.credit_card_linepay_invalid_msg = error;
          this.showError(error); //TODO: i18n
        });
      } else {
        this.showCreditCardORLINEPayModal = false;
        this.showUpdateUserEmail = false;
        this.showLinePayModal = true;
        this.showPaymentModal = false;

        const user = this.$state.$get('user');
        // console.log('user: ', user);
        const useremail = user.email && user.email.indexOf('@') !== -1 ? user.email : user.email2;

        if (!useremail) {
          this.showUpdateUserEmail = true;
        }
      }
    }, // eo popLinePayModal

    popCarMemberRegisterModal() {
      if(this.$state.$get('isDemo') === 'YES'){
        this.showError({message: this.$t('demo_account_error')});
        return;
      }

      this.showCarMemberRegisterModal = true;
      this.CarMemberRegisterResult = null;
      this.car_member_cardnoinvalid = false;
      this.car_member_cardno = '';
      this.showPaymentModal = false;

      let __vcc = setTimeout(() =>{
        this.$refs.car_member_cardno.focus();
        clearTimeout(__vcc);
      } , 800);
    }, // eo popCarMemberRegisterModal
    
    onDeductClick(){
        
    },//eo onDeductClick
    
    doCheckOut(action){
      let app = this;
      
      // console.info('action:', action);
      let after = (google_captcha) => {
        if(action === 1){
          if (this.device_record.price === undefined) { //device_record.price not found
            //console.info(`device_record.price not found. get_device_info()`);
            get_device_info(app, app.uuid); //Added this to fixed sometime device_record.price not find cause user use default price to pay issue.
          }

          let checkout = {
            amount: app.amount_to_pay(),
            credits: app.balance,
            bonus: app.bonus,
            after_credits: app.after_credits,
            after_bonus: app.after_bonus,
            watts: app.mqtt_value.value1,
            all_watts: app.mqtt_value.value2,
            total_used_watts: app.total_used_watts
          };

          // console.info('checkout:', checkout); return;
            
          checkout = encodeURIComponent(config.encrypt(JSON.stringify(checkout), config.ffkey, config.ffiv));
          app.showCashCheckOutProcessing = true;

          let action = `${config.mqtt_root}/checkout`;
          fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('user').token,
            },
            body: JSON.stringify({
              user_id: encodeURIComponent(app.$state.$get('user').uuid),
              device_id: encodeURIComponent(app.uuid),
              keyset: 'mqtt',
              ggtoken: google_captcha,
              checkout
            })
          }).then(res => res.json()).then(result => {
            if(result.success){
              if(app.device_record.idle_fee) {
                app.showCashCheckOutProcessing = false;
                app.showCashCheckOutModal = false;
                app.showMqttErrorCheckOutModal = false;

              } else {
                app.end_time           = moment().tz(config.timezone).unix();
                app.current_used_time = 0;
                app.current_used_time_peak = 0;
                app.total_used_time = 0;
                app.current_used_watts = 0;
                app.current_used_watts_peak = 0;
                app.total_used_watts = 0;
                app.current_charging_time  = 0;
                
                //console.info('check out result: ', result);
                
                let _cc = setTimeout(() => {
                  // get_latest_charging_record(app);
                  get_balance(app);
                  clearTimeout(_cc);
                  
                  let action = `${config.mqtt_root}/get_latest_charging_record`;
                  fetch(action, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer ' + app.$state.$get('user').token
                    },
                    body: JSON.stringify({
                      user_id:   encodeURIComponent(app.$state.$get('user').uuid),
                      device_id: encodeURIComponent(app.uuid),
                      keyset: 'mqtt',
                    })
                  }).then(res => res.json()).then(charging_record => {
                    if(charging_record.success){
                      app.start_time = charging_record.record.start_time;
                      app.end_time   = charging_record.record.end_time;

                      if(charging_record.record.status === 'end'){
                        app.record            = {};
                        app.record.used_time = charging_record.record.used_time;
                        app.record.used_time_peak = charging_record.record.used_time_peak;
                        app.record.used_watts = charging_record.record.used_watts;
                        app.record.used_watts_peak = charging_record.record.used_watts_peak;
                        app.record.interval   = Math.round(charging_record.record.interval/3600);
                      }
                                  
                      // app.mqtt_value.value3 = 0;
                    }

                    app.showSuccess({message: app.$t('device.system_reload')});

                    // window.location.reload(true);
                    setTimeout(() => {
                      app.showCashCheckOutProcessing = false;
                      app.showCashCheckOutModal = false;
                      app.showMqttErrorCheckOutModal = false;
                      //console.info('reload - 4');
                      window.location.reload(true);
                    }, 6500);
                  }).catch(error => {
                  });
                }, 400);
              }
              
              app.showSuccess({message: app.$t('device.charging_stopped')});
              // app.showCashCheckOutProcessing = false;
              // app.showCashCheckOutModal = false;
            } else {
              if(result.login_expired){ //login_expired
                app.showCashCheckOutProcessing = false;
                app.showCashCheckOutModal = false;
                app.showMqttErrorCheckOutModal = false;
                app.showLoginExpiredModal = true;
              } else {
                //console.info('result:', result);
                app.showError({title: app.$t('device.error.system_error'), message: app.$t('error_message') + ': ' + (result.error || result.message)}); //TODO: i18n
                app.showCashCheckOutProcessing = false;
                app.showCashCheckOutModal = false;
                app.showMqttErrorCheckOutModal = false;

                app.showSuccess({message: app.$t('device.charging_stopped')});
                app.showSuccess({message: app.$t('device.system_reload')});

                setTimeout(() => {
                  //console.info('reload - 5');
                  window.location.reload(true);
                }, 1500);
              }
            }
          }).catch(error => {
            //console.info('something wrong with JSONP:', error);
            app.showCashCheckOutProcessing = false;
            app.showCashCheckOutModal = false;
            app.showMqttErrorCheckOutModal = false;
          });
        } else {
            app.showCashCheckOutModal = false;
            app.showMqttErrorCheckOutModal = false;
        }
      }

      grecaptcha.execute(config.captcha_key, {action: 'checkout'})
      .then(function(ggtoken) {
        // console.info('grecaptcha.token:', ggtoken);
        after(ggtoken);
      });
    },
    amount_to_pay() {
      
      if(this === undefined){
        return 0;
      }
      
      let a     = 0;
      let c     = this.device_record.billing_method === 'TIME' ? this.current_used_time : this.current_used_watts;
      let c_peak     = this.device_record.billing_method === 'TIME' ? this.current_used_time_peak : this.current_used_watts_peak;
      // let c     = 10;
      let price = this.price;
      let price_peak = this.price;

      if (this.device_record && (this.device_record.price !== undefined)) {
        //console.info(`Got price = `, this.device_record.price);
        price = this.device_record.price;
        price_peak = this.device_record.price_peak;
      }

      // console.info(`this.device: `, this.device_record);
      //console.info(`current_used_watts: ${this.current_used_watts}, current_used_watts_peak: ${this.current_used_watts_peak}`);
      
      if((parseFloat(this.current_used_watts) + parseFloat(this.current_used_watts_peak)) >= 1){
        //console.info('c:', c);
        a = Math.round(c*price + c_peak*price_peak);
        //console.info('fee:', a);
        
        let after_bonus   = this.bonus;
        let after_credits = this.balance;

        // console.info(`after_bonus:${after_bonus}, after_credits:${after_credits}`);
        
        if(true){
          // console.info('1. after_bonus:', after_bonus, ', after_bonus - a:', (after_bonus - a));
          after_bonus = this.bonus - a;
          a -= this.bonus;
          a = a <= 0 ? 0 : a;
          // console.info('2. after_bonus:', after_bonus, ', a:', (a));
        } else {
          a = Math.round((c)*price);
        }
        
        after_credits -= a;//console.info(`after_credits:${after_credits}`);

        a = after_credits;
        
        // a -= after_credits;console.info(`a:${a}`);
        
        // console.info('a:', a, ', this.deduct_bonus:', this.deduct_bonus, ', c:', c);
        
        // after_bonus = after_bonus >= 0 ? after_bonus : 0;
        // after_credits = after_credits >= 0 ? after_credits : 0;
        
        this.after_bonus = after_bonus;
        this.after_credits = after_credits; 

        if(after_bonus < 0) {
          this.final_bonus = 0;
        } else {
          this.final_bonus = after_bonus;
        }
      } else {
        this.after_credits = this.balance;
        this.after_bonus = this.bonus;
        this.final_bonus = this.bonus;
      }

      return Math.abs(a);
    },

    checkCoupon() {
      if (_.trim(this.couponsn) && !this.isOkayToCheckout !== null){
        let action = `${config.mqtt_root}/validate_coupon`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('user').token
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            device_id: encodeURIComponent(this.uuid),
            keyset: 'mqtt',
            couponsn: encodeURIComponent(config.encrypt(this.couponsn, config.ffkey, config.ffiv)),
          })
        }).then(res => res.json()).then(result => {
          this.couponsn = '';
          if (result.success) {
            // this.couponObject = result.coupon;
            this.showSuccess({message: result.message});//TODO: i18n
            this.showCouponModal = false;

            setTimeout(() => {
              this.showSuccess({message: this.$t('device.refresh_coupon')});
              //console.info('reload - 6');
              window.location.reload(true);
            }, 800);
          } else {
            this.showError({message: result.message});//TODO: i18n
            this.$refs.couponsn.focus();
          }
        }).catch(error => {
          this.couponsn = '';
          this.showError({message: error.message});//TODO: i18n
          this.$refs.couponsn.focus();
        });
      }
    }, // eo checkCoupon

    doPaymentProcess(){
      let app = this;
      this.top_up_invalid = false;
      this.top_up_invalid_msg = '';

      if (!this.buyeremail) {
        this.$refs.buyeremail.focus();
        this.top_up_invalid = true;
        this.top_up_invalid_msg = this.$t('device.error.email_error');
        //this.showError({message: this.$t('device.error.email_error')});
        return;
      } else if(mail_format_check(this.buyeremail) === false) {
        this.$refs.buyeremail.focus();
        this.top_up_invalid = true;
        this.top_up_invalid_msg = this.$t('device.error.email_format_error');
        //this.showError({message: this.$t('device.error.email_format_error')});
        return;
      }

      if (this.auto_invoiceno_cl) {
        if(this.new_buyerubn_cl.length !== 8) {
          this.$refs.new_buyerubn_cl_top_up.focus();
          this.top_up_invalid = true;
          this.top_up_invalid_msg = this.$t('device.error.invoice_no_error');
          //this.showError({message: this.$t('device.error.invoice_no_error')});
          return;
        }

        if (!this.new_buyername_cl) {
          this.$refs.new_buyername_cl_top_up.focus();
          this.top_up_invalid = true;
          this.top_up_invalid_msg = this.$t('device.error.company_error');
          //this.showError({message: this.$t('device.error.company_error')});
          return;
        }
      }

      this.auto_invoiceno = this.auto_invoiceno_cl;
      this.buyerubn = this.new_buyerubn_cl;
      this.buyername = this.new_buyername_cl;
      let amount = 0;
      switch(this.topup_amount_select){
        case 1:
          amount = 100;
          break;
        case 2:
          amount = 300;
          break;
        case 3:
          amount = 500;
          break;
        case 4:
          amount = 1000;
          break;
        case 5:
          amount = 3000;
          break;
        default:
          amount = 0;
          break;
      }

      let action = `${config.mqtt_root}/read_balance`;
      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + app.$state.$get('user').token
        },
        body: JSON.stringify({
          device_id: app.uuid ? app.uuid : 0,
          user_id: app.$state.$get('user').uuid,
        })
      }).then(res => res.json()).then(result => {
        // console.info('read_balance:', result);
        if(result.success){
          app.balance = parseInt(result.user.credits);
          app.bonus = parseInt(result.user.bonus);
          
          if((app.balance + amount) > 9000) { 
            this.top_up_invalid = true;
            this.top_up_invalid_msg = this.$t('device.over_maximun_topup_amount');
            //this.showError({message: this.$t('device.over_maximun_topup_amount')});
          } else {
            if(this.payment_method === 0) { //User payment method not select.
              this.top_up_invalid = true;
              this.top_up_invalid_msg = this.$t('device.choose_payment_method');
              //this.showError({message: this.$t('device.choose_payment_method')});
              return;
            } if(this.topup_amount_select === 0) { //add value method not select.
              this.top_up_invalid = true;
              this.top_up_invalid_msg = this.$t('device.choose_topup_amount');
              //this.showError({message: this.$t('device.choose_topup_amount')});
              return;
            } else if(this.payment_method === 2) { //payment_method = 2 is ApplePay
              //this.applePayAmount = amount;
              //return this.initApplePay();
              return this.getTransactionForm(amount);
            } else if(this.payment_method === 3) {//payment_method = 3 is LinePay
              this.showTopUpModal = false;
              return;
            } else { //payment_method = others is NewebPay(include CreditCard/GooglePay/SamsungPay)
              return this.getTransactionForm(amount);
            }
          }
        }
      }).catch(error => {
        this.top_up_invalid = true;
        this.top_up_invalid_msg = this.$t('device.error.topup_fail2_error');
        //app.showError({message:app.$t('device.error.topup_fail2_error')});
      });
    },

    checkCreditCard() {
      let app = this;
      let user = app.$state.$get('user');

      if (app.showUpdateUserEmail && !app.cardemail) {
        this.$refs.cardemail.focus();
        this.showError({message: this.$t('device.error.email_error')});
        return;
      } else if(app.showUpdateUserEmail && mail_format_check(app.cardemail) === false) {
        this.$refs.cardemail.focus();
        this.showError({message: this.$t('device.error.email_format_error')});
        return;
      } else {
        app.showCashFlowLoadingModal = true;
        app.showTopUpModal = false;

        let amount = 1.15;

        let action = `${config.mqtt_root}/render_bind_form`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + app.$state.$get('user').token
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(app.$state.$get('user').uuid),
            backurl: location.href,
            amount,
            callbackName: 'transactionJP',
            buyeremail: app.cardemail
          })
        }).then(res => res.json()).then(result => {
          //console.info('render_transaction_form result:', result);
          if (app.cardemail) {
            const user = app.$state.$get('user');
            user.email2 = app.cardemail;
            app.$state.$set('user', user);
          }

          if(result.success){
            let form = jQuery(result.form);
            jQuery('#tmp-form').find('#transaction-form').remove();
            jQuery('#tmp-form').append(form).find('#transaction-form').submit();
            // jQuery('#tmp-form').append(form).find('#transaction-form');
          } else {
            app.showCashFlowLoadingModal = false;
            app.showError({message:app.$t('device.error.bind_fail_error')});
          }
        }).catch(error => {

        });
      }
    }, // eo checkCreditCard

    checkLinePay() {
      let app = this;
      const linepay = {
        linepayemail: this.linepayemail,
      };

      this.linepayemailinvalid = false;

      if (app.showUpdateUserEmail && !app.linepayemail) {
        this.$refs.linepayemail.focus();
        this.showError({message: this.$t('device.error.email_error')});
        return;
      } else if(app.showUpdateUserEmail && mail_format_check(app.linepayemail) === false) {
        this.$refs.linepayemail.focus();
        this.showError({message: this.$t('device.error.email_format_error')});
        return;
      } else {
        if (linepay.linepayemail) {
          const user = this.$state.$get('user');
          user.email2 = linepay.linepayemail;
          this.$state.$set('user', user);
        }

        app.linePayBinding(linepay);
      }
    }, // eo checkLinePay

    setCreditCard(id, last4, op) {
      let app = this;
      let msg = '';
      if(!this.mqtt_value.value3) {
        msg = op === 'delete' ? this.$t('device.delete_creditcard', {last4}) : this.$t('device.set_creditcard', {last4});

        if (window.confirm(msg)) {
          let action = `${config.mqtt_root}/set_creditcard`;
          fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$state.$get('user').token
            },
            body: JSON.stringify({
              user_id: encodeURIComponent(this.$state.$get('user').uuid),
              keyset: 'mqtt',
              creditcard: encodeURIComponent(config.encrypt(`${id}`, config.ffkey, config.ffiv)),
              op,
            })
          }).then(res => res.json()).then(result => {
            this.available_cards = [];
            if (result.success) {
              this.showSuccess(result);//TODO: i18n
            } else {
              this.showError(result);//TODO: i18n  
            }
            get_balance(app);
          }).catch(error => {
            console.info('set credit card error', error);
            this.showError(error);//TODO: i18n
          });
        }
      } else {
        msg = this.$t('device.charging_can_not_delete_creditcard');
        if (window.confirm(msg));
      }
      
    }, // eo setCreditCard

    CarMemberRegister() {
      let app = this;
      this.car_member_cardnoinvalid = false;
      this.CarMemberRegisterResult = null;

      //去除空白/全型空白/Tab/換行/CR
      this.car_member_cardno = this.car_member_cardno.replace(/[\s\u3000]/g, '');

      if (this.car_member_cardno.length <= 0) {
        this.car_member_cardnoinvalid = true;
      } else {
        if(this.CarMemberRegisterErrorCount < 3) {
          this.CarMemberRegisterProcessing = true;
          let action = `${config.mqtt_root}/car_member_register`;
          fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$state.$get('user').token
            },
            body: JSON.stringify({
              user_id: encodeURIComponent(this.$state.$get('user').uuid),
              keyset: 'mqtt',
              cardno: encodeURIComponent(config.encrypt(this.car_member_cardno.toUpperCase(), config.ffkey, config.ffiv)),
            })
          }).then(res => res.json()).then(result => {
            //console.info('car member register result', result);
            this.CarMemberRegisterSuccess = result.success;
            this.CarMemberRegisterResult = result.message + (result.rlt && result.rlt.Message ? ':' + result.rlt.Message : ''); //TODO: i18n

            if (result.success) {
              this.CarMemberRegisterErrorCount = 0;
              this.showCarMemberRegisterModal = false;
              this.showSuccess({
                message: result.message,//TODO: i18n
              });
              let __device_info_refresh = setTimeout(() =>{
                get_device_info(app, app.uuid);
                clearTimeout(__device_info_refresh);
              } , 800);
            } else {
              this.CarMemberRegisterErrorCount++;
              if(this.CarMemberRegisterErrorCount == 3) {
                let __car_member_error_reset = setTimeout(() =>{
                  this.CarMemberRegisterErrorCount = 0;
                  clearTimeout(__car_member_error_reset);
                } , 30000);
              }
            }
            this.CarMemberRegisterProcessing = false;
          }).catch(error => {
            // console.info('car member register error', error);
            // this.showError(error);
            this.CarMemberRegisterProcessing = false;
          });
        } else {
          app.showError({message:app.$t('device.error.bind_retry_fail_error')});
        }
      }
    }, // eo CarMemberRegister
    
    setLinePay(id, op) {
      let app = this;
      let msg = '';
      if(!this.mqtt_value.value3) {
        msg = op === 'delete' ? this.$t('device.delete_linepay') : this.$t('device.set_linepay');

        if (window.confirm(msg)) {
          let action = `${config.mqtt_root}/set_linepay`;
          fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$state.$get('user').token
            },
            body: JSON.stringify({
              user_id: encodeURIComponent(this.$state.$get('user').uuid),
              keyset: 'mqtt',
              linepay: encodeURIComponent(config.encrypt(`${id}`, config.ffkey, config.ffiv)),
              op,
            })
          }).then(res => res.json()).then(result => {
            this.available_line = [];
            if (result.success) {
              this.showSuccess(result);//TODO: i18n
            } else {
              this.showError(result); //TODO: i18n 
            }
            get_balance(app);
          }).catch(error => {
            console.info('set LINE Pay error', error);
            this.showError(error);//TODO: i18n
          });
        }
      } else {
        msg = this.$t('device.charging_can_not_delete_linepay');
        if (window.confirm(msg));
      }
      
    }, // eo setLinePay
    
    initApplePay() { //no use. Now Apple Pay processed via NewebPay.

      if (this.applePayAmount < this.minApplePayAmount) {
        this.applePayAmount = this.minApplePayAmount;
        return;
      }

      if (this.use_invoiceno) {
        if(this.new_buyerubn_topup.length !== 8) {
          this.$refs.new_buyerubn_topup.focus();
          this.showError({message: this.$t('device.error.invoice_no_error')});
          return;
        }

        if (!this.new_buyername_topup) {
          this.$refs.new_buyername_topup.focus();
          this.showError({message: this.$t('device.error.company_error')});
          return;
        }

        if (!this.buyeremail) {
          this.$refs.buyeremail.focus();
          this.showError({message: this.$t('device.error.email_error')});
          return;
        } else if(mail_format_check(this.buyeremail) === false) {
          this.$refs.buyeremail.focus();
          this.showError({message: this.$t('device.error.email_format_error')});
          return;
        }
      }

      this.buyerubn = this.new_buyerubn_topup;
      this.buyername = this.new_buyername_topup;

      // console.info('all this.applePayAmount: ', this.applePayAmount);

      const amount = Math.round(this.applePayAmount * 1.15);

      const app = this;
      const request = {
       countryCode: 'TW', // 國碼
       currencyCode: 'TWD', // 交易貨幣
       supportedNetworks: ['amex', 'masterCard', 'visa'],
       merchantCapabilities: [
        'supports3DS', 'supportsEMV', 'supportsCredit', 'supportsDebit' 
      ],
      lineItems: [
        {
          "label": "Charging points",
          "type": "final",
          "amount": parseFloat(amount).toFixed(2),
        },
      ],
       total: {
          label: 'Innoknight Inc.',
          type: "final",
          amount: parseFloat(amount).toFixed(2),
        }, // amount為此次交易金額
      };
      
      /* 建立 ApplePaySession */
      /* 參數1：版本號、參數2：付款請求物件 */
      const session = new ApplePaySession(1, request);
      session.onvalidatemerchant = function (event) {

        // console.info('session.onvalidatemerchant.event: ', event);
       
        const data = {
          validationURL: event.validationURL,
          hostname: window.location.host,
        };

        app.$jsonp(`${config.mqtt_root}/verify_applepay`, {
          user_id:   encodeURIComponent(app.$state.$get('user').uuid),
          device_id: encodeURIComponent(app.uuid),
          keyset: 'mqtt',
          token: app.$state.$get('user').token,
          data: JSON.stringify(data)
        }).then((verificationObject) => {
          // console.info('session: ', JSON.parse(verificationObject.session));
          if (verificationObject && verificationObject.success) {
            try {
              // console.info('window.location.host: ', window.location.host);
              const rlt = session.completeMerchantValidation(JSON.parse(verificationObject.session));
            } catch (error) {
              console.info('apple pay error: ', error);
              session.abort();
            }
          }
        });
      };

      session.oncancel = function(event) {
        console.info('apple pay canceled: ', event);
      }

      // session.onpaymentmethodselected = function(event) {
      //   console.info('starting session.onpaymentmethodselected');
      //   console.info(event);
        
      //   var newTotal = { type: 'final', label: '<?=PRODUCTION_DISPLAYNAME?>', amount: runningTotal() };
      //   var newLineItems =[{type: 'final',label: subTotalDescr, amount: runningAmount }, {type: 'final',label: 'P&P', amount: runningPP }];
        
      //   session.completePaymentMethodSelection( newTotal, newLineItems );
      // }

      session.onpaymentauthorized = function (event) {
        
        // const data = {
        //   payment: JSON.stringify(event.payment),
        // };

        // console.info('onpaymentauthorized: ', data);

        app.$jsonp(`${config.mqtt_root}/auth_applepay`, {
          user_id:   encodeURIComponent(app.$state.$get('user').uuid),
          device_id: encodeURIComponent(app.uuid),
          keyset: 'mqtt',
          token: app.$state.$get('user').token,
          data: JSON.stringify(event.payment),
          amount: amount,
          buyername: app.use_invoiceno ? app.buyername : '',
          buyerubn: app.use_invoiceno ? app.buyerubn : '',
          buyeremail: app.buyeremail,
        }).then((authObject) => {
          //console.info('authObject: ', authObject);
          if (authObject && authObject.success) {
            session.completePayment(JSON.parse(ApplePaySession.STATUS_SUCCESS));
            app.showSuccess({message:app.$t('device.topup_success')});
            app.showTopUpModal = false;
          } else {
            session.completePayment(JSON.parse(ApplePaySession.STATUS_FAILURE));
            app.showError({message:app.$t('device.topup_fail2_error')});
            app.showTopUpModal = false;
          }
        });

        /* 將payment物件拋至Server端，由Server端處理交易授權 */
        // $.ajax({
        //   url: ' Your Server URL',
        //   method: "POST",
        //   contentType: "application/json; charset=utf-8",
        //   data: JSON.stringify(data),
        //   error: function (err) {
        //     alert(JSON.stringify(err));
        //   }
        // }).then(function (result) {
        //   /* 依授權結果決定帶入ApplePaySession的回應 */
        //   // 授權成功
        //   session.completePayment(JSON.parse(ApplePaySession.STATUS_SUCCESS));
        //   // 授權失敗
        //   session.completePayment(JSON.parse(ApplePaySession.STATUS_FAILURE));
        // });
      }

      session.begin();
    }, // eo initApplePay

    linePayBinding(linepay){
      this.showLinePayModal = false;
      //this.showSuccess({ message: "LINE Pay 綁定中..."});

      //console.log("uuid = " + this.$state.$get("user").uuid);
      let action = `${config.mqtt_root}/linePayBinding`;
      fetch(action, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + generateRandomToken()
        },
        body: JSON.stringify({
          user_id: encodeURIComponent(this.$state.$get("user").uuid),
          linepay: encodeURIComponent(config.encrypt(JSON.stringify(linepay), config.ffkey, config.ffiv)),
        })
      }).then(res => res.json()).then(result => {
        if (result.success) {
          console.log("頁面跳轉");
          parent.window.location.assign(result.form.backurl);  
        }else{
          console.log("linePayBinding result.success=false, result="+JSON.stringify(result));
          //this.showError({message: "無法綁定LINE Pay，請稍後再試" });
          this.showError({message: result.message }); //TODO: i18n
        }
      }).catch(error => {
        console.log("頁面跳轉失敗");
        parent.window.location.assign(`${config.frontend_entry}`);
        //this.showError({message: "Error "+ JSON.stringify(e) });
        this.showError({message: this.$t('device.error.page_load_error')});
      });
    }, //eo linePayBinding

    popPlugAndChargeModal() {
      this.PlugAndChargeIdTagBinded = false;
      this.PlugAndChargeIdTag = '';
      this.PlugAndChargeErrorMsg = '';
      this.showPlugAndChargeModal = true;
    }, // eo popPlugAndChargeModal

    PlugAndChargeRegister(idTag) {
      this.PlugAndChargeErrorMsg = '';
      let action = `${config.mqtt_root}/auth_register`;
      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$state.$get('user').token,
        },
        body: JSON.stringify({
          user_id: encodeURIComponent(this.$state.$get('user').uuid),
          keyset: 'mqtt',
          idtag: encodeURIComponent(config.encrypt(`${idTag}`, config.ffkey, config.ffiv)),
          idtype: encodeURIComponent(config.encrypt(`CAR_ID`, config.ffkey, config.ffiv)),
        })
      }).then(res => res.json()).then(result => {
        if (result.success) {
          this.available_plug_and_charge = [];
          this.showPlugAndChargeModal = false;
          this.showSuccess({
            message: this.$t('device.carid_bind_success', {idTag}),
          });
        } else {
          this.PlugAndChargeIdTagBinded = false;
          this.PlugAndChargeIdTag = '';
          this.PlugAndChargeErrorMsg = result.message ? result.message : this.$t('device.unknow_error'); //TODO: i18n
        }
      }).catch(error => {
        //console.info('set plug and charge error', error);
        this.PlugAndChargeIdTagBinded = false;
        this.PlugAndChargeIdTag = '';
        this.PlugAndChargeErrorMsg = result.message ? result.message : this.$t('device.unknow_error'); //TODO: i18n
      });
    },

    PlugAndChargeRemove(idTag, target_id) {
      let msg = '';
      msg = this.$t('device.delete_carid', {idTag});
      if (window.confirm(msg)) {
        let action = `${config.mqtt_root}/auth_remove`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('user').token,
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            keyset: 'mqtt',
            target_id: encodeURIComponent(config.encrypt(`${target_id}`, config.ffkey, config.ffiv)),
            idtype: encodeURIComponent(config.encrypt(`CAR_ID`, config.ffkey, config.ffiv)),
          })
        }).then(res => res.json()).then(result => {
          if (result.success) {
            this.available_plug_and_charge = [];
            this.showSuccess({
              message: this.$t('device.delete_carid_success', {idTag}),
            });
          } else {
            this.showError({
              message: this.$t('device.error.delete_carid_error', {idTag, message: result.message}), //TODO: i18n
            });  
          }
        }).catch(error => {
          //console.info('set plug and charge error', error);
          this.showError({
            message: this.$t('device.error.delete_carid_error', {idTag, message: result.message}), //TODO: i18n
          }); 
        });
      }
    },

    popRfidChargeModal() {
      this.RfidChargeIdTagBinded = false;
      this.RfidChargeIdTag = '';
      this.RfidChargeErrorMsg = '';
      this.showRfidChargeModal = true;
    }, // eo popRfidChargeModal

    RfidChargeRegister(idTag) {
      this.RfidChargeErrorMsg = '';
      let action = `${config.mqtt_root}/auth_register`;
      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$state.$get('user').token,
        },
        body: JSON.stringify({
          user_id: encodeURIComponent(this.$state.$get('user').uuid),
          keyset: 'mqtt',
          idtag: encodeURIComponent(config.encrypt(`${idTag}`, config.ffkey, config.ffiv)),
          idtype: encodeURIComponent(config.encrypt(`CARD_NO`, config.ffkey, config.ffiv)),
        })
      }).then(res => res.json()).then(result => {
        if (result.success) {
          this.available_rfid_charge = [];
          this.showRfidChargeModal = false;
          this.showSuccess({
            message: this.$t('device.rfid_bind_success', {idTag}),
          });
        } else {
          this.RfidChargeIdTagBinded = false;
          this.RfidChargeIdTag = '';
          this.RfidChargeErrorMsg = result.message ? result.message : this.$t('device.unknow_error');//TODO: i18n
        }
      }).catch(error => {
        //console.info('set RFID charge error', error);
        this.RfidChargeIdTagBinded = false;
        this.RfidChargeIdTag = '';
        this.RfidChargeErrorMsg = result.message ? result.message : this.$t('device.unknow_error');//TODO: i18n
      });
    },

    RfidChargeRemove(idTag, target_id) {
      let msg = '';
      msg = this.$t('device.delete_rfid', {idTag});
      if (window.confirm(msg)) {
        let action = `${config.mqtt_root}/auth_remove`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('user').token,
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            keyset: 'mqtt',
            target_id: encodeURIComponent(config.encrypt(`${target_id}`, config.ffkey, config.ffiv)),
            idtype: encodeURIComponent(config.encrypt(`CARD_NO`, config.ffkey, config.ffiv)),
          })
        }).then(res => res.json()).then(result => {
          if (result.success) {
            this.available_rfid_charge = [];
            this.showSuccess({
              message: this.$t('device.delete_rfid_success', {idTag}),
            });
          } else {
            this.showError({
              message: this.$t('device.error.delete_rfid_error', {idTag, message: result.message}), //TODO: i18n
            });  
          }
        }).catch(error => {
          //console.info('set RFID charge error', error);
          this.showError({
            message: this.$t('device.error.delete_rfid_error', {idTag, message: result.message}), //TODO: i18n
          }); 
        });
      }
    },

    popInvoiceNoModal() {
      this.new_buyerubn_am = this.buyerubn;
      this.new_buyername_am = this.buyername;
      this.invoice_no_invalid = false;
      this.invoice_no_invalid_msg = '';
      this.showInvoiceNoModal = true;
    }, // eo popInvoiceNoModal

    InvoiceNoAutoSwitch() {
      if (!this.buyername) {
        this.auto_invoiceno = false;
        this.showError({message: this.$t('device.error.invoice_company_error')});
        return;
      }

      let invoiceno_enable = !this.auto_invoiceno ? '1' : '0';
      let action = `${config.mqtt_root}/set_invoiceno`;
      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$state.$get('user').token
        },
        body: JSON.stringify({
          user_id: encodeURIComponent(this.$state.$get('user').uuid),
          keyset: 'mqtt',
          invoiceno_enable: encodeURIComponent(config.encrypt(`${invoiceno_enable}`, config.ffkey, config.ffiv)),
          invoiceno: encodeURIComponent(config.encrypt(`${this.buyerubn}`, config.ffkey, config.ffiv)),
          invoiceno_name: encodeURIComponent(config.encrypt(`${this.buyername}`, config.ffkey, config.ffiv)),
          op: 'modify',
        })
      }).then(res => res.json()).then(result => {
        //console.info('set invoiceno:', result);

        if(result.success) {
          this.auto_invoiceno = (invoiceno_enable == '1') ? true : false;
          this.showSuccess({
            message: this.auto_invoiceno ? this.$t('device.enable_invoice') : this.$t('device.disable_invoice'),
          });
        } else {
          this.showError({
            message: result.message ? result.message : this.$t('device.error.invoice_switch_error', {buyerubn: this.buyerubn}), //TODO: i18n
          });
        }
      }).catch(error => {
        //console.info('set invoiceno error', error);
        this.showError(error); //TODO: i18n
      });
    },

    InvoiceNoAdd() {
      this.invoice_no_invalid = false;
      this.invoice_no_invalid_msg = '';

      if(this.new_buyerubn_am.length !== 8) {
        this.$refs.new_buyerubn_am.focus();
        this.invoice_no_invalid = true;
        this.invoice_no_invalid_msg = this.$t('device.error.invoice_no_error');
        //this.showError({message: this.$t('device.error.invoice_no_error')});
        return;
      }

      if (!this.new_buyername_am) {
        this.$refs.new_buyername_am.focus();
        this.invoice_no_invalid = true;
        this.invoice_no_invalid_msg = this.$t('device.error.company_error');
        //this.showError({message: this.$t('device.error.company_error')});
        return;
      }

      let invoiceno_enable = '1';
      let action = `${config.mqtt_root}/set_invoiceno`;
      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$state.$get('user').token
        },
        body: JSON.stringify({
          user_id: encodeURIComponent(this.$state.$get('user').uuid),
          keyset: 'mqtt',
          invoiceno_enable: encodeURIComponent(config.encrypt(`${invoiceno_enable}`, config.ffkey, config.ffiv)),
          invoiceno: encodeURIComponent(config.encrypt(`${this.new_buyerubn_am}`, config.ffkey, config.ffiv)),
          invoiceno_name: encodeURIComponent(config.encrypt(`${this.new_buyername_am}`, config.ffkey, config.ffiv)),
          op: 'add',
        })
      }).then(res => res.json()).then(result => {
        if(result.success) {
          this.auto_invoiceno = (invoiceno_enable == '1') ? true : false;
          this.buyerubn = this.new_buyerubn_am;
          this.buyername = this.new_buyername_am;
          this.showInvoiceNoModal = false;
          this.showSuccess({
            message: this.$t('device.invoice_add_success', {buyerubn: this.buyerubn}),
          });
        } else {
          this.invoice_no_invalid = true;
          this.invoice_no_invalid_msg = result.message ? result.message : this.$t('device.error.invoice_add_error', {buyerubn: this.buyerubn}); //TODO: i18n

          //this.showError({
          //  message: result.message ? result.message : this.$t('device.error.invoice_add_error', {buyerubn: this.buyerubn}), //TODO: i18n
          //});
        }
      }).catch(error => {
        //console.info('set invoiceno error', error);
        this.invoice_no_invalid = true;
        this.invoice_no_invalid_msg = error;
        //this.showError(error); //TODO: i18n
      });
    },

    InvoiceNoModify() {
      this.invoice_no_invalid = false;
      this.invoice_no_invalid_msg = '';

      if(this.new_buyerubn_am.length !== 8) {
        this.$refs.new_buyerubn_am.focus();
        this.invoice_no_invalid = true;
        this.invoice_no_invalid_msg = this.$t('device.error.invoice_no_error');
        //this.showError({message: this.$t('device.error.invoice_no_error')});
        return;
      }

      if (!this.new_buyername_am) {
        this.$refs.new_buyername_am.focus();
        this.invoice_no_invalid = true;
        this.invoice_no_invalid_msg = this.$t('device.error.company_error');
        //this.showError({message: this.$t('device.error.company_error')});
        return;
      }

      if(this.auto_invoiceno != true || this.buyerubn != this.new_buyerubn_am || this.buyername != this.new_buyername_am) {
        let invoiceno_enable = '1';
        let action = `${config.mqtt_root}/set_invoiceno`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('user').token
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            keyset: 'mqtt',
            invoiceno_enable: encodeURIComponent(config.encrypt(`${invoiceno_enable}`, config.ffkey, config.ffiv)),
            invoiceno: encodeURIComponent(config.encrypt(`${this.new_buyerubn_am}`, config.ffkey, config.ffiv)),
            invoiceno_name: encodeURIComponent(config.encrypt(`${this.new_buyername_am}`, config.ffkey, config.ffiv)),
            op: 'add',
          })
        }).then(res => res.json()).then(result => {
          if(result.success) {
            this.auto_invoiceno = (invoiceno_enable == '1') ? true : false;
            this.buyerubn = this.new_buyerubn_am;
            this.buyername = this.new_buyername_am;
            this.showInvoiceNoModal = false;

            this.showSuccess({
              message: this.$t('device.invoice_modify_success', {buyerubn: this.buyerubn}),
            });
          } else {
            this.invoice_no_invalid = true;
            this.invoice_no_invalid_msg = result.message ? result.message : this.$t('device.error.invoice_modify_error', {buyerubn: this.buyerubn}); //TODO: i18n

            //this.showError({
            //  message: result.message ? result.message : this.$t('device.error.invoice_modify_error', {buyerubn: this.buyerubn}), //TODO: i18n
            //});
          }
        }).catch(error => {
          //console.info('set invoiceno error', error);
          this.invoice_no_invalid = true;
          this.invoice_no_invalid_msg = error; //TODO: i18n
          //this.showError(error); //TODO: i18n
        });
      } else {
        this.showInvoiceNoModal = false;
      }
    },

    InvoiceNoRemove() {
      let msg = '';
      msg = this.$t('device.delete_invoice', {buyerubn: this.buyerubn});
      if (window.confirm(msg)) {
        let invoiceno_enable = '0';
        this.new_buyerubn_am = '';
        this.new_buyername_am = '';
        let action = `${config.mqtt_root}/set_invoiceno`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('user').token
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            keyset: 'mqtt',
            invoiceno_enable: encodeURIComponent(config.encrypt(`${invoiceno_enable}`, config.ffkey, config.ffiv)),
            invoiceno: encodeURIComponent(config.encrypt(`${this.new_buyerubn_am}`, config.ffkey, config.ffiv)),
            invoiceno_name: encodeURIComponent(config.encrypt(`${this.new_buyername_am}`, config.ffkey, config.ffiv)),
            op: 'delete',
          })
        }).then(res => res.json()).then(result => {
          if(result.success) {
            this.showSuccess({
              message: this.$t('device.delete_invoice_success', {buyerubn: this.buyerubn}),
            });
            this.auto_invoiceno = false;
            this.buyerubn = this.new_buyerubn_am;
            this.buyername = this.new_buyername_am;
          } else {
            this.showError({
              message: result.message ? result.message : this.$t('device.error.delete_invoice_error', {buyerubn: this.buyerubn}), //TODO: i18n
            });
          }
        }).catch(error => {
          //console.info('set invoiceno error', error);
          this.showError(error); //TODO: i18n
        });
      }
    },

    onInvoiceCarrierInput(value) {
      this.new_invoice_carrier = (value || '').trim().toUpperCase();
    },

    popInvoiceCarrierModal() {
      this.new_invoice_carrier = this.invoice_carrier;
      this.invoice_carrier_invalid = false;
      this.invoice_carrier_invalid_msg = '';
      this.showInvoiceCarrierModal = true;
    }, // eo popInvoiceCarrierModal

    InvoiceCarrierAdd() {
      this.invoice_carrier_invalid = false;
      this.invoice_carrier_invalid_msg = '';

      if(invoice_carrier_check(this.new_invoice_carrier) === false) {
        this.$refs.new_invoice_carrier.focus();
        this.invoice_carrier_invalid = true;
        this.invoice_carrier_invalid_msg = this.$t('device.error.invoice_carrier_format_error');
        return;
      }

      let action = `${config.mqtt_root}/set_invoice_carrier`;
      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$state.$get('user').token
        },
        body: JSON.stringify({
          user_id: encodeURIComponent(this.$state.$get('user').uuid),
          keyset: 'mqtt',
          invoice_carrier: encodeURIComponent(config.encrypt(`${this.new_invoice_carrier}`, config.ffkey, config.ffiv)),
          op: 'add',
        })
      }).then(res => res.json()).then(result => {
        if(result.success) {
          this.invoice_carrier = this.new_invoice_carrier;
          this.showInvoiceCarrierModal = false;
          this.showSuccess({
            message: this.$t('device.invoice_carrier_add_success', {invoice_carrier: this.invoice_carrier}),
          });
        } else {
          this.invoice_carrier_invalid = true;
          this.invoice_carrier_invalid_msg = result.message ? result.message : this.$t('device.error.invoice_carrier_add_error', {invoice_carrier: this.new_invoice_carrier}); //TODO: i18n
        }
      }).catch(error => {
        //console.info('set invoiceno error', error);
        this.invoice_carrier_invalid = true;
        this.invoice_carrier_invalid_msg = error;//TODO: i18n
      });
    },

    InvoiceCarrierModify() {
      this.invoice_carrier_invalid = false;
      this.invoice_carrier_invalid_msg = '';

      if(invoice_carrier_check(this.new_invoice_carrier) === false) {
        this.$refs.new_invoice_carrier.focus();
        this.invoice_carrier_invalid = true;
        this.invoice_carrier_invalid_msg = this.$t('device.error.invoice_carrier_format_error');
        return;
      }

      if(this.invoice_carrier != this.new_invoice_carrier) {
        let action = `${config.mqtt_root}/set_invoice_carrier`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('user').token
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            keyset: 'mqtt',
            invoice_carrier: encodeURIComponent(config.encrypt(`${this.new_invoice_carrier}`, config.ffkey, config.ffiv)),
            op: 'add',
          })
        }).then(res => res.json()).then(result => {
          if(result.success) {
            this.invoice_carrier = this.new_invoice_carrier;
            this.showInvoiceCarrierModal = false;
            this.showSuccess({
              message: this.$t('device.invoice_carrier_modify_success', {invoice_carrier: this.invoice_carrier}),
            });
          } else {
            this.invoice_carrier_invalid = true;
            this.invoice_carrier_invalid_msg = result.message ? result.message : this.$t('device.error.invoice_carrier_modify_error', {invoice_carrier: this.new_invoice_carrier}); //TODO: i18n
          }
        }).catch(error => {
          //console.info('set invoiceno error', error);
          this.invoice_carrier_invalid = true;
          this.invoice_carrier_invalid_msg = error; //TODO: i18n
        });
      } else {
        this.showInvoiceCarrierModal = false;
      }
    },

    InvoiceCarrierRemove() {
      let msg = '';
      msg = this.$t('device.invoice_carrier_delete', {invoice_carrier: this.invoice_carrier});
      if (window.confirm(msg)) {
        this.new_invoice_carrier = '';
        let action = `${config.mqtt_root}/set_invoice_carrier`;
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.$state.$get('user').token
          },
          body: JSON.stringify({
            user_id: encodeURIComponent(this.$state.$get('user').uuid),
            keyset: 'mqtt',
            invoice_carrier: encodeURIComponent(config.encrypt(`${this.new_invoice_carrier}`, config.ffkey, config.ffiv)),
            op: 'delete',
          })
        }).then(res => res.json()).then(result => {
          if(result.success) {
            this.showSuccess({
              message: this.$t('device.invoice_carrier_delete_success', {invoice_carrier: this.invoice_carrier}),
            });

            this.invoice_carrier = this.new_invoice_carrier;
          } else {
            this.showError({
              message: result.message ? result.message : this.$t('device.error.invoice_carrier_delete_error', {invoice_carrier: this.invoice_carrier}), //TODO: i18n
            });
          }
        }).catch(error => {
          //console.info('set invoiceno error', error);
          this.showError(error); //TODO: i18n
        });
      }
    },

    popDatePickerModal() {
      this.showDatePickerModal = true;
      let now = moment().tz(config.timezone);
      this.scheduleMinDate = now.format("YYYY-MM-DD").toString();
      let min_date = moment(this.scheduleMinDate).tz(config.timezone);
      let date = null;

      //console.log('now:' , now.format("YYYY-MM-DD HH:mm:ss"), 'min_date:' , min_date.format("YYYY-MM-DD HH:mm:ss"));

      if(this.scheduleEditDate) {
        date = moment(this.scheduleEditDate).tz(config.timezone);
        //console.log('date:' , date.format("YYYY-MM-DD HH:mm:ss"));
        if(min_date > date) {
          date = min_date.add(1, 'day');
        }
        this.datePickerSelectedDate = date.format("YYYY-MM-DD");
      } else {
        date = min_date.add(1, 'day');
        this.datePickerSelectedDate = date.format("YYYY-MM-DD");
      }
      //console.log('datePickerSelectedDate:' , this.datePickerSelectedDate);
    },

    DatePickerConfirm(){
      if(this.datePickerSelectedDate) {
        this.scheduleEditDate = this.datePickerSelectedDate;
        this.scheduleEditSelectedWeeksClear();
      }
      this.DatePickerInputValue = this.scheduleEditDate ? this.getDateAndWeekInfo(this.scheduleEditDate) : this.getWeeklyInfo(this.scheduleEditWeekly);
      this.showDatePickerModal = false;
    },

    scheduleEditSelectedWeeksClear(){
      this.scheduleEditWeekly = 0;
      this.$set(this.scheduleEditSelectedWeeks, 1, false);
      this.$set(this.scheduleEditSelectedWeeks, 2, false);
      this.$set(this.scheduleEditSelectedWeeks, 3, false);
      this.$set(this.scheduleEditSelectedWeeks, 4, false);
      this.$set(this.scheduleEditSelectedWeeks, 5, false);
      this.$set(this.scheduleEditSelectedWeeks, 6, false);
      this.$set(this.scheduleEditSelectedWeeks, 7, false);
    },

    popScheduleEditModal(schedule) {
      this.showScheduleEditModal = true;
      this.scheduleEditProcessing = false;
      this.scheduleSelected = schedule;
      this.scheduleEditStartTime = '12:30'; //Add this to fixed time select not focus on middle.
      this.scheduleEditEndTime = '12:30'; //Add this to fixed time select not focus on middle.

      if(schedule) {
        this.scheduleEditTitle = this.$t('device.scheduleEditTitle_modify');
        if(schedule.date != null) {
          this.scheduleEditDate = moment(schedule.date).tz(config.timezone).format("YYYY-MM-DD");
          this.scheduleEditSelectedWeeksClear();
        } else {
          this.scheduleEditWeekly = schedule.weekly;
          this.scheduleEditDate = null;
          //console.log('scheduleEditWeekly:' , this.scheduleEditWeekly);
          this.$set(this.scheduleEditSelectedWeeks, 1, (this.scheduleEditWeekly & 64) > 0 ? true : false);
          this.$set(this.scheduleEditSelectedWeeks, 2, (this.scheduleEditWeekly & 32) > 0 ? true : false);
          this.$set(this.scheduleEditSelectedWeeks, 3, (this.scheduleEditWeekly & 16) > 0 ? true : false);
          this.$set(this.scheduleEditSelectedWeeks, 4, (this.scheduleEditWeekly & 8) > 0 ? true : false);
          this.$set(this.scheduleEditSelectedWeeks, 5, (this.scheduleEditWeekly & 4) > 0 ? true : false);
          this.$set(this.scheduleEditSelectedWeeks, 6, (this.scheduleEditWeekly & 2) > 0 ? true : false);
          this.$set(this.scheduleEditSelectedWeeks, 7, (this.scheduleEditWeekly & 1) > 0 ? true : false);
        }
        
        this.$nextTick(() => { //Add $nextTick to fixed time select not focus on middle.
          this.scheduleEditStartTime = schedule.start_time;
          this.scheduleEditEndTime = schedule.end_time;
        }); 
      } else {
        let date = moment().tz(config.timezone);
        date = date.add(1, 'day').format("YYYY-MM-DD");
        this.scheduleEditTitle = this.$t('device.scheduleEditTitle_add');
        this.scheduleEditDate = date;
        this.scheduleEditSelectedWeeksClear();

        this.$nextTick(() => { //Add $nextTick to fixed time select not focus on middle.
          this.scheduleEditStartTime = '00:00';
          this.scheduleEditEndTime = '00:00';
        });
      }
      this.DatePickerInputValue = this.scheduleEditDate ? this.getDateAndWeekInfo(this.scheduleEditDate) : this.getWeeklyInfo(this.scheduleEditWeekly);
    }, // eo popScheduleEditModal
    ScheduleEditCheck(date, start_time, end_time){
      let check_starttime = null;
      let check_endtime = null;
      let now_time = moment().tz(config.timezone);
      //console.log('now_time:' , now_time.format("YYYY-MM-DD HH:mm:ss"));

      //check start_time/end_time set rule.
      if(date) {
        check_starttime = moment(`${date} + " " + ${start_time}`, 'YYYY-MM-DD HH:mm').tz(config.timezone);
        check_endtime = moment(`${date} + " " + ${end_time}`, 'YYYY-MM-DD HH:mm').tz(config.timezone);
        
        if(now_time >= check_starttime) {
          //console.log('check_starttime:' , check_starttime.format("YYYY-MM-DD HH:mm:ss"));
          this.showError({message: this.$t('device.error.starttime_over_error')});
          return false;
        }
      } else {
        check_starttime = moment(`${start_time}`, 'HH:mm').tz(config.timezone);
        check_endtime = moment(`${end_time}`, 'HH:mm').tz(config.timezone);
      }

      //console.log('check_starttime:' , check_starttime.format("YYYY-MM-DD HH:mm:ss"), ', check_endtime:' , check_endtime.format("YYYY-MM-DD HH:mm:ss"));

      if(check_endtime <= check_starttime) {
        check_endtime = check_endtime.add(1, 'day');
      }

      let minutesDiff = check_endtime.diff(check_starttime, 'minutes');
      //console.log('minutesDiff:' , minutesDiff);

      if(minutesDiff < 5) {
        this.showError({message: this.$t('device.error.charging_time_5min_error')});
        return false;
      }
      return true;
    },
    isScheduleChange(target_schedule) {
      let result = false;
      if(target_schedule.date != this.scheduleEditDate) {
        result = true;
      }
      if(target_schedule.weekly != this.scheduleEditWeekly) {
        result = true;
      }
      if(target_schedule.start_time != this.scheduleEditStartTime) {
        result = true;
      }
      if(target_schedule.end_time != this.scheduleEditEndTime) {
        result = true;
      }
      if(target_schedule.enable != true) { 
        result = true;
      }
      return result;
    },
    ScheduleEditConfirm(){
      const app = this;
      let schedule_data = {};
      let params = {};
      let device_id = null;
      let device_sn = null;
      let do_schedule_set = false;
      let pre_message = '';
      if(this.ScheduleEditCheck(this.scheduleEditDate, this.scheduleEditStartTime, this.scheduleEditEndTime)){
        if(this.scheduleSelected) {
          //console.log('scheduleSelected: ', this.scheduleSelected);
          if(this.isScheduleChange(this.scheduleSelected)){ //if have any change, update it.
            //update selected schedule
            //console.log('Update selected schedule');
            this.scheduleEditProcessing = true;
            schedule_data = {
              weekly: this.scheduleEditWeekly,
              date: this.scheduleEditDate ? this.scheduleEditDate : 0,
              start_time: this.scheduleEditStartTime,
              end_time: this.scheduleEditEndTime,
              enable: true,
              updating_schedule_id: this.scheduleSelected.id,
            };

            schedule_data = encodeURIComponent(config.encrypt(JSON.stringify(schedule_data), config.ffkey, config.ffiv));
            do_schedule_set = true;
            pre_message = this.$t('device.pre_message_modify');
            device_id = encodeURIComponent(config.encrypt(`${this.scheduleSelected.device_id}`, config.ffkey, config.ffiv));     
          } else {
            this.showScheduleEditModal = false;
          }
        } else { //create new schedule
          //console.log('Create new schedule');
          schedule_data = {
            weekly: this.scheduleEditWeekly,
            date: this.scheduleEditDate ? this.scheduleEditDate : 0,
            start_time: this.scheduleEditStartTime,
            end_time: this.scheduleEditEndTime,
            enable: true,
          };
          schedule_data = encodeURIComponent(config.encrypt(JSON.stringify(schedule_data), config.ffkey, config.ffiv));
          do_schedule_set = true;
          pre_message = this.$t('device.pre_message_add');
          device_sn = encodeURIComponent(app.uuid);
        }

        params = {
          user_id: encodeURIComponent(this.$state.$get('user').uuid),
          schedule_data
        }

        if(device_id) {
          params.device_id = device_id;
        } else {
          params.device_sn = device_sn;
        }

        if(do_schedule_set) {
          this.scheduleEditProcessing = true;
          let action = `${config.mqtt_root}/schedule_set`;
          fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$state.$get('user').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            this.scheduleEditProcessing = false;
            if(result.success) {

              if(this.scheduleSelected) {
                this.scheduleSelected.date = this.scheduleEditDate;
                this.scheduleSelected.weekly = this.scheduleEditWeekly;
                this.scheduleSelected.start_time = this.scheduleEditStartTime;
                this.scheduleSelected.end_time = this.scheduleEditEndTime;
                this.IgnoreSchedulesRefresh();
                this.scheduleSelected.enable = true;
              }
              
              this.showSuccess({
                message: `${pre_message}` + this.$t('device.success'),
              });
              this.showScheduleEditModal = false;
            } else {
              this.showError({
                message: `${pre_message}` + this.$t('device.fail') + '，' + result.message ? result.message : this.$t('device.error.system_error'), //TODO: i18n
              });
            }
          }).catch(error => {
            //console.info('set invoiceno error', error);
            this.scheduleEditProcessing = false;
            this.showError({
              message: `${pre_message}` + this.$t('device.fail') + '，' + error, //TODO: i18n
            });
          });
        }
      }
    },
    ScheduleEnableSwitch(schedule) {
      const app = this;
      let device_id = null;
      let need_update = false;
      let enable = false;
      let pre_message = '';
      if(schedule) {
        //console.log(schedule.name, ' value:' , schedule.enable);
        //console.log(schedule.name, ' schedule:' , schedule);
        this.IgnoreSchedulesRefresh();
        enable = !schedule.enable;
        if(schedule.enable === false) { //switch to ON
          //console.log(schedule.name, ' schedule.date:' , schedule.date);
          //check enable rule.
          if(this.ScheduleEditCheck(schedule.date, schedule.start_time, schedule.end_time)){
            need_update = true;
            pre_message = this.$t('device.pre_message_enable');
          } else {
            //switch ON fail, disable enable
            this.$nextTick(() => {
              schedule.enable = false;
            });
          }
        } else { //switch to OFF
          need_update = true;
          pre_message = this.$t('device.pre_message_disable');
        } 

        if(need_update) {//update schedule enable
          let schedule_data = {
            weekly: schedule.weekly,
            date: schedule.date ? schedule.date : 0,
            start_time: schedule.start_time,
            end_time: schedule.end_time,
            enable,
            updating_schedule_id: schedule.id,
          };
          schedule_data = encodeURIComponent(config.encrypt(JSON.stringify(schedule_data), config.ffkey, config.ffiv));

          let action = `${config.mqtt_root}/schedule_set`;
          fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$state.$get('user').token
            },
            body: JSON.stringify({
              user_id: encodeURIComponent(this.$state.$get('user').uuid),
              device_id: encodeURIComponent(config.encrypt(`${schedule.device_id}`, config.ffkey, config.ffiv)),
              schedule_data
            })
          }).then(res => res.json()).then(result => {
            if(result.success) {
              this.showSuccess({
                message: `${pre_message}` + this.$t('device.success'),
              });
            } else {
              //if switch update fail, restore enable
              this.$nextTick(() => {
                schedule.enable = !enable;
              });
              this.showError({
                message: `${pre_message}`+ this.$t('device.fail') + '，' + result.message ? result.message : this.$t('device.error.system_error'), //TODO: i18n
              });
            }
          }).catch(error => {
            this.$nextTick(() => {
              schedule.enable = !enable;
            });
            //console.info('set invoiceno error', error);
            this.showError({
              message: `${pre_message}`+ this.$t('device.fail') + '，' + error, //TODO: i18n
            });
          });
        }
      }
    }, // eo popRfidChargeModal
    ScheduleRemove(schedule) {
      let msg = '';
      if(schedule) {
        msg = this.$t('device.delete_schedule');
        if (window.confirm(msg)) {
          let remove_data = {
            remove_schedule_id: schedule.id,
          };
          remove_data = encodeURIComponent(config.encrypt(JSON.stringify(remove_data), config.ffkey, config.ffiv));

          //console.log(schedule.name, ' schedule:' , schedule);
          let action = `${config.mqtt_root}/schedule_remove`;
          fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$state.$get('user').token
            },
            body: JSON.stringify({
              user_id: encodeURIComponent(this.$state.$get('user').uuid),
              remove_data
            })
          }).then(res => res.json()).then(result => {
            if(result.success) {
              this.showSuccess({
                message:  this.$t('device.delete_schedule_success'),
              });
            } else {
              this.showError({
                message: this.$t('device.error.delete_schedule_error') + '，' + result.message ? result.message : this.$t('device.error.system_error'), //TODO: i18n
              });
            }
          }).catch(error => {
            //console.info('set invoiceno error', error);
            this.showError({
              message: this.$t('device.error.delete_schedule_error') + '，' + error, //TODO: i18n
            });
          });
        }
      }
    }, // eo popRfidChargeModal
    IgnoreSchedulesRefresh(){
      this.ignore_schedules_refresh = true;
      setTimeout(() => {
        this.ignore_schedules_refresh = false;
      }, 5000);
    }
  }, //eo methods
};
</script>

<style>
.breadcrumb{display: none;}
.pt-3, .py-3 { padding-top: 0.35rem !important; }
#qrcode-window { max-height: 400px; margin: auto; display: block; max-width: 100%;}
#qrcode-window video { max-width: 100%; }
#qrcode-video { max-width: 100%; }
.app{
  background: black;
}
.title-text {
  font-size: clamp(1rem, 8vw, 3rem); /* 最小 1.2rem，最大 3rem，平常 6% 螢幕寬度 */
  font-weight: bold;
  color: white;
}
.charging-limit-warning {
  color: #ffc107;
  font-size: clamp(1rem, 4vw, 1.3rem);
  font-weight: bold;
  text-align: center;
  padding: 0.1rem 0.8rem;
  line-height: 1.4;
  word-break: break-word;
}
.support_text {
  font-size: clamp(1rem, 4vw, 1.3rem);
  font-weight: bold;
  text-align: center;
  padding: 0.1rem 0.8rem;
  line-height: 1.4;
  word-break: break-word;
}
.schedule_time_text {
  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: bold;
  word-break: break-word;
}
/* 電池 icon 的容器（內容置中） */
.battery-wrapper {
  width: 100%;
  height: auto;          /* 高度跟內容自動一致 */
  display: flex;
  justify-content: center;
  align-items: center;
  /*margin-top: -1.2rem;
  margin-bottom: -1rem;*/
}
.battery-icon {
  font-size: 20rem;
  display: block;
  color: white;
  line-height: 1;   /* 取消多餘上下空白 */
  /*transform: scaleX(1.4); 壓扁 */
}
.battery-icon-charging {
  font-size: 20rem;
  display: block;
  color: white;
  line-height: 1;   /* 取消多餘上下空白 */
  /*transform: scaleX(1.4); 壓扁 */
  -moz-animation:myfirst 5s infinite; /* Firefox */
  -webkit-animation:myfirst 5s infinite; /* Safari and Chrome */
}
.battery-shape {
  width: 100%;
  max-width: 600px;
  height: 130px;
  border: 10px solid white;
  border-radius: 20px;
  box-sizing: border-box;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.battery-shape-charging {
  width: 100%;
  max-width: 600px;
  height: 130px;
  border: 10px solid white;
  border-radius: 20px;
  box-sizing: border-box;
  -moz-animation:myfirst 5s infinite; /* Firefox */
  -webkit-animation:myfirst 5s infinite; /* Safari and Chrome */
  animation: myfirst 5s infinite;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
/* 中間顯示文字（80%） */
.battery-text {
  position: absolute;
  font-size: clamp(1.2rem, 6vw, 3rem); /* 例如 6% 的螢幕寬度 */
  font-weight: bold;
  color: white;
  pointer-events: none;
}
.status-li-no-padding-left{
	color: white;
	font-weight: bold;
	font-size: 1.5rem;
}
.status-li{
	color: white; margin: 0.2rem 0; 
	font-weight: bold;
	font-size: 1.5rem;
	padding-left: 1rem;
}
.grecaptcha-badge{
	display: none !important;
}
.li-icon {
  padding: 0;
  margin: 0;
  width: 10%;
  max-width: 24px;
  display: flex;
  justify-content: center;
}
.li-icon img {
  width: clamp(16px, 6vw, 24px);
  margin-top: 0.15rem;
}
.li-text {
	width: 90%;
  font-size: clamp(1rem, 4vw, 1.3rem);
}
.auto-text {
  width: 90%;
  font-size: min(4.0vw, 1.5rem) !important;
}
.main-body{
	max-width: 450px;
	margin: auto;
}
.top-up-btn{
  height: 4rem;
  max-width: 98%;
  min-width: 98%;
  font-size: min(5.0vw, 1.5rem) !important;
  margin: 0.5px 0px;
}
.top-up-btn-sm{
  height: 3rem;
  max-width: 98%;
  min-width: 98%;
  font-size: min(5.0vw, 1.5rem) !important;
  margin: 0.5px 0px;
}
.select-payment-btn{
  height: 3.5rem;
  max-width: 98%;
  min-width: 98%;
  font-size: min(5.0vw, 1rem) !important;
  white-space: normal; /* 預設是 nowrap，改成 normal 允許換行 */
  word-break: break-word; /* 遇到太長的文字也可換行 */
  text-align: center;
}
.select-payment-btn-left{
  height: 3.5rem;
  max-width: 98%;
  min-width: 98%;
  font-size: min(5.0vw, 1rem) !important;
  white-space: normal; /* 預設是 nowrap，改成 normal 允許換行 */
  word-break: break-word; /* 遇到太長的文字也可換行 */
  text-align: left;
}
.select-payment-img{
  display: inline-block;   /* inline 也可以，但 inline-block 更安全 */
  width: 2rem;
  height: 2rem;
  vertical-align: middle;  /* 與文字垂直置中 */
  margin-right: 0.5rem;    /* 文字與圖示間隔 */
}
.fixed-leading{
  display: inline-block;
  width: 1.3rem;
  text-align: center;
}
.lame-btn {
  border: none !important;
  background-color: transparent !important;
}
.lg-icon-btn {
  font-size: min(7.0vw, 2.1rem) !important;
}
.custom-b-button {
  max-width: 100%;
  min-width: 100%;
}
.custom-padding {
  padding: 0px;
}
.custom-table th,
.custom-table td {
  text-align: center;
  vertical-align: middle;
  padding: 1px;
}
.custom-table-for-week th,
.custom-table-for-week td {
  text-align: center;
  vertical-align: middle;
  padding: 1px;
}
.device-clickable-text {
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  color: black !important;
}
.device-clickable-text.clicked {
  background-color: #007bff;
  color: white !important;
}
.custom-space {
  min-width: 100px;
  padding: 0 10px;
}
.custom_input_prepend{
	width: 100px !important;
	text-align: left;
	font-size: 1.5rem;
}
.hidden-div {
  display: none;
}
#toggle-button:checked + .hidden-div {
  display:block;
}
.hidden-div2 {
  display: none;
}
#toggle-button2:checked + .hidden-div2 {
  display:block;
}
.hidden-div3 {
  display: block;
}
#toggle-button3:checked + .hidden-div3 {
  display:none;
}
.hidden-div4 {
  display: block;
}
#toggle-button4:checked + .hidden-div4 {
  display:none;
}
#btnApplePay{
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: buy;
  -apple-pay-button-style: white;
  height: 3.5rem;
  width: 100%;
}
.apple-pay-amount {
  padding-top: .65rem;
  font-size: 1.2rem;
}
.action-btn-container {
  padding: 0 !important;
}
.attention-effect {
  animation: pulse 1.8s infinite;
  transition: transform 0.1s;
}
@keyframes pulse {
  0% { transform: scale(1);}
  50% { transform: scale(1.05);}
  100% { transform: scale(1);}
}
@media screen and (max-width: 480px) {
  .battery-shape {
    width: 100%;
    height: 90px;
    border-width: 8px;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .battery-shape-charging {
    width: 100%;
    height: 90px;
    border-width: 8px;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .battery-icon {
    font-size: 66vw;
  }
  .battery-icon-charging {
    font-size: 66vw;
  }
  .card-header {
    padding: .75rem .2rem;
  }
}
@-moz-keyframes myfirst /* Firefox */ {
  0% {border-color:blue;}
  50% {border-color:yellow;}
  100% {border-color:white;}
}

@-webkit-keyframes myfirst /* Safari and Chrome */ {
  0% {border-color:blue;}
  50% {border-color:yellow;}
  100% {border-color:white;}
}
@supports (-webkit-appearance: -apple-pay-button) {
 .apple-pay-button {
 display: inline-block;
 -webkit-appearance: -apple-pay-button;
 }
 .apple-pay-button-white {
   -apple-pay-button-style: white;
 }
}
@supports not (-webkit-appearance: -apple-pay-button) {
 .apple-pay-button {
 display: inline-block;
 background-size: 100% 60%;
 background-repeat: no-repeat;
 background-position: 50% 50%;
 border-radius: 5px;
 padding: 0px;
 box-sizing: border-box;
 min-width: 200px;
 min-height: 32px;
 max-height: 64px;
 }
 .apple-pay-button-white {
   background-image: -webkit-named-image(apple-pay-logo-black);
   background-color: white;
 }
}
</style>

<style src="spinkit/scss/spinkit.scss" lang="scss" />